const API_BASE='https://script.google.com/macros/s/AKfycbz_ATMqfdlPD6S1a3t14MFUKF5d-Tiwano44bjbFw_bkrGaQw4WXOLHgqbDrdrREqwp/exec';
const STATUS_API='https://script.google.com/macros/s/AKfycbyQYx9-APhFwKLtj9kVuE2Dt5uYOSjtG1DDkUqx99VpNYUyEBXoJehydbGi1cVk_ljO/exec';
const STATUS_TOKEN='9K2USdRzQlPoeswT6VROeWgi7sPMlWs8LheJqoFcbc';

const CARDPOS_BASE = (()=>{
  const q = new URLSearchParams(location.search).get('cardpos_base');
  if(q) return q.replace(/\/$/, '');
  const host = location.hostname || '';
  if(location.protocol === 'file:') return 'https://buylist.kaitori-torekanobankoku.com';
  if(host.includes('torekanobankoku.com') && !host.includes('buylist.kaitori-torekanobankoku.com')) return 'https://buylist.kaitori-torekanobankoku.com';
  return location.origin;
})();
const CARDPOS_BOOTSTRAP_URL=()=>`${CARDPOS_BASE}/api/sheet/bootstrap?hide_empty=0${isAdminView()?'&include_unpublished=1':''}`;
// 郵送買取は別ページへ飛ばさず、この買取表ページ内で切り替え表示する。

const PRINT_SHOW_THUMB=true;
const ALLOWED_CONDS=['美品','白かけ','折れ','凹み','汚れ','初期キズ','キズあり','PSA10美品','PSA10キズあり'];
const AUTOSCROLL_ON_LOAD=false;

const POSTAL_BUY_TWEET_LINES=[
  '📦 郵送買取を開始しました！ぜひご利用ください。',
  '買取ページからお申し込みいただけます。',
  '⚠️一部タイトルは現在準備中のため、未対応となっております。',
  '対応タイトルは順次拡大予定です！'
];

// 投稿用画像のダウンロード処理がすべて終わってから呼び出す。
// about:blank 等の中継ページは作成しない。元のツイート文面も加工しない。
function openOriginalTweetOnX(tweetText){
  const url = 'https://x.com/intent/tweet?text=' + encodeURIComponent(String(tweetText || ''));
  const tab = window.open(url, '_blank');
  if(tab){
    try{tab.opener = null;}catch(_){ }
    const oldNotice = document.getElementById('torekanobankoku-x-open-fallback');
    if(oldNotice) oldNotice.remove();
    return true;
  }
  // 非同期の画像生成に時間がかかるとブラウザ側がポップアップをブロックする場合がある。
  // このときだけ手動で開けるリンクを元のページに表示する。
  let notice = document.getElementById('torekanobankoku-x-open-fallback');
  if(!notice){
    notice = document.createElement('div');
    notice.id = 'torekanobankoku-x-open-fallback';
    notice.style.cssText = 'position:fixed;bottom:22px;right:22px;z-index:2147483646;background:#fff;color:#111;border:1px solid #ddd;border-radius:12px;padding:12px 16px;box-shadow:0 6px 26px rgba(0,0,0,.22);font:14px/1.5 sans-serif;max-width:380px;';
    const title = document.createElement('div');
    title.textContent = '画像のダウンロードが完了しました。Xの自動起動がブロックされました。';
    const link = document.createElement('a');
    link.textContent = 'Xの投稿画面を開く';
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.style.cssText = 'display:block;margin-top:6px;color:#1767bf;text-decoration:underline;';
    const close = document.createElement('button');
    close.textContent = '閉じる';
    close.style.cssText = 'display:block;margin-top:8px;padding:4px 10px;cursor:pointer;';
    close.addEventListener('click', ()=>notice.remove());
    notice.append(title, link, close);
    document.body.appendChild(notice);
  }
  notice.querySelector('a').href = url;
  return false;
}

const RARITY_ORDER={
  OP:['SEC★★★','SEC★★','SEC★','SEC','SP','L★','SR★★','SR★','SR','R★','R','UC','C','L','PR','DON'],
  UA:['SR★★★','SR★★','SR★','R★','U★','C★','PcSR★★★','PcSR★★','PcSR★','PcR★★','PcR★','PcC★','AP','PcSR','PcR','PcC','SR','R','U','C','PR'],
  XROSS:['LRPP','LRP','SRP','SR','R','UC','C','TR','LR','PR'],
  GUNDAM:['LR++','LR+','R+','U+','C++','C+','LR','R','U','C'],
  ULTRA:['UR','SSSP','SP','AP','EXP','RRRR','RRR','RR','R','U','C'],
  QUINT:['SSSP','SSP','SP','GR','RR+','R+','U+','C+','RR','R','U','C'],
  FB:['SR★★','R★★','SCR★★','SCR★','SCR','L★','SR★','R★','UC★','C★','PR★','SR','R','UC','C','L','PR','エナジーマーカー（パラレル）','エナジーマーカー'],
  DIGI:['SEC★★','SEC★','SEC','SP','SR★','R★','U★','C★','SR','R','U','C','PR'],
  NIKKE:['SPL','SPR','UR','SR','L','R','C'],
  // 名探偵コナンカードゲーム：SRP が正。SPR は使わない。
  CONAN:['SRP','SR','R','C','CP','PR','SEC','SP','P'],
  LORCANA:['エンチャンテッド','レジェンダリー','スーパーレア','レア','アンコモン','コモン'],
  FE:['SR+','R+X','N+X','+X','R+','HR','SR','R','HN','N','PR'],
  pokekavs:['SEC','MRP','MRCP','SRP','SRCP','RP','CP','MR','SR','R','C','D','PR'],
  DEFAULT:['SSP','SEC','UR','LR','GGR','GR','SP','SSR','SR','RRR','RR','R','L','UC','U','C','AP','HN','N','PR','DON','EXP'],
  baboka:['極','秘','頂P','SP','頂','S','RP','R','NP','N','DP','D','P'],
  sangoku:['CTR','TMR','PT','SR','R','UC','C'],
  sengoku:['CTR','傾奇','TR','PT','PR']
};

function isConanGameId(gameId){
  const id = String(gameId || window.currentDropdownId || '');
  const game = findBootstrapGame(id);
  const text = [
    id,
    game?.name,
    game?.game_name,
    game?.title,
    game?.label,
    game?.game_key,
    game?.id
  ].map(v=>String(v||'')).join(' ');
  return /conan|名探偵|コナン/i.test(text);
}

function currentBrandKey(){
  const id=window.currentDropdownId||'';
  if(isConanGameId(id))return'CONAN';
  if(id==='onepiece-dropdown')return'OP';
  if(id==='dejimon-dropdown')return'DIGI';
  if(id==='UA-dropdown')return'UA';
  if(id==='ultraman-dropdown')return'ULTRA';
  if(id==='gotoubunbright-dropdown')return'QUINT';
  if(id==='nikee-dropdown')return'NIKKE';
  if(id==='pokeka-dropdown')return'OP';
  if(id==='doragonboru-dropdown')return'FB';
  if(id==='gundam-dropdown')return'GUNDAM';
  if(id==='Xross-dropdown')return'XROSS';
  if(id==='FE-dropdown')return'FE';
  if(id==='haikyo-dropdown')return'baboka';
  if(id==='pokekavs-dropdown')return'pokekavs';
  if(id==='sangoku-dropdown')return'sangoku';
  return'DEFAULT';
}

function splitRarityOrderValue(v){
  // CardPOS 側の「レアリティ順（カンマ区切り）」をそのまま利用できるようにする
  // 対応形式：
  // 1) ['SEC','MRCP',...]
  // 2) 'SEC,MRCP,MRP,SRP,...'
  if(Array.isArray(v)){
    return v.map(x=>String(x||'').trim()).filter(Boolean);
  }
  return String(v||'')
    .split(/[,\n\r\t，、]+/)
    .map(x=>String(x||'').trim())
    .filter(Boolean);
}

function findBootstrapGame(gameId){
  const id = String(gameId || window.currentDropdownId || '');
  const list = Array.isArray(window._bootstrapGames) ? window._bootstrapGames : [];
  return list.find(g =>
    String(g?.id || '') === id ||
    String(g?.game_key || '') === id ||
    String(g?.dropdown_id || '') === id
  ) || {};
}

function getServerRarityOrder(gameId){
  const game = findBootstrapGame(gameId);
  const raw =
    game.rarity_order ??
    game.rarityOrder ??
    game.rarities ??
    game.rarity_list ??
    game.rarityList ??
    '';
  return splitRarityOrderValue(raw);
}

function getFallbackRarityOrderByGame(gameId){
  const prev = window.currentDropdownId;
  window.currentDropdownId = gameId || prev || '';
  const key = currentBrandKey();
  window.currentDropdownId = prev;
  return (RARITY_ORDER[key] || RARITY_ORDER.DEFAULT || []).slice();
}

function getRarityOrderForGame(gameId){
  // ✅ 最优先：CardPOS 后台每个游戏设置的稀有度顺序
  // ✅ 兜底：旧版 HTML 内置 RARITY_ORDER
  const fromServer = getServerRarityOrder(gameId);
  const order = fromServer.length ? fromServer : getFallbackRarityOrderByGame(gameId);

  let cleaned = order.map(x=>String(x||'').trim()).filter(Boolean);

  // ✅ コナン専用：后台設定やAPIに SPR が混ざっていても、前端では SRP として扱う
  // NIKKE など他タイトルの正しい SPR には影響させない。
  if(isConanGameId(gameId)){
    cleaned = cleaned.map(x => normalizeRarityForCompare(x) === 'SPR' ? 'SRP' : x);
    if(!cleaned.some(x => normalizeRarityForCompare(x) === 'SRP')) cleaned.unshift('SRP');
    const seen = new Set();
    cleaned = cleaned.filter(x => {
      const k = normalizeRarityForCompare(x);
      if(seen.has(k)) return false;
      seen.add(k);
      return true;
    });
  }

  if(!cleaned.some(x=>x === 'その他')) cleaned.push('その他');
  return cleaned;
}

function escapeRegExp(s){
  return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
}

function normalizeRarityForCompare(s){
  return String(s||'')
    .trim()
    .toUpperCase()
    .replace(/\s+/g,'')
    .replace(/[☆＊*]/g,'★')
    .replace(/[‐-‒–—―ー－]/g,'-');
}

function makeRarityDetectRegex(rarity){
  // 英字・数字の短いレアリティ（C/R/SR/CP2等）がカード名や型番の一部に誤爆しないように、
  // 前後は区切り文字か行頭/行末だけ許可する
  const escaped = escapeRegExp(String(rarity||'').toUpperCase());
  return new RegExp(`(^|[\\s　【】\\[\\]（）()／/,:：｜|])${escaped}($|[\\s　【】\\[\\]（）()／/,:：｜|])`);
}

function detectRarityFromNameByOrder(name, order){
  const s = String(name || '').toUpperCase();
  const sorted = [...(order || [])]
    .filter(r => r && r !== 'その他')
    // SRP / SRCP / MRCP 这种必须比 SR / CP / R 先识别
    .sort((a,b)=>String(b).length-String(a).length);

  for(const cand of sorted){
    const re = makeRarityDetectRegex(cand);
    if(re.test(s)) return cand;
  }
  return '';
}

function rarityIndexInOrder(rarity, order){
  const target = normalizeRarityForCompare(rarity);
  return (order || []).findIndex(x => normalizeRarityForCompare(x) === target);
}

function getItemRarityRaw(item){
  return String(
    item?.rarity ??
    item?.rare ??
    item?.rarityName ??
    item?.rarity_name ??
    item?.rarityLabel ??
    item?.rarity_label ??
    item?.rareName ??
    item?.rare_name ??
    item?.productRarity ??
    item?.product_rarity ??
    item?.cardRarity ??
    item?.card_rarity ??
    ''
  ).trim();
}

function isConanCardLike(name,item,gameId){
  if(isConanGameId(gameId)) return true;

  const game = findBootstrapGame(gameId || window.currentDropdownId || '');
  const source = [
    gameId,
    game?.name,
    game?.game_name,
    game?.game_key,
    game?.id,
    name,
    item?.gameId,
    item?.game_id,
    item?.gameName,
    item?.game_name,
    item?.title,
    item?.category,
    item?.collection,
    item?.packName,
    item?.pack_name,
    item?.pack,
    item?.setName,
    item?.set_name,
    item?.cardNumber,
    item?.card_number,
    item?.cardNo,
    item?.card_no,
    item?.number,
    item?.code
  ].map(v=>String(v||'')).join(' ');

  return /conan|名探偵|コナン|ID\[[A-Z0-9]+\]|\bCT[-_\s]?[PD]\d*\b|\bCT[PD]\d+\b|CTP\d+|CTD\d+/i.test(source);
}

function detectConanSrpFix(name,item,gameId){
  if(!isConanCardLike(name,item,gameId)) return '';

  const text = [name, item?.productName, item?.name, item?.title, item?.cardName, item?.card_name].map(v=>String(v||'')).join(' ').toUpperCase();
  const raw = getItemRarityRaw(item);

  // 名探偵コナンカードゲームには SRP が存在する。
  // API/后台側で誤って SPR と返ってきた場合は、表示・検索・発推すべて SRP に統一する。
  if(makeRarityDetectRegex('SRP').test(text)) return 'SRP';
  if(normalizeRarityForCompare(raw) === 'SPR') return 'SRP';

  return '';
}

function parseRarity(name,item,gameId){
  const id = gameId || item?.gameId || window.currentDropdownId || '';
  const order = getRarityOrderForGame(id);

  // 先从名称中检测一次。这样 SRP / MRCP / CP2 不会被 SR / CP 抢先吃掉。
  const detected = detectRarityFromNameByOrder(name, order);
  const conanSrpFix = detectConanSrpFix(name, item, id);
  if(conanSrpFix) return conanSrpFix;

  // CardPOS / API 如果返回 rarity，正常情况下仍然尊重它；
  // 但如果返回了 SR，而卡名中明确写着 SRP / SRCP 这种更具体的稀有度，则以前端检测结果修正。
  const raw = getItemRarityRaw(item);
  if(raw){
    const hit = order.find(r => normalizeRarityForCompare(r) === normalizeRarityForCompare(raw)) || raw;
    if(detected){
      const hitNorm = normalizeRarityForCompare(hit);
      const detNorm = normalizeRarityForCompare(detected);
      const hitIdx = rarityIndexInOrder(hit, order);
      const detIdx = rarityIndexInOrder(detected, order);

      // 例：API が SR、カード名が SRP の場合は SRP を採用
      const detectedIsMoreSpecific = detNorm.includes(hitNorm) && detNorm.length > hitNorm.length;
      const detectedIsHigherOrder = hitIdx >= 0 && detIdx >= 0 && detIdx < hitIdx && detNorm.length >= hitNorm.length;
      if(hitNorm !== detNorm && (detectedIsMoreSpecific || detectedIsHigherOrder)){
        return detected;
      }
    }
    return hit;
  }

  return detected || 'その他';
}

const GUARANTEE_IMAGE_MAP={
  'onepiece-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'dejimon-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'UA-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'ultraman-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'pokekasm-dropdown':'https://i.postimg.cc/Yq4qWBBX/pokeka-sm.jpg',
  'doragonboru-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'gotoubunbright-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'gundam-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'Xross-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'pokekavs-dropdown':'https://i.postimg.cc/g29jCFWw/Gemini-Generated-Image-sdva1esdva1esdva.png',
  'FE-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'haikyo-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'nikee-dropdown':'https://t3.ftcdn.net/jpg/15/27/57/44/360_F_1527574462_sDi9gHVwqtT4PYC5Ud6PHkRpYVZGBHwx.jpg',
  'sangoku-dropdown':'https://i.postimg.cc/7Zr2QfjS/sanguomaiqubaozheng.jpg'
};

function getGameGuaranteeImageUrl(game){
  if(!game) return '';
  const fromServer = game.guarantee_image_url || game.guaranteeImageUrl || game.guaranteeImageURL || '';
  if(String(fromServer||'').trim()) return String(fromServer).trim();
  return GUARANTEE_IMAGE_MAP[game.id] || GUARANTEE_IMAGE_MAP[game.game_key] || '';
}


function getPackImageUrl(pack){
  if(!pack || typeof pack !== 'object') return '';
  const candidates = [
    pack.image,
    pack.image_url,
    pack.imageUrl,
    pack.pack_image,
    pack.packImage,
    pack.pack_image_url,
    pack.packImageUrl,
    pack.productImageUrl,
    pack.product_image_url,
    pack.thumbnail,
    pack.thumbnail_url,
    pack.thumbnailUrl,
    pack.thumb,
    pack.thumb_url,
    pack.thumbUrl,
    pack.hero_image,
    pack.heroImage,
    pack.hero_image_url,
    pack.heroImageUrl,
    pack.cover,
    pack.cover_image,
    pack.coverImage,
    pack.image_src,
    pack.imageSrc,
    pack.artwork,
    pack.artwork_url,
    pack.artworkUrl
  ];
  for(const v of candidates){
    if(v !== undefined && v !== null){
      const s = String(v).trim();
      if(s) return s;
    }
  }
  return '';
}

const $=sel=>document.querySelector(sel);
const IMAGE_PROXY_BASE = 'https://flat-fire-5577.bankokutcg.workers.dev/?url=';

// 既に画像プロキシを通したURLを再度プロキシ化しない。
// 旧版の自定义買取表にはプロキシ済みURLがlocalStorageへ保存されているため、
// 二重プロキシになるとhtml2canvas上で商品画像が白くなる。
function unwrapProxyImageUrl(u){
  let s = String(u || '').trim();
  for(let i=0; i<3 && s.startsWith(IMAGE_PROXY_BASE); i++){
    try{
      const inner = new URL(s).searchParams.get('url');
      if(!inner || inner === s) break;
      s = inner;
    }catch(_){ break; }
  }
  return s;
}
function getProxyImageUrl(u){
  if(!u) return '';
  const original = String(u).trim();
  const s = unwrapProxyImageUrl(original);
  if(/^data:image\//i.test(s) || /^blob:/i.test(s) || /^file:/i.test(s) || /^https:\/\/cdn\.shopify\.com\//i.test(s)) return s;
  // 既に正しい単一プロキシURLなら、そのまま再利用する。
  if(original.startsWith(IMAGE_PROXY_BASE) && unwrapProxyImageUrl(original) === s){
    return `${IMAGE_PROXY_BASE}${encodeURIComponent(s)}`;
  }
  return `${IMAGE_PROXY_BASE}${encodeURIComponent(s)}`;
}
function isMobileLayout(){
  try{
    return (window.matchMedia && window.matchMedia('(max-width: 749px)').matches) ||
      Math.min(window.innerWidth || 9999, document.documentElement?.clientWidth || 9999) <= 749;
  }catch(_){return false;}
}
function isAdminView(){
  // v18: 手机端只作为顾客浏览用。即使 URL 带 admin=1，也不渲染管理员/見積/发推相关UI。
  return new URLSearchParams(location.search).get('admin')==='1' && !isMobileLayout();
}
function triggerFade(el){el.classList.remove('show');void el.offsetWidth;el.classList.add('show')}
function money(n){return'¥'+(Number(n)||0).toLocaleString()}
function getPsa10BuyPrice(item){
  return Number(item?.psa10BuyPrice ?? item?.psa10_buy_price ?? item?.psa10Price ?? item?.psa10_price ?? 0) || 0;
}
function isPsa10BuyEnabled(item){
  const raw = item?.psa10BuyEnabled ?? item?.psa10_buy_enabled ?? item?.psa10_enabled ?? false;
  return raw === true || raw === 1 || raw === '1' || String(raw).toLowerCase() === 'true';
}
function hasPublicBuyPrice(item){
  const normal = readMoneyNumber(
    item?.productPrice ?? item?.buyPrice ?? item?.buy_price ?? item?.price ?? item?.normalPrice ?? 0
  );
  const psa10 = getPsa10BuyPrice(item);
  return normal > 0 || (isPsa10BuyEnabled(item) && psa10 > 0);
}
function appendBuyPriceBlock(card,p){
  const normal = Number(p?.price ?? p?.productPrice ?? p?.buy_price ?? 0) || 0;
  const psa10 = getPsa10BuyPrice(p);
  const psaOn = isPsa10BuyEnabled(p);

  // 一鍵発推 / 画像生成でも同じ価格を使えるよう、表示DOMに価格を保持する
  card.dataset.normalPrice = String(normal || 0);
  card.dataset.psa10Price = String(psa10 || 0);
  card.dataset.psa10Enabled = psaOn ? '1' : '0';

  const stack = document.createElement('div');
  stack.className = 'price-stack';
  let count = 0;
  if(normal > 0){
    const normalEl = document.createElement('div');
    normalEl.className = 'price-tag normal-price-tag';
    normalEl.textContent = money(normal);
    stack.appendChild(normalEl);
    count++;
  }
  if(psaOn && psa10 > 0){
    const psaEl = document.createElement('div');
    psaEl.className = 'price-tag psa10-price-tag';
    psaEl.innerHTML = `<span class="price-mini-label">PSA10</span>${money(psa10)}`;
    stack.appendChild(psaEl);
    count++;
  }
  if(!count){
    const none = document.createElement('div');
    none.className = 'price-unset';
    none.textContent = '価格未設定';
    stack.appendChild(none);
  }
  card.appendChild(stack);
}

function readMoneyNumber(v){
  if(typeof v === 'number') return Number.isFinite(v) ? v : 0;
  const n = Number(String(v ?? '').replace(/[^0-9.-]/g, ''));
  return Number.isFinite(n) ? n : 0;
}
function formatBuyPriceText(normal, psa10, psaOn){
  const parts = [];
  const n = readMoneyNumber(normal);
  const p = readMoneyNumber(psa10);
  const on = psaOn === true || psaOn === 1 || psaOn === '1' || String(psaOn).toLowerCase() === 'true';
  if(n > 0) parts.push(money(n));
  if(on && p > 0) parts.push(`PSA10 ${money(p)}`);
  return parts.length ? parts.join(' / ') : '価格未設定';
}
function getProductCardPriceText(card){
  const normal = readMoneyNumber(card?.dataset?.normalPrice);
  const psa10 = readMoneyNumber(card?.dataset?.psa10Price);
  const psaOn = card?.dataset?.psa10Enabled === '1';
  if(normal > 0 || (psaOn && psa10 > 0)) return formatBuyPriceText(normal, psa10, psaOn);

  const normalText = card?.querySelector?.('.normal-price-tag')?.innerText || '';
  const psaText = card?.querySelector?.('.psa10-price-tag')?.innerText || '';
  const fallback = [normalText, psaText].map(x=>String(x||'').trim()).filter(Boolean).join(' / ');
  return fallback || '価格未設定';
}
function formatBuyPriceTextFromItem(item){
  const normal = Number(item?.price ?? item?.productPrice ?? item?.buy_price ?? 0) || 0;
  const psa10 = getPsa10BuyPrice(item);
  const psaOn = isPsa10BuyEnabled(item);
  return formatBuyPriceText(normal, psa10, psaOn);
}

function escapeHtml(s){
  return String(s??'').replace(/[&<>"']/g, ch => ({
    '&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'
  }[ch]));
}

function veilFlash(doWork){
  const v=document.getElementById('swap-veil');
  const release=()=>{try{v?.classList?.remove('on')}catch(_){}};
  if(!v){
    try{doWork?.();}catch(err){console.error('veilFlash work failed:', err);}
    return;
  }
  v.classList.add('on');
  // Safety valve: an exception during rendering must never leave a fixed veil
  // over the page. That was one of the causes of tablet/PC scroll lock.
  const watchdog=setTimeout(release, 900);
  requestAnimationFrame(()=>{
    try{
      doWork?.();
    }catch(err){
      console.error('veilFlash work failed:', err);
    }finally{
      requestAnimationFrame(()=>{
        clearTimeout(watchdog);
        setTimeout(release,120);
      });
    }
  });
}
function smoothSwap(target,renderFn){
  const el=(typeof target==='string')?document.querySelector(target):target;
  if(!el){
    try{renderFn?.();}catch(err){console.error('smoothSwap render failed:', err);}
    return;
  }
  el.classList.remove('swap-in');
  el.classList.add('swap-out');
  requestAnimationFrame(()=>{
    try{
      renderFn?.();
    }catch(err){
      console.error('smoothSwap render failed:', err);
    }finally{
      el.classList.remove('swap-out');
      void el.offsetWidth;
      el.classList.add('swap-in');
    }
  });
}

const _QS=new URLSearchParams(location.search);
const ENABLE_SEARCH=_QS.get('search')==='1'||_QS.get('s')==='1';
const QS_SORT=(_QS.get('sort')||'').toLowerCase();
const QS_GAME=_QS.get('game')||'';
const QS_PACK=_QS.get('pack')||'';

async function postJSON(url,data){
  const res=await fetch(url,{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify(data),mode:'cors',credentials:'omit'});
  const text=await res.text();
  if(!res.ok)throw new Error(text||`HTTP ${res.status}`);
  try{return JSON.parse(text)}catch(_){throw new Error('Server returned non-JSON: '+text)}
}

function getUpdatedFromResponse(j){
  const pick=v=>(v!==undefined&&v!==null&&String(v).trim()!=='')?v:undefined;
  const dig=(obj,path)=>{try{return path.split('.').reduce((o,k)=>(o&&k in o)?o[k]:undefined,obj)}catch(_){return undefined}};
  const cand=[pick(j?.C2),pick(j?.c2),pick(j?.updatedC2),pick(j?.lastUpdatedC2),pick(j?.lastUpdatedDateC2),pick(dig(j,'meta.C2')),pick(dig(j,'meta.updatedC2')),pick(dig(j,'info.C2')),pick(dig(j,'sheet.updatedC2')),pick(j?.lastUpdatedDate),pick(j?.updated)];
  return cand.find(v=>v!==undefined)??null;
}

window.currentDropdownId=null;
window.currentSheetTitle='';
window.isProductListReady=false;

let _cardposBootstrapPromise = null;

async function loadCardposBootstrap(force=false){
  if(force || !_cardposBootstrapPromise){
    _cardposBootstrapPromise = fetch(CARDPOS_BOOTSTRAP_URL(), { cache:'no-store' })
      .then(async r=>{
        const t = await r.text();
        let data;
        try { data = JSON.parse(t); }
        catch (_) { throw new Error('bootstrap non-json: ' + t.slice(0,160)); }
        const remoteGames = Array.isArray(data?.games) ? data.games : [];
        window._bootstrapGames = remoteGames.map(g=>(Object.assign({}, g, {
          id: String(g?.game_key || g?.id || g?.dropdown_id || ''),
          name: String(g?.name || g?.title || g?.label || g?.game_key || '')
        })));
        return data;
      });
  }
  return _cardposBootstrapPromise;
}

function mergeSystemPacksIntoGame(game, remoteGame){
  const staticPacks = Array.isArray(game?.packs) ? game.packs : [];
  const staticByName = new Map(staticPacks.map(p=>[String(p?.name||''), p]));
  const remotePacks = Array.isArray(remoteGame?.packs) ? remoteGame.packs : [];
  if(!remotePacks.length) return staticPacks;

  const merged = remotePacks.map(p=>{
    const prev = staticByName.get(String(p?.name||'')) || {};
    return {
      ...prev,
      ...p,
      name: p?.name || prev.name || '',
      image: getPackImageUrl(p) || getPackImageUrl(prev) || '',
      releaseDate: p?.releaseDate || p?.release_date || prev.releaseDate || '',
      buylistPublishAt: p?.buylist_publish_at || p?.buylistPublishAt || prev.buylistPublishAt || '',
      isPublicNow: !!(p?.is_public_now ?? p?.isPublicNow ?? prev.isPublicNow),
      apiUrl: p?.api_url || p?.gas_compat_url || prev.apiUrl || '',
      visibleCount: Number(p?.visible_count ?? p?.visibleCount ?? 0),
      updated: p?.updated || prev.updated || '',
      created_at: p?.created_at || prev.created_at || ''
    };
  });

  game.packs = merged;
  game._packsLoadedFromSystem = true;
  return merged;
}

async function ensureDynamicGamePacks(game, force=false){
  if(!game) return [];
  if(game._packsLoadedFromSystem && !force && Array.isArray(game.packs) && game.packs.length) return game.packs;
  try{
    const data = await loadCardposBootstrap(force);
    const remoteGames = Array.isArray(data?.games) ? data.games : [];
    const remoteGame = remoteGames.find(g =>
      String(g?.game_key||'') === String(game.id||'') ||
      String(g?.name||'') === String(game.name||'')
    );
    if(remoteGame){
      return mergeSystemPacksIntoGame(game, remoteGame);
    }
  }catch(err){
    console.warn('CardPOS bootstrap load failed:', err);
  }
  return Array.isArray(game.packs) ? game.packs : [];
}

const GAME_ORDER_HINT = [
  'onepiece-dropdown','dejimon-dropdown','UA-dropdown','ultraman-dropdown',
  'gotoubunbright-dropdown','nikee-dropdown','pokekasm-dropdown','pokekavs-dropdown',
  'doragonboru-dropdown','gundam-dropdown','Xross-dropdown','FE-dropdown',
  'sangoku-dropdown','sengoku-dropdown','haikyo-dropdown','kiseki-dropdown'
];

const games = [];
const sheetMap = {};

function sortGamesByHint(list){
  const idx = new Map(GAME_ORDER_HINT.map((v,i)=>[String(v), i]));
  return [...(list||[])].sort((a,b)=>{
    const ai = idx.has(String(a?.id||'')) ? idx.get(String(a?.id||'')) : 999;
    const bi = idx.has(String(b?.id||'')) ? idx.get(String(b?.id||'')) : 999;
    if(ai !== bi) return ai - bi;
    return String(a?.name||'').localeCompare(String(b?.name||''), 'ja');
  });
}

async function hydrateGamesFromSystem(force=false){
  const data = await loadCardposBootstrap(force);
  const remoteGames = Array.isArray(data?.games) ? data.games : [];
  const normalized = remoteGames.map(g=>({
    id: String(g?.game_key || g?.id || ''),
    name: String(g?.name || g?.game_name || g?.id || ''),
    guarantee_image_url: String(g?.guarantee_image_url || g?.guaranteeImageUrl || ''),
    guaranteeImageUrl: String(g?.guarantee_image_url || g?.guaranteeImageUrl || ''),
    packs: Array.isArray(g?.packs) ? g.packs.map(p=>({
      ...p,
      name: p?.name || '',
      image: getPackImageUrl(p) || '',
      releaseDate: p?.releaseDate || p?.release_date || '',
      buylistPublishAt: p?.buylist_publish_at || p?.buylistPublishAt || '',
      isPublicNow: !!(p?.is_public_now ?? p?.isPublicNow),
      apiUrl: p?.api_url || p?.gas_compat_url || '',
      visibleCount: Number(p?.visible_count ?? p?.visibleCount ?? 0),
      updated: p?.updated || '',
      created_at: p?.created_at || ''
    })) : [],
    _packsLoadedFromSystem: true
  })).filter(g=>g.id && g.name);

  games.splice(0, games.length, ...sortGamesByHint(normalized));

  Object.keys(sheetMap).forEach(k=>delete sheetMap[k]);
  for(const g of games){
    sheetMap[g.id] = `${CARDPOS_BASE}/exec/${encodeURIComponent(g.id)}`;
  }
  return games;
}

const GAME_CARD_BACK_IMAGE_MAP = {
  // 各ゲームのカード背面画像（このHTML内に埋め込み済み）
  'onepiece-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_01_1fa8f5a2d6.png?v=1780644190',
  'dejimon-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_02_1d79534a80.png?v=1780644190',
  'UA-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_03_55253154ca.png?v=1780644190',
  'ultraman-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_04_bbccbe993d.png?v=1780644190',
  'gotoubunbright-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_05_14d04b022e.png?v=1780644190',
  'nikee-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_06_4d11351e33.png?v=1780644190',
  'pokekasm-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_07_3cf047d43a.png?v=1780644190',
  'pokeka-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_07_3cf047d43a.png?v=1780644190',
  'pokekavs-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_07_3cf047d43a.png?v=1780644190',
  'doragonboru-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_08_b4f92a4049.png?v=1780644190',
  'gundam-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_09_3099192334.png?v=1780644190',
  'Xross-dropdown': '',
  'FE-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_10_98211bee6c.png?v=1780644190',
  'sangoku-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_11_16999c94f2.png?v=1780644190',
  'sengoku-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_12_2cbfcf996f.png?v=1780644190',
  'haikyo-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_13_8a74f8735f.png?v=1780644190',
  'kiseki-dropdown': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_14_39e0eaeecb.png?v=1780644190',
  // name-based aliases / fallbacks
  'pokemon': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_07_3cf047d43a.png?v=1780644190',
  'digimon': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_02_1d79534a80.png?v=1780644190',
  'onepiece': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_01_1fa8f5a2d6.png?v=1780644190',
  'unionarena': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_03_55253154ca.png?v=1780644190',
  'dragonball': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_08_b4f92a4049.png?v=1780644190',
  'conan': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_15_b370d75278.png?v=1780644190',
  'nivelarena': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_06_4d11351e33.png?v=1780644190',
  'gotoubun': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_05_14d04b022e.png?v=1780644190',
  'ultraman': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_04_bbccbe993d.png?v=1780644190',
  'gundam': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_09_3099192334.png?v=1780644190',
  'fireemblem': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_10_98211bee6c.png?v=1780644190',
  'sangoku': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_11_16999c94f2.png?v=1780644190',
  'sengoku': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_12_2cbfcf996f.png?v=1780644190',
  'haikyu': 'https://cdn.shopify.com/s/files/1/0663/8085/7504/files/cardback_13_8a74f8735f.png?v=1780644190'
};

function makeSvgDataUrl(svg){
  return 'data:image/svg+xml;charset=UTF-8,' + encodeURIComponent(svg);
}

function makeGameCardBackPlaceholder(name){
  const safe = String(name || 'CARD GAME').replace(/[&<>"']/g, m => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[m]));
  return makeSvgDataUrl(`
    <svg xmlns="http://www.w3.org/2000/svg" width="630" height="880" viewBox="0 0 630 880">
      <defs>
        <linearGradient id="bg" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="#0f172a"/>
          <stop offset="50%" stop-color="#1d4ed8"/>
          <stop offset="100%" stop-color="#0f766e"/>
        </linearGradient>
        <linearGradient id="line" x1="0" y1="0" x2="1" y2="1">
          <stop offset="0%" stop-color="rgba(255,255,255,.75)"/>
          <stop offset="100%" stop-color="rgba(255,255,255,.12)"/>
        </linearGradient>
      </defs>
      <rect width="630" height="880" rx="42" fill="url(#bg)"/>
      <rect x="24" y="24" width="582" height="832" rx="32" fill="none" stroke="rgba(255,255,255,.22)" stroke-width="3"/>
      <circle cx="315" cy="290" r="148" fill="none" stroke="rgba(255,255,255,.30)" stroke-width="18"/>
      <circle cx="315" cy="290" r="92" fill="none" stroke="rgba(255,255,255,.16)" stroke-width="16"/>
      <path d="M110 642C196 558 433 558 520 642" fill="none" stroke="rgba(255,255,255,.26)" stroke-width="16" stroke-linecap="round"/>
      <path d="M150 698H480" fill="none" stroke="rgba(255,255,255,.18)" stroke-width="8" stroke-linecap="round"/>
      <rect x="100" y="565" width="430" height="190" rx="28" fill="rgba(255,255,255,.08)" stroke="rgba(255,255,255,.18)" stroke-width="2"/>
      <text x="315" y="620" text-anchor="middle" font-size="28" font-weight="700" fill="rgba(255,255,255,.86)" font-family="Arial, Helvetica, sans-serif">CARD BACK STYLE</text>
      <text x="315" y="680" text-anchor="middle" font-size="34" font-weight="800" fill="#ffffff" font-family="Arial, Helvetica, sans-serif">${safe}</text>
      <text x="315" y="744" text-anchor="middle" font-size="20" font-weight="600" fill="rgba(255,255,255,.70)" font-family="Arial, Helvetica, sans-serif">BUYLIST SELECTOR</text>
    </svg>
  `);
}

function getGameCardBackAlias(game){
  const text = [
    game?.id,
    game?.name,
    game?.game_name,
    game?.title,
    game?.label,
    game?.game_key
  ].map(v=>String(v||'')).join(' ');
  if(/ポケモン|pokemon|pokeka/i.test(text)) return 'pokemon';
  if(/デジモン|digimon/i.test(text)) return 'digimon';
  if(/ワンピース|one\s*piece/i.test(text)) return 'onepiece';
  if(/ユニオンアリーナ|union\s*arena/i.test(text)) return 'unionarena';
  if(/ドラゴンボール|dragon\s*ball|fusion\s*world|フュージョンワールド/i.test(text)) return 'dragonball';
  if(/コナン|名探偵|detective\s*conan/i.test(text)) return 'conan';
  if(/ニベル|nivel\s*arena|nivelarena/i.test(text)) return 'nivelarena';
  if(/五等分|gotoubun/i.test(text)) return 'gotoubun';
  if(/ウルトラマン|ultraman/i.test(text)) return 'ultraman';
  if(/ガンダム|gundam/i.test(text)) return 'gundam';
  if(/ファイアーエムブレム|サイファ|fire\s*emblem/i.test(text)) return 'fireemblem';
  if(/三国志大戦|sangoku/i.test(text)) return 'sangoku';
  if(/戦国大戦|sengoku/i.test(text)) return 'sengoku';
  if(/ハイキュー|バボカ|haikyu/i.test(text)) return 'haikyu';
  return '';
}

function getGameCardBackImage(game){
  if(!game) return makeGameCardBackPlaceholder('CARD GAME');
  const direct = [
    game.card_back_image_url,
    game.cardBackImageUrl,
    game.back_image_url,
    game.backImageUrl,
    game.card_back_url,
    game.cardBackUrl
  ].find(v => v !== undefined && v !== null && String(v).trim() !== '');
  if(direct) return String(direct).trim();

  const idKey = String(game.id || '').trim();
  const idMapped = GAME_CARD_BACK_IMAGE_MAP[idKey];
  if(idMapped) return String(idMapped).trim();

  const alias = getGameCardBackAlias(game);
  const aliasMapped = alias ? GAME_CARD_BACK_IMAGE_MAP[alias] : '';
  if(aliasMapped) return String(aliasMapped).trim();

  return makeGameCardBackPlaceholder(game.name || game.id || 'CARD GAME');
}

const tweetHashtagMap = {
  'onepiece-dropdown': 'ワンピースカードゲーム',
  'dejimon-dropdown': 'デジモンカードゲーム',
  'UA-dropdown': 'ユニオンアリーナ',
  'gotoubunbright-dropdown': '五等分の花嫁カードゲーム',
  'ultraman-dropdown': 'ウルトラマンカードゲーム',
  'pokeka-dropdown': 'ポケモンカード',
  'doragonboru-dropdown': 'ドラゴンボールフュージョンワールド',
  'FE-dropdown': 'TCGファイアーエムブレム０（サイファ）',
  'gundam-dropdown': 'ガンダムカードゲーム',
  'Xross-dropdown': 'Xross stars（クロスターズ）',
  'haikyo-dropdown': 'バボカBREAK',
  'pokekavs-dropdown': 'ポケモンカード',
  'kiseki-dropdown': '軌跡TCG',
};

const _gameSearchCache=new Map();
let _activeSearchCtrl=null;
let _activeSearchGameId=null;

function normalizeQ(s){
  return String(s||'').toLowerCase().replace(/\s+/g,'').replace(/[‐-‒–—―ー－]/g,'-').replace(/[【】\[\]（）\(\)『』「」]/g,'');
}
function normalizeRarityKey(s){
  return String(s||'').toUpperCase().replace(/\s+/g,'').replace(/[☆*]/g,'★').replace(/[‐-‒–—―ー－]/g,'-');
}
function parseSearchInput(raw,gameId){
  const parts=String(raw||'').trim().split(/\s+/).filter(Boolean);
  const nameParts=[];
  let rarity='';

  const order = getGameRarityOrder(gameId).slice();
  if(!order.includes('その他')) order.push('その他');
  const raritySet=new Set(order.map(r=>normalizeRarityKey(r)));

  for(const token of parts){
    const m=token.match(/^(r|rarity|レア|稀有度)[:：](.+)$/i);
    if(m&&m[2]){rarity=m[2];continue}
    if(!rarity&&raritySet.has(normalizeRarityKey(token))){rarity=token;continue}
    nameParts.push(token);
  }
  return {nameQuery:nameParts.join(' '),rarityQuery:rarity};
}

function rarityMatch(itemRarity, queryRarity){
  const qRaw = String(queryRarity || '').trim();
  if(!qRaw) return true;

  const isWildcard = qRaw.endsWith('*');
  const q = normalizeRarityKey(isWildcard ? qRaw.slice(0, -1) : qRaw);
  if(!q) return true;

  const r = normalizeRarityKey(itemRarity);

  if(!isWildcard){
    return r === q;
  }

  return r === q || r.startsWith(q);
}

function cancelActiveSearch(){
  try{_activeSearchCtrl?.abort()}catch(_){}
  _activeSearchCtrl=null;_activeSearchGameId=null;
}
function isPackPublicNow(pack){
  const raw=String(pack?.buylistPublishAt || pack?.buylist_publish_at || '').trim();
  if(!raw) return true;
  const d=new Date(raw.replace(' ','T'));
  if(Number.isNaN(d.getTime())) return true;
  return d <= new Date();
}
function getAvailablePacksForGame(game){
  const now=new Date();
  return (game?.packs||[]).filter(p=>{
    const released = (!p.releaseDate || new Date(p.releaseDate)<=now);
    const published = isAdminView() ? true : isPackPublicNow(p);
    return released && published;
  });
}
async function mapWithConcurrency(list,limit,worker){
  const ret=[],executing=[];
  for(const item of list){
    const p=Promise.resolve().then(()=>worker(item));
    ret.push(p);
    const e=p.finally(()=>{const i=executing.indexOf(e);if(i>=0)executing.splice(i,1)});
    executing.push(e);
    if(executing.length>=limit)await Promise.race(executing);
  }
  return Promise.all(ret);
}
async function fetchPackProductsForSearch(gameId,packName,signal){
  const base=sheetMap[gameId];
  if(!base)return[];
  const admin = isAdminView();
  const qs=new URLSearchParams({sheet:packName,exact:'1',hide_zero:admin?'0':'1'});
  if(admin) qs.set('include_unpublished','1');
  const res=await fetch(`${base}?${qs.toString()}`,{signal});
  const text=await res.text();
  let json; try{json=JSON.parse(text)}catch(e){throw new Error(`Non-JSON (${packName}): ${text.slice(0,120)}`)}
  const items=json.products||json.data||[];
  const prev=window.currentDropdownId;
  window.currentDropdownId=gameId;
  const out=(items||[]).map(it=>{
    const name=String(it.productName??it.name??'').trim();
    if(!name)return null;
    const price=Number(it.productPrice??it.price??0);
    const img=it.productImageUrl||'';
    const rarity=parseRarity(name,it,gameId);
    const psa10Price = getPsa10BuyPrice(it);
    const psa10Enabled = isPsa10BuyEnabled(it);
    return {name,price,img,rarity,packName,gameId,psa10Price,psa10BuyPrice:psa10Price,psa10Enabled,psa10BuyEnabled:psa10Enabled};
  }).filter(Boolean).filter(item=>admin || hasPublicBuyPrice(item));
  window.currentDropdownId=prev;
  return out;
}
async function ensureGameSearchCache(game,onProgress){
  const gameId=game.id;
  const packs=getAvailablePacksForGame(game).map(p=>p.name);

  if(!_gameSearchCache.has(gameId)){
    _gameSearchCache.set(gameId,{
      promise:null,
      products:[],
      totalPacks:packs.length,
      ready:false,
    });
  }

  const cache=_gameSearchCache.get(gameId);

  if(cache.ready) return cache;
  if(cache.promise) return cache;

  cancelActiveSearch();
  _activeSearchCtrl=new AbortController();
  _activeSearchGameId=gameId;
  const signal=_activeSearchCtrl.signal;

  cache.products=[];
  cache.totalPacks=packs.length;
  cache.ready=false;

  let done=0;

  cache.promise=(async()=>{
    try{
      await mapWithConcurrency(packs,4,async(packName)=>{
        if(signal.aborted) throw new DOMException('Aborted','AbortError');
        try{
          const arr=await fetchPackProductsForSearch(gameId,packName,signal);
          cache.products.push(...arr);
        }finally{
          done++;
          onProgress?.({done,total:packs.length,packName,count:cache.products.length});
        }
      });

      cache.ready=true;
      return cache;
    }finally{
      cache.promise=null;
    }
  })().catch(err=>{
    if(err?.name==='AbortError') return cache;
    throw err;
  });

  await cache.promise;
  return cache;
}

function getGameRarityOrder(gameId){
  return getRarityOrderForGame(gameId);
}

function setRarityInInput(input,gameId,rarity){
  const raw=input.value||'';
  const {nameQuery,rarityQuery}=parseSearchInput(raw,gameId);
  const cur=normalizeRarityKey(rarityQuery);
  const next=normalizeRarityKey(rarity);
  const newR=cur===next?'':rarity;
  const v=[String(nameQuery||'').trim(), newR?`r:${rarity}`:''].filter(Boolean).join(' ').trim();
  input.value=v;
}
function updateRarityButtonActive(bar,gameId,inputValue){
  const {rarityQuery}=parseSearchInput(inputValue||'',gameId);
  const cur=normalizeRarityKey(rarityQuery);
  bar.querySelectorAll('.rarity-btn').forEach(b=>{
    b.classList.toggle('active', normalizeRarityKey(b.dataset.r||'')===cur && !!cur);
  });
}

const DESKTOP_TAB_LABELS = {
  'ultraman-dropdown': { lines:['ウルトラマンカード'], nowrap:true },
  'doragonboru-dropdown': { lines:['ドラゴンボール','フュージョンワールド'], nowrap:false },
  'gundam-dropdown': { lines:['ガンダムカード'], nowrap:false },
  'Xross-dropdown': { lines:['Xross Stars','（クロスターズ）'], nowrap:false },

  // ✅ 宝可梦两行固定显示
  'pokekasm-dropdown': { lines:['ポケモンカード','（SMシリーズ~現行）'], nowrap:false },
  'pokekavs-dropdown': { lines:['ポケモンカード','（VSシリーズ~XYシリーズ）'], nowrap:false }
};

function getDesktopTabLabel(game){
  const cfg=DESKTOP_TAB_LABELS[game?.id];
  if(!cfg){
    return { html:'', text:String(game?.name||''), nowrap:false };
  }
  const lines=(cfg.lines||[]).map(x=>String(x||'')).filter(Boolean);
  if(lines.length<=1){
    return { html:'', text:lines[0]||String(game?.name||''), nowrap:!!cfg.nowrap };
  }
  const html=lines.map(l=>`<span class="tab-line">${escapeHtml(l)}</span>`).join('');
  return { html, text:'', nowrap:false };
}

function updateGameTabsUI(activeGameId){
  document.querySelectorAll('.game-seg-btn, .kaitori-title-button, .kaitori-side-title-btn').forEach(b=>{
    b.classList.toggle('active', b.dataset.id===activeGameId);
    b.classList.toggle('is-active', b.dataset.id===activeGameId);
  });
  const sel=document.getElementById('game-dd-select');
  if(sel && activeGameId) sel.value=activeGameId;
}

function gameHasPublicPackForNav(g){
  const packs = Array.isArray(g?.packs) ? g.packs : [];
  const now = new Date();
  return packs.some(p=>{
    const released = (!p.releaseDate || new Date(p.releaseDate) <= now);
    const published = isPackPublicNow(p);
    const visible = Number(p?.visibleCount || p?.visible_count || 0) > 0;
    return released && published && visible;
  });
}

function renderKaitoriSideNav(activeGameId){
  const nav = document.getElementById('kaitori-side-nav');
  if(!nav) return;
  const list = Array.isArray(games) ? games : [];
  if(!list.length){
    nav.classList.remove('is-visible');
    document.body.classList.remove('kaitori-side-nav-active');
    nav.innerHTML = '';
    return;
  }

  const readyGames = [];
  const comingGames = [];
  list.forEach(g=>{
    (gameHasPublicPackForNav(g) ? readyGames : comingGames).push(g);
  });

  const renderBtn = (g, ready)=>{
    const img = getProxyImageUrl(getGameCardBackImage(g));
    const safeName = escapeHtml(g.name || '');
    return `
      <button type="button" class="kaitori-side-title-btn ${ready ? '' : 'is-coming'}" data-id="${escapeHtml(g.id || '')}" title="${safeName}">
        <img class="kaitori-side-title-btn__img" src="${img}" alt="${safeName}" loading="lazy">
        <span class="kaitori-side-title-btn__name">${safeName}</span>
        <span class="kaitori-side-title-btn__badge ${ready ? '' : 'is-coming'}">${ready ? '受付中' : '準備中'}</span>
      </button>
    `;
  };

  nav.innerHTML = `
    <div class="kaitori-side-nav__head">
      <div class="kaitori-side-nav__title">タイトル一覧<span class="kaitori-side-nav__sub">他タイトルの買取表へ移動</span></div>
      <button type="button" class="kaitori-side-nav__back">タイトル一覧</button>
    </div>
    <div class="kaitori-side-nav__group">
      <div class="kaitori-side-nav__group-title"><span>受付中</span><span class="kaitori-side-nav__count">${readyGames.length}</span></div>
      <div class="kaitori-side-nav__list">${readyGames.map(g=>renderBtn(g,true)).join('')}</div>
    </div>
    ${comingGames.length ? `
    <div class="kaitori-side-nav__group">
      <div class="kaitori-side-nav__group-title"><span>準備中</span><span class="kaitori-side-nav__count">${comingGames.length}</span></div>
      <div class="kaitori-side-nav__list">${comingGames.map(g=>renderBtn(g,false)).join('')}</div>
    </div>` : ''}
  `;

  nav.classList.add('is-visible');
  document.body.classList.add('kaitori-side-nav-active');
  nav.querySelector('.kaitori-side-nav__back')?.addEventListener('click', showKaitoriTitleSelector);
  nav.querySelectorAll('.kaitori-side-title-btn').forEach(btn=>{
    btn.addEventListener('click', ()=>{
      const game = list.find(g=>String(g.id) === String(btn.dataset.id));
      if(game) handleGameSelect(game);
    });
  });
  updateGameTabsUI(activeGameId || window.currentDropdownId || '');
}

function hideKaitoriSideNav(){
  const nav = document.getElementById('kaitori-side-nav');
  if(nav){
    nav.classList.remove('is-visible');
    document.body.classList.remove('kaitori-side-nav-active');
    nav.innerHTML = '';
  }
}

function hideKaitoriTitleSelector(){
  const tabs = document.getElementById('game-tabs');
  if(tabs){
    tabs.classList.remove('show');
    tabs.style.display = 'none';
  }
}

function showKaitoriTitleSelector(){
  cancelActiveSearch();
  hideKaitoriSideNav();
  const tabs = document.getElementById('game-tabs');
  const landing = document.getElementById('game-landing');
  const packEl = document.getElementById('pack-buttons');
  const sheet = document.getElementById('sheet-container');
  const status = document.getElementById('buy-status');

  if(tabs){
    tabs.style.display = 'block';
    tabs.classList.add('show');
  }
  if(landing){ landing.innerHTML = ''; landing.classList.remove('show'); landing.style.display = 'none'; }
  if(packEl){ packEl.innerHTML = ''; packEl.classList.remove('show'); packEl.style.display = 'none'; }
  if(sheet){ sheet.innerHTML = ''; }
  if(status){ status.innerHTML = ''; status.classList.remove('show'); }

  window.currentSheetTitle = '';
  const t = document.getElementById('tweet-btn');
  if(t) t.style.display = 'none';
  const heading = document.getElementById('heading-text');
  if(heading) heading.innerText = 'タイトルの買取表を選んでください';
  const update = document.getElementById('update-time');
  if(update) update.innerText = '';

  try{
    tabs?.scrollIntoView({behavior:'smooth', block:'start'});
  }catch(_){
    if(tabs) window.scrollTo(0, tabs.offsetTop || 0);
  }
}

async function handleGameSelect(game){
  cancelActiveSearch();
  const packEl = document.getElementById('pack-buttons');
  const landing = document.getElementById('game-landing');
  const sheet = document.getElementById('sheet-container');

  if(window.currentDropdownId === game.id && window.currentSheetTitle){
    window.currentSheetTitle = '';
    try{ await ensureDynamicGamePacks(game); }catch(_){ }
    if(packEl){ packEl.classList.remove('is-pack-list-hidden'); packEl.style.display = 'block'; packEl.classList.add('show'); }
    if(landing){ landing.style.display = 'block'; landing.classList.add('show'); }
    if(sheet){ sheet.innerHTML = ''; }
    const t = document.getElementById('tweet-btn');
    if(t) t.style.display = 'none';
    document.getElementById('heading-text').innerText = game.name + '：パックを選択してください';
    document.getElementById('update-time').innerText = '';
    hideKaitoriTitleSelector();
    renderKaitoriSideNav(game.id);
    veilFlash(()=>{
      smoothSwap('#game-landing', ()=>renderGameLanding(game));
      smoothSwap('#pack-buttons', ()=>renderPackButtons(game));
    });
    return;
  }

  if(packEl){
    packEl.classList.remove('is-pack-list-hidden');
    packEl.classList.remove('show');
    packEl.style.display = 'block';
    packEl.innerHTML = `<div class="loading-wrapper"><span>CardPOSからパック一覧を取得中</span><div class="loading-dots"><span></span><span></span><span></span></div></div>`;
  }
  if(landing){ landing.style.display = 'block'; landing.classList.remove('show'); }
  if(sheet){ sheet.innerHTML = ''; }
  const t = document.getElementById('tweet-btn');
  if(t) t.style.display = 'none';
  document.getElementById('heading-text').innerText = game.name + '：パックを選択してください';
  document.getElementById('update-time').innerText = '';
  window.currentDropdownId = game.id;
  window.currentSheetTitle = '';
  updateGameTabsUI(game.id);
  hideStatusBoard();
  hideKaitoriTitleSelector();
  renderKaitoriSideNav(game.id);
  try{ await ensureDynamicGamePacks(game); }catch(err){ console.warn('failed to sync packs from CardPOS:', err); }
  veilFlash(()=>{
    smoothSwap('#game-landing', ()=>renderGameLanding(game));
    smoothSwap('#pack-buttons', ()=>renderPackButtons(game));
    smoothSwap('#sheet-container', ()=>{ document.getElementById('sheet-container').innerHTML=''; });
  });
}

function applyAdaptiveGameTitleSizing(scope=document){
  const names = Array.from(scope.querySelectorAll('#game-tabs .kaitori-title-name'));
  names.forEach((el)=>{
    el.classList.remove('is-long','is-xlong');
    const raw = (el.textContent || '').trim();
    const compactLen = raw.replace(/\s+/g,'').length;

    // 先按字符长度做预判，再按实际溢出做二次收缩
    if(compactLen >= 12){
      el.classList.add('is-long');
    }
    if(compactLen >= 17){
      el.classList.add('is-xlong');
    }

    if(el.scrollHeight > el.clientHeight + 2){
      el.classList.add('is-long');
    }
    if(el.scrollHeight > el.clientHeight + 2){
      el.classList.add('is-xlong');
    }
  });
}

async function renderGameTabs(){
  try{
    await hydrateGamesFromSystem();
  }catch(err){
    console.warn('hydrateGamesFromSystem failed:', err);
  }

  const ct = $('#game-tabs');
  ct.innerHTML = '';

  const list = (games || []);
  const card = document.createElement('section');
  card.className = 'kaitori-title-select-card kaitori-title-select-card--catalog';
  card.setAttribute('aria-label', '買取表タイトル選択');

  card.innerHTML = `
    <div class="kaitori-title-select-body kaitori-title-select-body--catalog">
      <div class="buyback-notice buyback-notice-title" role="note">
        当日買取可能なタイトルは、予告なく停止となる場合がございます。あらかじめご了承ください。
      </div>
      <div class="kaitori-title-group">
        <div class="kaitori-title-group__head">
          <h3 class="kaitori-title-group__title is-ready">受付中タイトル</h3>
          <p class="kaitori-title-group__desc">現在公開中の買取表です</p>
        </div>
        <div class="kaitori-title-grid" id="kaitori-title-grid-ready"></div>
      </div>
      <div class="kaitori-title-group kaitori-title-group--coming" id="kaitori-title-group-coming" hidden>
        <div class="kaitori-title-group__head">
          <h3 class="kaitori-title-group__title is-coming">準備中タイトル</h3>
          <p class="kaitori-title-group__desc">公開前・準備中のタイトルです</p>
        </div>
        <div class="kaitori-title-grid kaitori-title-grid--coming" id="kaitori-title-grid-coming"></div>
      </div>
    </div>
  `;

  const gridReady = card.querySelector('#kaitori-title-grid-ready');
  const gridComing = card.querySelector('#kaitori-title-grid-coming');
  const comingGroup = card.querySelector('#kaitori-title-group-coming');

  if(!list.length){
    gridReady.innerHTML = '<div class="empty-system-hint" style="grid-column:1/-1;padding:18px;color:#cbd5e1;font-weight:900;text-align:center;">CardPOS からゲーム一覧を取得できませんでした。</div>';
    ct.appendChild(card);
    triggerFade(ct);
    return;
  }

  const hasPublicPack = (g)=>{
    const packs = Array.isArray(g?.packs) ? g.packs : [];
    const now = new Date();
    return packs.some(p=>{
      const released = (!p.releaseDate || new Date(p.releaseDate) <= now);
      const published = isPackPublicNow(p);
      const visible = Number(p?.visibleCount || p?.visible_count || 0) > 0;
      return released && published && visible;
    });
  };

  const getSubText = (g, ready)=>{
    if(!ready) return '公開準備中';
    if(String(g?.id||'') === 'pokekasm-dropdown') return 'SMシリーズ〜現行';
    if(String(g?.id||'') === 'pokekavs-dropdown') return 'VSシリーズ〜XYシリーズ';
    return '買取表を見る';
  };

  // 旧版のゲーム並び順をそのまま維持する
  // ※ 受付中 / 準備中 は表示エリアだけ分け、各エリア内の並び順は元の games 配列順のまま
  const orderedList = list;

  orderedList.forEach(g=>{
    const ready = hasPublicPack(g);
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'kaitori-title-button' + (ready ? '' : ' is-coming-card');
    btn.dataset.id = g.id;
    btn.title = g.name;
    const cardBackUrl = getProxyImageUrl(getGameCardBackImage(g));
    btn.innerHTML = `
      <span class="kaitori-title-button-top">
        <span class="kaitori-title-badge ${ready ? '' : 'is-coming'}">${ready ? '受付中' : '準備中'}</span>
        <span class="kaitori-title-arrow">›</span>
      </span>
      <span class="kaitori-title-preview-wrap">
        <img class="kaitori-title-preview" src="${cardBackUrl}" alt="${escapeHtml(g.name)} カード背面" loading="lazy">
      </span>
      <span class="kaitori-title-info">
        <span class="kaitori-title-name">${escapeHtml(g.name)}</span>
        <span class="kaitori-title-sub">${escapeHtml(getSubText(g, ready))}</span>
      </span>
    `;
    btn.addEventListener('click', ()=>handleGameSelect(g));
    (ready ? gridReady : gridComing).appendChild(btn);
  });

  if(gridComing.children.length){
    comingGroup.hidden = false;
  }

  ct.appendChild(card);
  applyAdaptiveGameTitleSizing(ct);
  triggerFade(ct);

  if(window.currentDropdownId){
    updateGameTabsUI(window.currentDropdownId);
  }
}

function renderGameLanding(game){
  const landing = document.getElementById('game-landing');
  if(!landing) return;

  cancelActiveSearch();

  const KEY='gameSearch:'+game.id;
  try{ sessionStorage.removeItem(KEY); }catch(_){}

  const imgUrl = getGameGuaranteeImageUrl(game);
  landing.innerHTML = `
    <div class="game-title-return-bar no-print">
      <button id="back-to-title-selector" type="button" class="back-to-title-selector-btn">← 買取タイトル一覧へ戻る</button>
      <span class="current-game-title-chip">${escapeHtml(game.name)}</span>
    </div>
    <section id="game-search-panel">
      <div class="game-hero">
        <div class="hero-card hero-left">
          <div class="hero-title">検索（このゲーム内のみ）</div>
          <div class="hero-sub">
            カード名とレアリティで検索できます。例：<b>ルフィ r:SEC</b> / <b>SR</b> / <b>LR*</b><br>
            ※ 初回検索はこのタイトルの全パックを読み込みます。
          </div>
          <div class="global-search">
            <input id="game-search-input" type="search" placeholder="例：ルフィ / SR / r:SEC★ / LR*" />
            <button id="game-search-clear">クリア</button>
          </div>

          <div class="hero-title hero-title-rarity">レアリティ</div>
          <div class="rarity-bar" id="rarity-bar"></div>

          <div class="global-meta">
            <span class="meta-chip">結果：<b id="game-search-count">0</b></span>
            <span class="meta-chip muted" id="game-search-progress">未検索</span>
            ${isAdminView()?`<button id="game-search-tweet" class="search-tweet-btn" disabled>検索結果を一鍵発推</button>`:''}
          </div>
        </div>

        ${imgUrl?`
          <div class="hero-card guarantee-wrap">
            <div class="guarantee-head">最低保証買取</div>
            <div class="guarantee-body"><img src="${getProxyImageUrl(imgUrl)}" alt="最低保証買取" loading="lazy"></div>
          </div>`:`
          <div class="hero-card guarantee-wrap">
            <div class="guarantee-head">最低保証買取</div>
            <div class="guarantee-body" style="display:flex;align-items:center;justify-content:center;color:#64748b;font-weight:900;">（画像URL未設定）</div>
          </div>`}
      </div>

      <div id="game-search-results"></div>
    </section>
  `;

  triggerFade(landing);

  const backBtn=document.getElementById('back-to-title-selector');
  if(backBtn) backBtn.addEventListener('click', showKaitoriTitleSelector);

  const input=document.getElementById('game-search-input');
  const clear=document.getElementById('game-search-clear');
  const results=document.getElementById('game-search-results');
  const countEl=document.getElementById('game-search-count');
  const progEl=document.getElementById('game-search-progress');
  const rarityBar=document.getElementById('rarity-bar');
  const tweetBtn=document.getElementById('game-search-tweet');
  const packEl=document.getElementById('pack-buttons');

  if(input) input.value='';
  results.innerHTML='';
  countEl.textContent='0';
  progEl.textContent='未検索';
  if(tweetBtn) tweetBtn.disabled=true;

  let lastQuery='';
  let lastFilteredAll=[];

  const hidePacks=()=>{
    if(!packEl) return;
    if(!packEl.dataset.prevDisplay) packEl.dataset.prevDisplay = packEl.style.display || '';
    setPackListVisible(false);
  };
  const showPacks=()=>{
    if(!packEl) return;
    const prev=packEl.dataset.prevDisplay;
    packEl.classList.remove('is-pack-list-hidden');
    packEl.style.display = (prev!==undefined ? prev : 'block');
  };

  const rarities=getGameRarityOrder(game.id);
  rarityBar.innerHTML='';
  rarities.forEach(r=>{
    const b=document.createElement('button');
    b.type='button';
    b.className='rarity-btn';
    b.textContent=r;
    b.dataset.r=r;
    b.addEventListener('click',()=>{
      setRarityInInput(input,game.id,r);
      runSearch();
      updateRarityButtonActive(rarityBar,game.id,input.value||'');
      input.focus();
    });
    rarityBar.appendChild(b);
  });

  let timer=null;

  const renderCards=(filteredUI)=>{
    const grid=document.createElement('div');
    grid.className='product-grid';
    filteredUI.forEach(p=>{
      const card=document.createElement('div');
      card.className='pack-card-product';
      card.setAttribute('data-nm',p.name);

      const chip=document.createElement('div');
      chip.className='pack-chip-mini';
      chip.textContent=p.packName||'';
      chip.title='クリックでこのパックを開く';
      chip.addEventListener('click',(e)=>{
        e.stopPropagation();

        if(input) input.value='';
        results.innerHTML='';
        countEl.textContent='0';
        progEl.textContent='未検索';
        lastQuery='';
        lastFilteredAll=[];
        if(tweetBtn) tweetBtn.disabled=true;
        try{ sessionStorage.removeItem(KEY); }catch(_){}

        setPackListVisible(false);
        loadProducts(p.packName,sheetMap[game.id]);
        window.currentSheetTitle=p.packName;
      });
      card.appendChild(chip);

      if(p.img){
        const img=document.createElement('img');
        img.src=getProxyImageUrl(p.img);
        img.alt=p.name;
        img.loading='lazy';
        card.appendChild(img);
      }

      const nm=document.createElement('p'); nm.textContent=p.name; nm.title=p.name; card.appendChild(nm);

      const sub=document.createElement('div');
      sub.style.cssText='font-size:12px;color:#6b7280;margin-bottom:8px;font-weight:700';
      sub.textContent=p.rarity||'';
      card.appendChild(sub);

      appendBuyPriceBlock(card,p);

      if(isAdminView()){
        const btn=document.createElement('button');
        btn.className='add-estimate-btn';
        btn.textContent='＋見積に追加';
        const add=()=>{
          if(!estimateMode)return;
          addToEstimate({name:p.name,packName:p.packName||'',img:getProxyImageUrl(p.img),price:p.price||0,qty:1,cond:ALLOWED_CONDS[0]});
        };
        btn.addEventListener('click',e=>{e.stopPropagation();add()});
        card.addEventListener('click',add);
        card.style.cursor=estimateMode?'pointer':'default';
        card.appendChild(btn);
      }

      grid.appendChild(card);
    });
    results.innerHTML='';
    results.appendChild(grid);
  };

  const draw=(query)=>{
    const {nameQuery,rarityQuery}=parseSearchInput(query,game.id);
    const qName=normalizeQ(nameQuery);
    const qRar=rarityQuery;

    updateRarityButtonActive(rarityBar,game.id,query||'');

    const hasQuery = !!(qName || String(qRar||'').trim());
    if(!hasQuery){
      results.innerHTML='';
      countEl.textContent='0';
      progEl.textContent='未検索';
      lastQuery='';
      lastFilteredAll=[];
      if(tweetBtn) tweetBtn.disabled=true;
      showPacks();
      try{ sessionStorage.removeItem(KEY); }catch(_){}
      return;
    }

    hidePacks();

    const cache=_gameSearchCache.get(game.id);
    const base=cache?.products||[];
    const filteredAll=base.filter(p=>{
      const okName=!qName || normalizeQ(p.name).includes(qName);
      const okRar=rarityMatch(p.rarity,qRar);
      return okName && okRar;
    }).sort((a,b)=>(b.price||0)-(a.price||0));

    lastQuery=query||'';
    lastFilteredAll=filteredAll;

    const filteredUI=filteredAll.slice(0,240);

    countEl.textContent=String(filteredAll.length);
    if(tweetBtn) tweetBtn.disabled = filteredAll.length===0;

    const rarLabel=String(qRar||'').trim()?` / 稀有度:${String(qRar).trim()}`:'';
    if(cache?.totalPacks){
      const loadedHint=cache.promise?'読み込み中':'読み込み完了';
      progEl.textContent=`${loadedHint}${rarLabel}`;
    }else{
      progEl.textContent=`検索中…${rarLabel}`;
    }

    if(filteredAll.length===0){
      results.innerHTML=`<div class="search-loading">🔎 該当なし</div>`;
      return;
    }
    renderCards(filteredUI);
  };

  async function runSearch(){
    const q=input.value||'';
    const {nameQuery,rarityQuery}=parseSearchInput(q,game.id);
    const nq=normalizeQ(nameQuery);
    const rq=String(rarityQuery||'').trim();

    updateRarityButtonActive(rarityBar,game.id,q);

    if(!nq && !rq){
      draw('');
      return;
    }

    hidePacks();
    results.innerHTML=`<div class="search-loading">⏳ データ取得中…</div>`;
    progEl.textContent='読み込み中…';

    window.currentDropdownId=game.id;

    try{
      await ensureGameSearchCache(game,({done,total,count})=>{
        progEl.textContent=`読み込み：${done}/${total}（累計 ${count} 件）`;
        draw(input.value||'');
      });

      const cache=_gameSearchCache.get(game.id);
      progEl.textContent=`読み込み完了（全 ${cache?.products?.length||0} 件）`;
      draw(input.value||'');
    }catch(e){
      console.error(e);
      progEl.textContent='取得失敗';
      results.innerHTML=`<div class="search-loading" style="color:#b91c1c">❗ 取得失敗：${(e?.message||e)}</div>`;
      if(tweetBtn) tweetBtn.disabled=true;
    }
  }

  async function tweetSearchResults(){
    if(!isAdminView())return;
    if(!lastFilteredAll.length){alert('検索結果がありません。');return;}

    const gameName=game?.name||'';

    const top10 = lastFilteredAll.slice(0,10).map(p=>{
      return `- ${p.name}：${formatBuyPriceTextFromItem(p)}`;
    });

    const extraTags=(()=>{
      const id=game.id;
      if(id==='ultraman-dropdown')return['#ウルトラマンTCG #UCG'];
      if(id==='dejimon-dropdown')return['#デジカ'];
      if(id==='gotoubunbright-dropdown')return['#ごとカド #五等分の花嫁TCG'];
      if(id==='pokeka-dropdown')return['#ポケカ #ポケモンカード'];
      if(id==='doragonboru-dropdown')return['#フュージョンワールド #DBFW'];
      if(id==='gundam-dropdown')return['#ガンダムカード #GCG'];
      if(id==='UA-dropdown')return['#ユニアリ #ユニオンアリーナ'];
      if(id==='onepiece-dropdown')return['#ワンピースカード'];
      return[];
    })();

    const tweetText=[
      `${gameName} 最新買取情報`,
      '強化買取',
      ...top10,
      '上記以外のカードも高価買取中です。',
      'ぜひお持ちください。',
      ...POSTAL_BUY_TWEET_LINES,
      '買取表はこちらで確認できます⇩',
      'https://torekanobankoku.com/pages/kaitorihyou',
      '※相場・状態・在庫・エディションにより予告なく金額が変動する場合がございます。',
      '#買取 #トレカの万国 #秋葉原',
      ...extraTags
    ].join('\n').trim();

    await downloadTweetImagesByProductCount(lastFilteredAll, {
      gameId: game.id,
      game,
      gameTitle: gameName,
      prefix: '検索結果',
      headline: '強化買取',
      cols: 7,
      width: 1400,
      perImage: 28,
      cardImgH: 200
    });

    openOriginalTweetOnX(tweetText);
  }

  if(tweetBtn) tweetBtn.addEventListener('click',tweetSearchResults);

  input?.addEventListener('input',()=>{
    clearTimeout(timer);
    timer=setTimeout(runSearch,220);
  });
  clear?.addEventListener('click',()=>{
    input.value='';
    draw('');
    input.focus();
  });
}

/* =========================================================
   v34 共通ヘルパー：買取金額パネル / 金額オートフィット / 画像自動トリミング
   - 全レイアウト（単品・2件・4件・多商品）で同じ買取金額の見た目に統一する
   - 「買取」ラベルは左の狭い列、金額は右の黄色エリアいっぱいに中央表示
   - 黒い縦線は無し、金額は文字幅に応じて自動でサイズ調整（はみ出し・見切れ防止）
   - 商品画像は描画前に余白（透明/白フチ）を自動トリミングして枠にフィット
   ========================================================= */

// 金額表示用テキスト（¥付き・カンマ区切り）。normalPriceがあれば優先。
function formatPosterAmount(product){
  const n = Number(product && product.normalPrice) || 0;
  if(n > 0) return '¥' + n.toLocaleString();
  const t = String((product && (product.priceText || product.price)) || '価格未設定')
    .replace(/円/g,'').trim();
  return t || '価格未設定';
}

// 統一「買取金額」パネル：左に「買取」（縦書き2文字）、右に黄色の大きな金額エリア。
// 黒い縦線は入れない。金額側は data-fit-price を付け、描画前に幅に合わせて自動拡縮する。
function createKaitoriPricePanel(amountText, opt = {}){
  const boxH      = opt.boxH || 74;
  const labelFont = opt.labelFont || Math.max(13, Math.round(boxH * 0.40));
  const labelW    = opt.labelW   || Math.max(20, Math.round(boxH * 0.60));
  const radius    = (opt.radius != null) ? opt.radius : 0;
  const border    = opt.border || '3px solid #111827';
  const amtPadX   = (opt.amtPadX != null) ? opt.amtPadX : Math.max(4, Math.round(boxH * 0.08));

  const box = makeTweetEl('div',
    `position:relative;width:100%;height:${boxH}px;`+
    `background:linear-gradient(180deg,#ffe24d 0%,#ffce19 100%);`+
    `border:${border};border-radius:${radius}px;overflow:hidden;`+
    `display:flex;align-items:stretch;box-sizing:border-box;`);
  box.setAttribute('data-kaitori-price-panel','1');

  // 左：「買取」ラベル（狭い・縦に2文字）。背景や縦線は付けない。
  const label = makeTweetEl('div',
    `flex:0 0 ${labelW}px;display:flex;flex-direction:column;align-items:center;justify-content:center;`+
    `color:#161616;font-weight:1000;line-height:.9;letter-spacing:-.05em;`);
  label.setAttribute('data-kaitori-price-label','1');
  label.appendChild(makeTweetEl('div', `font-size:${labelFont}px;`, '買'));
  label.appendChild(makeTweetEl('div', `font-size:${labelFont}px;`, '取'));
  box.appendChild(label);

  // 右：金額エリア（残り全幅）。html2canvasでもずれないよう、金額は絶対配置で中央に置く。
  const amtWrap = makeTweetEl('div',
    `position:relative;flex:1 1 auto;align-self:stretch;min-width:0;display:block;`+
    `overflow:hidden;padding:0 ${amtPadX}px;box-sizing:border-box;`);
  amtWrap.setAttribute('data-kaitori-amount-box','1');
  const amt = makeTweetEl('div',
    `position:absolute;left:50%;top:50%;transform:translate(-50%,-50%);`+
    `margin:0;padding:0;font-family:Arial,'Helvetica Neue',sans-serif;`+
    `font-style:italic;font-weight:1000;color:#ff1414;line-height:1;`+
    `white-space:nowrap;letter-spacing:-.02em;text-align:center;`,
    amountText);
  amt.setAttribute('data-fit-price','1');
  if(opt.maxFont) amt.setAttribute('data-fit-maxfont', String(opt.maxFont));
  if(opt.widthRatio)  amt.setAttribute('data-fit-wr', String(opt.widthRatio));
  if(opt.heightRatio) amt.setAttribute('data-fit-hr', String(opt.heightRatio));
  amtWrap.appendChild(amt);
  box.appendChild(amtWrap);

  return box;
}

// 金額のオートフィット計測用（オフスクリーンcanvasのmeasureText）
function _kaitoriMeasureCtx(){
  if(!_kaitoriMeasureCtx._c){
    _kaitoriMeasureCtx._c = document.createElement('canvas').getContext('2d');
  }
  return _kaitoriMeasureCtx._c;
}

// 字形の外接矩形ではなく、実際に塗られるピクセル量の重心を中央へ寄せるための補正値。
// カンマのような小さい下端だけで「中央」と判定され、数字本体が上に見える問題を防ぐ。
function getPriceOpticalCenterShift(text, font, metrics){
  try{
    const ascent  = Number(metrics.actualBoundingBoxAscent)  || 0;
    const descent = Number(metrics.actualBoundingBoxDescent) || 0;
    const left    = Number(metrics.actualBoundingBoxLeft)    || 0;
    const right   = Number(metrics.actualBoundingBoxRight)   || 0;
    if(ascent <= 0 || left + right <= 0) return {x:0,y:0};

    const pad = 6;
    const canvas = getPriceOpticalCenterShift._c ||
      (getPriceOpticalCenterShift._c = document.createElement('canvas'));
    canvas.width  = Math.max(1, Math.ceil(left + right) + pad * 2 + 4);
    canvas.height = Math.max(1, Math.ceil(ascent + descent) + pad * 2 + 4);
    const ctx = canvas.getContext('2d', { willReadFrequently:true });
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    ctx.font = font;
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = '#000';
    ctx.fillText(String(text || ''), pad + 2 + left, pad + 2 + ascent);

    const data = ctx.getImageData(0, 0, canvas.width, canvas.height).data;
    let minX = canvas.width, maxX = -1, minY = canvas.height, maxY = -1;
    let weight = 0, weightedX = 0, weightedY = 0;
    for(let y=0; y<canvas.height; y++){
      for(let x=0; x<canvas.width; x++){
        const alpha = data[(y * canvas.width + x) * 4 + 3];
        if(alpha <= 0) continue;
        if(x < minX) minX = x;
        if(x > maxX) maxX = x;
        if(y < minY) minY = y;
        if(y > maxY) maxY = y;
        weight += alpha;
        weightedX += x * alpha;
        weightedY += y * alpha;
      }
    }
    if(weight <= 0 || maxX < minX || maxY < minY) return {x:0,y:0};
    const boundsCenterX = (minX + maxX) / 2;
    const boundsCenterY = (minY + maxY) / 2;
    const opticalCenterX = weightedX / weight;
    const opticalCenterY = weightedY / weight;
    return {x:boundsCenterX-opticalCenterX,y:boundsCenterY-opticalCenterY};
  }catch(_){
    return {x:0,y:0};
  }
}

// テキストが boxW×boxH に収まる最大フォントサイズ（はみ出し・見切れ防止）を返す。
function fitPriceFontSizeToBox(text, boxW, boxH, opt = {}){
  const ctx = _kaitoriMeasureCtx();
  const ref = 100;
  const fontStyle  = opt.fontStyle  || 'italic';
  const fontWeight = opt.fontWeight || '1000';
  const fontFamily = opt.fontFamily || "Arial, 'Helvetica Neue', sans-serif";
  ctx.font = `${fontStyle} ${fontWeight} ${ref}px ${fontFamily}`;
  const metrics = ctx.measureText(String(text || ''));
  const inkW = Number.isFinite(metrics.actualBoundingBoxLeft) && Number.isFinite(metrics.actualBoundingBoxRight)
    ? metrics.actualBoundingBoxLeft + metrics.actualBoundingBoxRight
    : 0;
  let w = Math.max(metrics.width || 0, inkW) * 1.06; // 太字・斜体の張り出しを含む安全係数
  if(w <= 0) w = 1;
  const availW = Math.max(1, boxW * (opt.widthRatio  != null ? opt.widthRatio  : 0.94));
  const availH = Math.max(1, boxH * (opt.heightRatio != null ? opt.heightRatio : 0.86));
  const byWidth = availW / w * ref;
  let size = Math.min((opt.maxFont != null ? opt.maxFont : 240), availH, byWidth);
  size = Math.max((opt.minFont != null ? opt.minFont : 9), Math.floor(size));
  return size;
}

// ノード内の全[data-fit-price]について、実際の枠サイズを測ってフォントサイズを確定する。
// （html2canvas描画の直前に呼ぶ。レイアウト確定後に実寸で計算するため確実に収まる）
function applyPriceAutoFit(node){
  const els = Array.prototype.slice.call(node.querySelectorAll('[data-fit-price="1"]'));
  els.forEach(el => {
    const box = el.parentElement;
    if(!box) return;
    let paddingLeft = 0, paddingRight = 0, paddingTop = 0, paddingBottom = 0;
    let elStyle = null;
    try{
      const cs = getComputedStyle(box);
      paddingLeft   = parseFloat(cs.paddingLeft)   || 0;
      paddingRight  = parseFloat(cs.paddingRight)  || 0;
      paddingTop    = parseFloat(cs.paddingTop)    || 0;
      paddingBottom = parseFloat(cs.paddingBottom) || 0;
      elStyle = getComputedStyle(el);
    }catch(_){}
    const rect = box.getBoundingClientRect();
    const bw = rect.width - paddingLeft - paddingRight;
    const bh = rect.height - paddingTop - paddingBottom;
    if(bw <= 0 || bh <= 0) return;
    const text = el.textContent || '';
    const maxFont     = Number(el.getAttribute('data-fit-maxfont')) || 240;
    const widthRatio  = Number(el.getAttribute('data-fit-wr')) || 0.94;
    const heightRatio = Number(el.getAttribute('data-fit-hr')) || 0.86;
    let fs = fitPriceFontSizeToBox(text, bw, bh, {
      maxFont,
      widthRatio,
      heightRatio,
      fontStyle: elStyle && elStyle.fontStyle,
      fontWeight: elStyle && elStyle.fontWeight,
      fontFamily: elStyle && elStyle.fontFamily
    });
    el.style.fontSize = fs + 'px';
    el.style.position = 'absolute';
    el.style.left = '50%';
    el.style.top = '50%';
    el.style.transform = 'translate(-50%,-50%)';
    el.style.margin = '0';
    el.style.padding = '0';
    el.style.whiteSpace = 'nowrap';
    el.style.lineHeight = '1';
    el.style.textAlign = 'center';

    // 実DOMで最終確認し、斜体の張り出しなどで枠を越える場合だけもう一段縮小する。
    let textRect = el.getBoundingClientRect();
    const shrink = Math.min(1, bw / Math.max(1, textRect.width), bh / Math.max(1, textRect.height));
    if(shrink < 1){
      fs = Math.max(9, Math.floor(fs * shrink * 0.98));
      el.style.fontSize = fs + 'px';
      textRect = el.getBoundingClientRect();
    }

    // 字形そのもの（斜体の張り出し、¥、カンマの下端）を基準に視覚中心を補正する。
    // CSSの行ボックス中心だけでは、短い金額が上・右に見えるため。
    let visualX = 0, visualY = 0, opticalShiftX = 0, opticalShiftY = 0;
    const fontStyle  = (elStyle && elStyle.fontStyle)  || 'italic';
    const fontWeight = (elStyle && elStyle.fontWeight) || '1000';
    const fontFamily = (elStyle && elStyle.fontFamily) || "Arial, 'Helvetica Neue', sans-serif";
    const calculateVisualCenter = () => {
      let nextX = 0, nextY = 0, nextOpticalX = 0, nextOpticalY = 0, nextMetrics = null;
      const ctx = _kaitoriMeasureCtx();
      ctx.font = `${fontStyle} ${fontWeight} ${fs}px ${fontFamily}`;
      const metrics = ctx.measureText(String(text));
      nextMetrics = metrics;
      if(Number.isFinite(metrics.actualBoundingBoxLeft) && Number.isFinite(metrics.actualBoundingBoxRight)){
        const inkCenterX = (metrics.actualBoundingBoxRight - metrics.actualBoundingBoxLeft) / 2;
        // CSSのadvance幅とcanvasのink幅の差を考慮し、斜体の補正は実測差の60%に留める。
        nextX = (textRect.width / 2 - inkCenterX) * 0.60;
      }
      if(Number.isFinite(metrics.actualBoundingBoxAscent) && Number.isFinite(metrics.actualBoundingBoxDescent)){
        // Chromium/Arialのline-height:1におけるベースラインは行中心から約0.20em下。
        const inkCenterFromLineCenter = fs * 0.20 +
          (metrics.actualBoundingBoxDescent - metrics.actualBoundingBoxAscent) / 2;
        // 外接矩形を中央へ置いた後、ピクセル重心も中央に来るよう追加補正する。
        const optical = getPriceOpticalCenterShift(String(text), ctx.font, metrics);
        nextOpticalX = optical.x;
        nextOpticalY = optical.y;
        nextX += nextOpticalX;
        nextY = -inkCenterFromLineCenter + nextOpticalY;
      }
      return {x:nextX,y:nextY,opticalX:nextOpticalX,opticalY:nextOpticalY,metrics:nextMetrics};
    };
    try{
      let visual = calculateVisualCenter();

      // 重心補正で下へ動かしても、カンマなどの下端に必ず安全な余白を残す。
      const safeY = Math.max(2, Math.min(5, bh * 0.06));
      if(visual.metrics){
        const baseline = fs * 0.20;
        const topExtent = visual.metrics.actualBoundingBoxAscent - baseline - visual.y;
        const bottomExtent = baseline + visual.metrics.actualBoundingBoxDescent + visual.y;
        const maxExtent = Math.max(1, topExtent, bottomExtent);
        const allowedExtent = Math.max(1, bh / 2 - safeY);
        const opticalShrink = Math.min(1, allowedExtent / maxExtent);
        if(opticalShrink < 0.995){
          fs = Math.max(9, Math.floor(fs * opticalShrink * 0.99));
          el.style.fontSize = fs + 'px';
          textRect = el.getBoundingClientRect();
          visual = calculateVisualCenter();
        }
      }
      visualX = visual.x;
      visualY = visual.y;
      opticalShiftX = visual.opticalX;
      opticalShiftY = visual.opticalY;
    }catch(_){ }
    visualX = Math.max(-fs * 0.12, Math.min(fs * 0.12, visualX));
    visualY = Math.max(-fs * 0.22, Math.min(fs * 0.22, visualY));
    el.style.transform = `translate(-50%,-50%) translate(${visualX.toFixed(2)}px,${visualY.toFixed(2)}px)`;
    el.setAttribute('data-fit-visual-x', visualX.toFixed(2));
    el.setAttribute('data-fit-visual-y', visualY.toFixed(2));
    el.setAttribute('data-fit-optical-x', opticalShiftX.toFixed(2));
    el.setAttribute('data-fit-optical-y', opticalShiftY.toFixed(2));
  });
}

// 1枚の画像srcから、透明/白の余白を自動トリミングしたdataURLを返す（失敗時は元srcを返す）。
function autoCropImageSrc(src){
  return new Promise((resolve) => {
    if(!src){ resolve(src); return; }
    const im = new Image();
    im.crossOrigin = 'anonymous';
    im.referrerPolicy = 'no-referrer';
    im.onload = () => {
      try{
        const iw = im.naturalWidth, ih = im.naturalHeight;
        if(!iw || !ih){ resolve(src); return; }
        // 走査用は最大1100pxまで縮小（高速化）。トリミング後の出力は元解像度から切り出す。
        const maxDim = 1100;
        const scale = Math.min(1, maxDim / Math.max(iw, ih));
        const w = Math.max(1, Math.round(iw * scale));
        const h = Math.max(1, Math.round(ih * scale));
        const cv = document.createElement('canvas');
        cv.width = w; cv.height = h;
        const ctx = cv.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(im, 0, 0, w, h);
        let data;
        try{ data = ctx.getImageData(0, 0, w, h).data; }
        catch(e){ resolve(src); return; } // CORSで読めない場合は元のまま
        let minX = w, minY = h, maxX = -1, maxY = -1;
        const aTh = 12;   // これ以下のalphaは背景(透明)扱い
        const wTh = 244;  // これ以上のRGBは背景(白)扱い
        for(let y = 0; y < h; y++){
          for(let x = 0; x < w; x++){
            const i = (y * w + x) * 4;
            if(data[i+3] <= aTh) continue;
            if(data[i] >= wTh && data[i+1] >= wTh && data[i+2] >= wTh) continue;
            if(x < minX) minX = x;
            if(x > maxX) maxX = x;
            if(y < minY) minY = y;
            if(y > maxY) maxY = y;
          }
        }
        if(maxX < minX || maxY < minY){ resolve(src); return; } // 全面が背景
        const pad = Math.round(Math.max(w, h) * 0.012); // 端の切り過ぎ防止に少し余白
        minX = Math.max(0, minX - pad);
        minY = Math.max(0, minY - pad);
        maxX = Math.min(w - 1, maxX + pad);
        maxY = Math.min(h - 1, maxY + pad);
        const cw = maxX - minX + 1;
        const chh = maxY - minY + 1;
        // ほぼ全面が中身なら（トリミング不要）元srcを返す
        if(cw >= w * 0.985 && chh >= h * 0.985){ resolve(src); return; }
        const inv = 1 / scale; // 走査座標→元画像座標
        const sx = minX * inv, sy = minY * inv;
        const sw = cw * inv,   sh = chh * inv;
        const ocw = Math.max(1, Math.round(sw));
        const och = Math.max(1, Math.round(sh));
        const out = document.createElement('canvas');
        out.width = ocw; out.height = och;
        out.getContext('2d').drawImage(im, sx, sy, sw, sh, 0, 0, ocw, och);
        try{ resolve(out.toDataURL('image/png')); }
        catch(e){ resolve(src); }
      }catch(e){ resolve(src); }
    };
    im.onerror = () => resolve(src);
    im.src = src;
  });
}

// ノード内の[data-autocrop]画像をすべて自動トリミング後のdataURLへ差し替える。
async function applyImageAutoCrop(node){
  const imgs = Array.prototype.slice.call(node.querySelectorAll('img[data-autocrop="1"]'));
  await Promise.all(imgs.map(async (img) => {
    const src = img.getAttribute('src') || '';
    if(!src || img.getAttribute('data-cropped') === '1') return;
    try{
      const cropped = await autoCropImageSrc(src);
      if(cropped && cropped !== src){
        img.setAttribute('data-cropped','1');
        await new Promise(res => { img.onload = img.onerror = res; img.src = cropped; });
      }
    }catch(_){}
  }));
}

function createAlignedShotCard(p, opt = {}) {
  const showPack   = opt.showPack   ?? !!p.packName;
  const showRarity = opt.showRarity ?? true;
  const imgH       = opt.imgH       ?? 200;

  const reserveTop = opt.reserveTop ?? (showPack ? 92 : 14);

  const card = document.createElement('div');
  card.style.cssText = `
    position:relative;
    background:#fff;
    border:1px solid #e8eaee;
    border-radius:14px;
    box-shadow:none;
    padding:${reserveTop}px 12px 12px;
    display:flex;
    flex-direction:column;
    align-items:center;
    overflow:hidden;
  `;

  if (showPack) {
    const chip = document.createElement('div');
    chip.textContent = p.packName || '';
    chip.style.cssText = `
      position:absolute;
      top:12px; left:12px; right:12px;
      padding:6px 10px;
      border-radius:9999px;
      background:#f1f3f5;
      border:1px solid #e5e7eb;
      font-size:12px;
      font-weight:900;
      color:#111;
      text-align:center;
      line-height:1.15;

      display:-webkit-box;
      -webkit-line-clamp:2;
      -webkit-box-orient:vertical;
      overflow:hidden;

      word-break:break-word;
      max-height:44px;
    `;
    card.appendChild(chip);
  }

  if (p.img) {
    // 固定高さの枠の中で max-width/max-height により比率を保って中央表示
    //（html2canvas 1.4.1 は object-fit を無視するため使わない）。
    const imgBox = document.createElement('div');
    imgBox.style.cssText = `
      width:100%;
      height:${imgH}px;
      border-radius:10px;
      background:#fff;
      border:1px solid #eef1f5;
      margin:0 0 10px 0;
      display:flex;
      align-items:center;
      justify-content:center;
      overflow:hidden;
    `;
    const img = document.createElement('img');
    img.crossOrigin = 'anonymous';
    img.referrerPolicy = 'no-referrer';
    img.setAttribute('data-autocrop','1'); // 余白を自動トリミングしてから枠にフィット
    img.src = p.img;
    img.style.cssText = `
      max-width:100%;
      max-height:100%;
      width:auto;
      height:auto;
      display:block;
    `;
    imgBox.appendChild(img);
    card.appendChild(imgBox);
  } else {
    const ph = document.createElement('div');
    ph.style.cssText = `
      width:100%;
      height:${imgH}px;
      border-radius:10px;
      background:#f8fafc;
      border:1px dashed #cbd5e1;
      margin-bottom:10px;
      display:flex;
      align-items:center;
      justify-content:center;
      color:#94a3b8;
      font-weight:900;
    `;
    ph.textContent = 'NO IMAGE';
    card.appendChild(ph);
  }

  const nm = document.createElement('div');
  nm.textContent = p.name || '';
  nm.style.cssText = `
    font-weight:1000;
    color:#111;
    text-align:center;
    font-size:14px;
    line-height:1.25;
    display:-webkit-box;
    -webkit-line-clamp:2;
    -webkit-box-orient:vertical;
    overflow:hidden;
    min-height:36px;
    margin:0 0 8px 0;
    word-break:break-word;
  `;
  card.appendChild(nm);

  if (showRarity) {
    const rr = document.createElement('div');
    rr.textContent = p.rarity || '';
    rr.style.cssText = `
      font-size:12px;
      color:#6b7280;
      font-weight:800;
      margin:0 0 10px 0;
      min-height:18px;
    `;
    card.appendChild(rr);
  }

  const normalPrice = readMoneyNumber(p.normalPrice ?? p.price);
  const psa10Price = readMoneyNumber(p.psa10Price ?? p.psa10BuyPrice);
  const psa10OnRaw = p.psa10Enabled ?? p.psa10BuyEnabled ?? (psa10Price > 0 ? 1 : 0);
  const psa10On = psa10OnRaw === true || psa10OnRaw === 1 || psa10OnRaw === '1' || String(psa10OnRaw).toLowerCase() === 'true';

  const priceStack = document.createElement('div');
  priceStack.style.cssText = `
    width:100%;
    display:flex;
    flex-direction:column;
    gap:6px;
    margin-top:auto;
  `;

  // PSA10など追加価格はグラデーションのバーで表示（補助的な金額）。
  const addExtraPrice = (text, bg) => {
    const pr = document.createElement('div');
    pr.textContent = text;
    pr.style.cssText = `
      width:100%;
      min-height:40px;
      padding:6px 4px;
      display:flex;
      align-items:center;
      justify-content:center;
      text-align:center;
      border-radius:10px;
      color:#fff;
      font-weight:1000;
      line-height:1.2;
      background:${bg};
      box-shadow:none;
      white-space:pre-line;
    `;
    priceStack.appendChild(pr);
  };

  // メインの買取金額は統一パネル（左「買取」＋右の黄色エリアに大きな赤金額）で表示。
  const mainBoxH = Math.max(44, Number(opt.priceH) || 50);
  if (normalPrice > 0) {
    priceStack.appendChild(createKaitoriPricePanel(money(normalPrice), {
      boxH: mainBoxH, radius: 12, border: '2px solid #111827', maxFont: 60
    }));
  }
  if (psa10On && psa10Price > 0) {
    addExtraPrice(`PSA10 ${money(psa10Price)}`, 'linear-gradient(90deg,#7c3aed,#f59e0b)');
  }
  if (!(normalPrice > 0) && !(psa10On && psa10Price > 0)) {
    const fallbackText = String(p.price || '').trim();
    priceStack.appendChild(createKaitoriPricePanel(fallbackText || '価格未設定', {
      boxH: mainBoxH, radius: 12, border: '2px solid #111827', maxFont: 60
    }));
  }
  card.appendChild(priceStack);

  return card;
}



/* =========================================================
   v30 一鍵発推：商品数量別ポスター画像生成
   1件=単品ポスター / 2件=双商品 / 3-4件=2x2 / 5-8件=多商品 / 9件以上=一覧型で全件出力
   ========================================================= */
const TWEET_IMAGE_NOTE_DEFAULT = '買取価格は「在庫状況・状態・市場状況」により変動いたします。';
const TWEET_IMAGE_HEADLINE_DEFAULT = '数量限定高価買取!!';
const TWEET_IMAGE_GAME_TITLE_MAP = {
  'doragonboru-dropdown':'ドラゴンボールフュージョンワールド',
  'onepiece-dropdown':'ワンピースカード',
  'dejimon-dropdown':'デジモンカード',
  'UA-dropdown':'ユニオンアリーナ',
  'ultraman-dropdown':'ウルトラマンカードゲーム',
  'gotoubunbright-dropdown':'五等分の花嫁カードゲーム',
  'nikee-dropdown':'NIKKE NIVEL ARENA',
  'pokekasm-dropdown':'ポケモンカード（SMシリーズ〜現行）',
  'pokeka-dropdown':'ポケモンカード',
  'pokekavs-dropdown':'ポケモンカード（VSシリーズ〜XYシリーズ）',
  'gundam-dropdown':'ガンダムカードゲーム',
  'Xross-dropdown':'Xross Stars',
  'FE-dropdown':'TCGファイアーエムブレム0（サイファ）',
  'haikyo-dropdown':'ハイキュー!! バボカ!!',
  'sangoku-dropdown':'三国志大戦',
  'sengoku-dropdown':'戦国大戦',
  'conan-dropdown':'名探偵コナンカードゲーム'
};

function getTweetImageLayoutType(count){
  const n = Number(count)||0;
  if(n <= 1) return 'single-poster';
  if(n === 2) return 'double-poster';
  if(n <= 4) return 'grid-2x2';
  if(n <= 8) return 'multi-grid';
  return 'current-all-products';
}

function getTweetImageGameTitle(gameId, gameObj){
  const id = String(gameId || window.currentDropdownId || '');
  const game = gameObj || findBootstrapGame(id) || (games||[]).find(g=>String(g.id)===id) || {};
  const serverName = String(game?.name || game?.game_name || game?.title || game?.label || '').trim();
  return serverName || TWEET_IMAGE_GAME_TITLE_MAP[id] || tweetHashtagMap[id] || 'トレカ';
}

function getTweetImageShopName(){
  // v29: 一鍵発推ポスター上のロゴ表示は画像ではなく「トレカの万国」に固定。
  return 'トレカの万国';
}

function getTweetImageLogoUrl(){
  // v29: Shopifyテーマロゴ画像は使用しない。中央は固定文字「トレカの万国」を表示する。
  return '';
}

function getTweetImageUpdatedAt(fallback){
  // v29: 右上の日付は「月/日」だけに統一。
  // 例：最終更新：2026/6/28 14:53 → 6/28
  const rawCandidates = [
    fallback,
    String(document.getElementById('update-time')?.innerText || '').replace(/^最終更新\s*[:：]?\s*/,'').trim()
  ].map(v=>String(v||'').trim()).filter(Boolean);

  for(const raw of rawCandidates){
    const s = raw.replace(/最終更新\s*[:：]?/g,'').trim();
    let m = s.match(/(?:20\d{2}|19\d{2})[\/\-.年]\s*(\d{1,2})[\/\-.月]\s*(\d{1,2})/);
    if(m) return `${Number(m[1])}/${Number(m[2])}`;
    m = s.match(/(^|[^\d])(\d{1,2})[\/月](\d{1,2})(?:日)?/);
    if(m) return `${Number(m[2])}/${Number(m[3])}`;
  }

  const d = new Date();
  return `${d.getMonth()+1}/${d.getDate()}`;
}

function getTweetImageHeadline(v){
  return String(v || window.TOREKANO_TWEET_HEADLINE || TWEET_IMAGE_HEADLINE_DEFAULT).trim() || TWEET_IMAGE_HEADLINE_DEFAULT;
}

function getTweetImageNote(v){
  return String(v || window.TOREKANO_TWEET_NOTE || TWEET_IMAGE_NOTE_DEFAULT).trim() || TWEET_IMAGE_NOTE_DEFAULT;
}

function safeTweetFilePart(s){
  return String(s || 'tweet').replace(/[\\/:*?"<>|]/g,'_').replace(/\s+/g,'_').slice(0,48) || 'tweet';
}

function normalizeTweetImageProduct(item, opt={}){
  const normalPrice = readMoneyNumber(item?.price ?? item?.normalPrice ?? item?.productPrice ?? item?.buy_price);
  const psa10Price = readMoneyNumber(item?.psa10Price ?? item?.psa10BuyPrice ?? getPsa10BuyPrice(item));
  const psaRaw = item?.psa10Enabled ?? item?.psa10BuyEnabled ?? isPsa10BuyEnabled(item);
  const psa10Enabled = psaRaw === true || psaRaw === 1 || psaRaw === '1' || String(psaRaw).toLowerCase() === 'true';
  const priceText = String(item?.priceText || item?.priceLabel || formatBuyPriceText(normalPrice, psa10Price, psa10Enabled) || '').trim();
  const rawImg = item?.img || item?.image || item?.productImageUrl || item?.imageUrl || item?.src || '';
  const img = rawImg ? getProxyImageUrl(rawImg) : '';
  return {
    name: String(item?.name || item?.title || item?.productName || item?.cardName || '').trim(),
    packName: String(item?.packName || item?.pack_name || opt.packName || '').trim(),
    rarity: String(item?.rarity || item?.condition || item?.rare || '').trim(),
    normalPrice,
    psa10Price,
    psa10Enabled,
    priceText: priceText || '価格未設定',
    img
  };
}

function makeTweetEl(tag='div', css='', text=''){
  const el = document.createElement(tag);
  if(css) el.style.cssText = css;
  if(text !== undefined && text !== null && text !== '') el.textContent = text;
  return el;
}

function makeTweetImg(src, css='', alt=''){
  const img = document.createElement('img');
  img.crossOrigin = 'anonymous';
  img.referrerPolicy = 'no-referrer';
  img.setAttribute('data-autocrop','1'); // 描画前に余白を自動トリミング
  img.src = src || '';
  img.alt = alt || '';
  img.style.cssText = css;
  return img;
}

function appendTweetFittedText(parent, text, css='', maxChars=38){
  const el = makeTweetEl('div', css);
  const s = String(text || '');
  el.textContent = s.length > maxChars ? s.slice(0, maxChars-1) + '…' : s;
  parent.appendChild(el);
  return el;
}

function createTweetStarsBgCss(){
  const svg = `<svg xmlns="http://www.w3.org/2000/svg" width="1080" height="1350" viewBox="0 0 1080 1350"><rect width="1080" height="1350" fill="#06070d"/><g fill="white" opacity=".82"><circle cx="46" cy="56" r="1.5"/><circle cx="156" cy="92" r="2.2"/><circle cx="280" cy="28" r="1.2"/><circle cx="506" cy="75" r="2"/><circle cx="842" cy="45" r="1.6"/><circle cx="986" cy="132" r="2.4"/><circle cx="96" cy="290" r="1.4"/><circle cx="248" cy="346" r="2.2"/><circle cx="400" cy="256" r="1.7"/><circle cx="660" cy="326" r="2.1"/><circle cx="924" cy="286" r="1.4"/><circle cx="1030" cy="420" r="2"/><circle cx="72" cy="730" r="2.4"/><circle cx="210" cy="822" r="1.2"/><circle cx="454" cy="704" r="2.1"/><circle cx="706" cy="812" r="1.8"/><circle cx="918" cy="704" r="2.4"/><circle cx="1000" cy="968" r="1.3"/><circle cx="122" cy="1160" r="2"/><circle cx="366" cy="1222" r="1.5"/><circle cx="644" cy="1138" r="2.2"/><circle cx="886" cy="1220" r="1.6"/></g><g opacity=".18"><circle cx="920" cy="148" r="78" fill="#fff"/><circle cx="110" cy="1050" r="90" fill="#fff"/><circle cx="760" cy="1010" r="120" fill="#f7d37a"/></g></svg>`;
  return `#05060b url("data:image/svg+xml;charset=UTF-8,${encodeURIComponent(svg)}") center/cover no-repeat`;
}

function createTweetHeaderNode(options){
  const {gameTitle, shopName, headline, updatedAt} = options;
  const header = makeTweetEl('div', 'position:relative;height:178px;color:#fff;');

  // 左：ゲーム正式名称。長いタイトルでも2行で収まるよう固定枠＋自動折返し。
  const label = makeTweetEl('div', `position:absolute;left:44px;top:40px;width:390px;height:72px;padding:8px 14px;border:3px solid #fff;background:#080808;display:flex;align-items:center;justify-content:center;text-align:center;font-size:22px;line-height:1.12;font-weight:1000;letter-spacing:.02em;word-break:keep-all;overflow-wrap:anywhere;`, gameTitle);
  header.appendChild(label);

  // 中央：ロゴ画像は使わず、固定で「トレカの万国」を表示。
  const shopLogoText = makeTweetEl('div', `position:absolute;left:470px;top:36px;width:330px;height:78px;display:flex;align-items:center;justify-content:center;text-align:center;color:#fff;font-size:42px;line-height:1.05;font-weight:1000;letter-spacing:.03em;text-shadow:0 3px 0 rgba(0,0,0,.38);`, shopName || 'トレカの万国');
  header.appendChild(shopLogoText);

  // 右：日付は月/日のみ。年・時刻・「最終更新」は表示しない。
  const dateBox = makeTweetEl('div', 'position:absolute;right:58px;top:42px;width:170px;height:86px;background:#ef3333;border:5px solid #fff;display:flex;align-items:center;justify-content:center;color:#fff;font-weight:1000;line-height:1;text-align:center;box-shadow:0 8px 0 rgba(0,0,0,.22);');
  dateBox.appendChild(makeTweetEl('div','font-size:48px;letter-spacing:.01em;', String(updatedAt || '').trim()));
  header.appendChild(dateBox);

  header.appendChild(makeTweetEl('div', 'position:absolute;left:70px;right:245px;top:116px;font-size:54px;line-height:1;font-weight:1000;text-shadow:0 3px 0 rgba(0,0,0,.36);white-space:nowrap;', headline));
  return header;
}

function createTweetFooterNode(note){
  const foot = makeTweetEl('div', 'position:absolute;left:70px;right:70px;bottom:40px;height:48px;background:#fff;display:flex;align-items:center;justify-content:center;color:#111827;font-size:25px;font-weight:700;text-align:center;padding:0 18px;');
  foot.textContent = note;
  return foot;
}

function createTweetPricePanel(product){
  // v34: 全レイアウト共通の買取金額パネルを使用。
  // 「買取」を左の狭い列に、金額は右の黄色エリアいっぱいに中央表示（黒い縦線なし）。
  const wrap = makeTweetEl('div', 'position:absolute;left:90px;right:90px;bottom:166px;height:214px;background:#fff;padding:14px 34px 18px;text-align:center;color:#111827;overflow:hidden;');
  appendTweetFittedText(wrap, product.name, 'font-size:32px;line-height:1.15;font-weight:800;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;margin-bottom:12px;', 52);

  const panel = createKaitoriPricePanel(formatPosterAmount(product), {
    boxH: 130, labelW: 92, labelFont: 56, border: '4px solid #111827', radius: 0, maxFont: 160, amtPadX: 14
  });
  wrap.appendChild(panel);
  return wrap;
}

function createTweetPosterCard(product, imgH, opts={}){
  const card = makeTweetEl('div', `background:#fff;border:1px solid #e8eaee;border-radius:${opts.radius||22}px;box-shadow:0 16px 30px rgba(0,0,0,.24);padding:${opts.pad||14}px;display:flex;flex-direction:column;align-items:stretch;overflow:hidden;min-width:0;height:100%;box-sizing:border-box;`);
  // 画像枠はカードの余り高さいっぱいまで伸ばす（flex:1）。これで縦長カードも大きく表示され、
  // 画像と金額の間の余白が消える。比率は object-fit:contain で維持（歪まない）。
  const imgBox = makeTweetEl('div', `width:100%;flex:1 1 ${imgH}px;min-height:${imgH}px;background:#fff;border-radius:${opts.imgRadius||16}px;display:flex;align-items:center;justify-content:center;overflow:hidden;border:1px solid #eef1f5;margin-bottom:${opts.imgMb||14}px;`);
  // html2canvas 1.4.1 は object-fit を無視して画像を引き伸ばすため使用しない。
  // max-width/max-height + 親のflex中央寄せで「比率を保ったまま枠内にフィット」を実現。
  if(product.img) imgBox.appendChild(makeTweetImg(product.img, 'max-width:100%;max-height:100%;width:auto;height:auto;display:block;', product.name));
  else imgBox.appendChild(makeTweetEl('div','color:#94a3b8;font-size:26px;font-weight:1000;','NO IMAGE'));
  card.appendChild(imgBox);
  appendTweetFittedText(card, product.name, `flex:0 0 auto;width:100%;min-height:${opts.nameMinH||48}px;color:#111827;text-align:center;font-size:${opts.nameSize||24}px;line-height:1.25;font-weight:1000;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden;margin-bottom:8px;`, 42);
  card.appendChild(makeTweetEl('div', `flex:0 0 auto;width:100%;min-height:${opts.rarityH||24}px;color:#64748b;text-align:center;font-size:${opts.raritySize||18}px;line-height:1.2;font-weight:900;margin-bottom:12px;`, product.rarity || product.packName || ''));
  // 統一買取金額パネル（左「買取」＋右の黄色エリアに大きな赤金額）。最下段に固定。
  const panel = createKaitoriPricePanel(formatPosterAmount(product), {
    boxH: opts.priceH || 74,
    radius: (opts.priceRadius != null ? opts.priceRadius : 14),
    border: opts.priceBorder || '3px solid #111827',
    maxFont: opts.priceMaxFont
  });
  panel.style.flex = '0 0 auto';
  card.appendChild(panel);
  return card;
}

function buildTweetPosterNode(products, options){
  const layout = getTweetImageLayoutType(products.length);
  const node = makeTweetEl('div', `position:relative;width:1080px;height:1350px;background:${createTweetStarsBgCss()};overflow:hidden;font-family:"Noto Sans JP",system-ui,-apple-system,"Segoe UI",sans-serif;`);
  node.appendChild(createTweetHeaderNode(options));
  const note = options.note || TWEET_IMAGE_NOTE_DEFAULT;

  if(layout === 'single-poster'){
    const p = products[0];
    // 領域（透明）。この中で白枠が画像サイズにフィットし中央配置される。
    // 白い余白が画像の上下に大きく余らないよう、白枠は画像にぴったり寄せる。
    const region = makeTweetEl('div', 'position:absolute;left:44px;right:44px;top:205px;height:700px;display:flex;align-items:center;justify-content:center;overflow:hidden;');
    if(p.img){
      // 白枠は画像サイズに合わせて縮む（inline-block）。object-fitは使わず比率維持。
      const frame = makeTweetEl('div', 'display:inline-block;background:#fff;padding:14px;line-height:0;font-size:0;box-sizing:border-box;max-width:100%;max-height:100%;');
      frame.appendChild(makeTweetImg(p.img,'max-width:964px;max-height:672px;width:auto;height:auto;display:block;',p.name));
      region.appendChild(frame);
    } else {
      const ph = makeTweetEl('div','width:100%;height:100%;background:#fff;display:flex;align-items:center;justify-content:center;color:#94a3b8;font-size:44px;font-weight:1000;','NO IMAGE');
      region.appendChild(ph);
    }
    node.appendChild(region);
    node.appendChild(createTweetPricePanel(p));
    node.appendChild(createTweetFooterNode(note));
    return node;
  }

  if(layout === 'double-poster'){
    const grid = makeTweetEl('div', 'position:absolute;left:84px;right:84px;top:238px;height:760px;display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr;gap:34px;');
    products.slice(0,2).forEach(p=>grid.appendChild(createTweetPosterCard(p,470,{nameSize:30,nameMinH:76,priceH:88})));
    node.appendChild(grid);
    node.appendChild(createTweetFooterNode(note));
    return node;
  }

  if(layout === 'grid-2x2'){
    const grid = makeTweetEl('div', 'position:absolute;left:82px;right:82px;top:215px;height:1024px;display:grid;grid-template-columns:1fr 1fr;grid-template-rows:1fr 1fr;gap:24px;');
    products.slice(0,4).forEach(p=>grid.appendChild(createTweetPosterCard(p,285,{nameSize:24,nameMinH:60,priceH:70})));
    node.appendChild(grid);
    node.appendChild(createTweetFooterNode(note));
    return node;
  }

  const count = products.length;
  const cols = count <= 6 ? 3 : 4;
  const rows = Math.ceil(count / cols);
  const grid = makeTweetEl('div', `position:absolute;left:58px;right:58px;top:214px;height:1045px;display:grid;grid-template-columns:repeat(${cols},1fr);grid-auto-rows:1fr;gap:18px;`);
  const imgH = rows <= 2 ? 182 : 142;
  products.slice(0,8).forEach(p=>grid.appendChild(createTweetPosterCard(p,imgH,{pad:12,nameSize:18,nameMinH:45,raritySize:14,rarityH:18,priceH:54,priceRadius:14,imgMb:10})));
  node.appendChild(grid);
  node.appendChild(createTweetFooterNode(note));
  return node;
}

function buildTweetCurrentAllNode(products, options){
  const cols = options.cols || 7;
  const cardImgH = options.cardImgH || 200;
  const width = options.width || (cols >= 8 ? 1600 : 1400);
  const gap = options.gap || 18;
  const pad = options.pad || 18;
  const node = makeTweetEl('div', `width:${width}px;background:#fff;color:#111827;font-family:"Noto Sans JP",system-ui,-apple-system,"Segoe UI",sans-serif;padding:0;overflow:hidden;`);
  const head = makeTweetEl('div', 'position:relative;height:108px;background:#fff;border-bottom:1px solid #eef1f5;');
  appendTweetFittedText(head, `${options.gameTitle || ''} 最新買取情報`, 'position:absolute;left:24px;top:20px;right:390px;font-size:30px;line-height:1.1;font-weight:1000;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;', 58);
  appendTweetFittedText(head, `${options.shopName || getTweetImageShopName()} / ${options.updatedAt || ''} / ${options.headline || ''}`, 'position:absolute;left:24px;top:60px;right:390px;color:#64748b;font-size:18px;line-height:1.2;font-weight:800;white-space:nowrap;overflow:hidden;text-overflow:ellipsis;', 80);
  const titleBox = makeTweetEl('div', 'position:absolute;right:32px;top:22px;width:350px;height:58px;background:#080808;border:2px solid #fff;color:#fff;display:flex;align-items:center;justify-content:center;text-align:center;font-size:22px;line-height:1.1;font-weight:1000;padding:0 14px;overflow:hidden;', options.gameTitle || '');
  head.appendChild(titleBox);
  node.appendChild(head);

  const grid = makeTweetEl('div', `display:grid;grid-template-columns:repeat(${cols},minmax(0,1fr));gap:${gap}px;padding:${pad}px;background:#ffffff;`);
  products.forEach(p=>{
    grid.appendChild(createAlignedShotCard({
      name:p.name,
      packName:p.packName,
      rarity:p.rarity,
      price:p.priceText,
      normalPrice:p.normalPrice,
      psa10Price:p.psa10Price,
      psa10Enabled:p.psa10Enabled,
      img:p.img
    }, {showPack:!!p.packName, showRarity:true, imgH:cardImgH}));
  });
  node.appendChild(grid);
  const foot = makeTweetEl('div', 'margin:0 24px 24px;height:44px;background:#f3f4f6;color:#111827;display:flex;align-items:center;justify-content:center;text-align:center;font-size:20px;font-weight:700;padding:0 18px;', options.note || TWEET_IMAGE_NOTE_DEFAULT);
  node.appendChild(foot);
  return node;
}

async function waitTweetNodeImages(node){
  const imgs = Array.from(node.querySelectorAll('img'));
  await Promise.all(imgs.map(img => img.complete ? Promise.resolve() : new Promise(r => { img.onload = img.onerror = r; })));
}

async function downloadTweetNodeAsPng(node, fileName, bg='#ffffff'){
  const tempWrapper = document.createElement('div');
  tempWrapper.style.cssText = 'position:absolute;top:-99999px;left:0;width:max-content;z-index:-1;pointer-events:none;';
  tempWrapper.appendChild(node);
  document.body.appendChild(tempWrapper);
  try{
    await waitTweetNodeImages(node);
    try{ if(document.fonts && document.fonts.ready) await document.fonts.ready; }catch(_){ }
    // v34: 描画前に商品画像の余白を自動トリミング → 再ロード待ち → 金額のオートフィット確定。
    try{ await applyImageAutoCrop(node); }catch(_){ }
    try{ await waitTweetNodeImages(node); }catch(_){ }
    try{ applyPriceAutoFit(node); }catch(_){ }
    // フォントサイズ反映後のレイアウトを待ち、html2canvas直前に実寸でもう一度確定する。
    try{
      await new Promise(resolve => requestAnimationFrame(() => requestAnimationFrame(resolve)));
      applyPriceAutoFit(node);
    }catch(_){ }
    const canvas = await html2canvas(node, {scrollY:0,useCORS:true,allowTaint:false,backgroundColor:bg,scale:window.devicePixelRatio||1});
    await new Promise(resolve=>{
      canvas.toBlob(blob=>{
        const a=document.createElement('a');
        a.download=fileName;
        a.href=URL.createObjectURL(blob);
        a.click();
        setTimeout(()=>URL.revokeObjectURL(a.href),3000);
        resolve();
      });
    });
  }finally{
    tempWrapper.remove();
  }
}

async function downloadTweetImagesByProductCount(items, opt={}){
  const raw = Array.isArray(items) ? items : [];
  if(!raw.length) return;
  const gameId = opt.gameId || window.currentDropdownId || '';
  const gameObj = opt.game || (games||[]).find(g=>String(g.id)===String(gameId)) || findBootstrapGame(gameId) || {};
  const products = raw
    .map(x=>normalizeTweetImageProduct(x, opt))
    .filter(p=>(p.normalPrice>0 || (p.psa10Enabled && p.psa10Price>0)) && (p.name || p.img));
  if(!products.length) return;

  const options = {
    gameId,
    gameTitle: opt.gameTitle || getTweetImageGameTitle(gameId, gameObj),
    shopName: opt.shopName || getTweetImageShopName(),
    logoUrl: opt.logoUrl ?? getTweetImageLogoUrl(),
    headline: getTweetImageHeadline(opt.headline),
    updatedAt: getTweetImageUpdatedAt(opt.updatedAt),
    note: getTweetImageNote(opt.note),
    prefix: opt.prefix || '買取表',
    cols: opt.cols,
    width: opt.width,
    gap: opt.gap,
    pad: opt.pad,
    cardImgH: opt.cardImgH
  };

  const layout = getTweetImageLayoutType(products.length);
  const safeBase = safeTweetFilePart(`${options.prefix}_${options.gameTitle}`);

  if(layout !== 'current-all-products'){
    const node = buildTweetPosterNode(products, options);
    await downloadTweetNodeAsPng(node, `${safeBase}_${layout}.png`, '#05060b');
    return;
  }

  const perImage = opt.perImage || (Number(options.cols || 7) >= 8 ? 24 : 28);
  const total = Math.ceil(products.length / perImage);
  for(let i=0;i<total;i++){
    const group = products.slice(i*perImage, (i+1)*perImage);
    const node = buildTweetCurrentAllNode(group, options);
    await downloadTweetNodeAsPng(node, `${safeBase}_${i+1}.png`, '#ffffff');
  }
}
window.__downloadTweetImagesByProductCount = downloadTweetImagesByProductCount;

function setHeadingDropdown(on){
  if(!isAdminView()) return;

  const h1 = document.getElementById('heading-text');
  if(!h1) return;

  const wrapId = 'heading-game-dd';
  const old = document.getElementById(wrapId);

  if(on){
    if(old) return;

    h1.dataset.prevText = h1.textContent || '';
    h1.style.display = 'none';

    const wrap = document.createElement('div');
    wrap.id = wrapId;
    wrap.className = 'heading-game-dd';
    wrap.innerHTML = `<select id="heading-game-select" aria-label="ゲームを選択"></select>`;
    h1.parentNode.insertBefore(wrap, h1.nextSibling);

    const sel = wrap.querySelector('#heading-game-select');
    (games||[]).forEach(g=>{
      const opt=document.createElement('option');
      opt.value=g.id;
      opt.textContent=g.name;
      sel.appendChild(opt);
    });

    sel.value = window.currentDropdownId || (games?.[0]?.id || '');

    sel.addEventListener('change', ()=>{
      const id = sel.value;
      const g = (games||[]).find(x=>x.id===id);
      if(g) handleGameSelect(g);
    });

  }else{
    if(old) old.remove();
    h1.style.display = '';
    if(h1.dataset.prevText) h1.textContent = h1.dataset.prevText;
  }
}

function switchGameByIdSafe(gameId){
  if(typeof window.activateGame === 'function') return window.activateGame(gameId);
  if(typeof window.selectGame === 'function') return window.selectGame(gameId);

  const btn =
    document.querySelector(`#game-tabs [data-id="${gameId}"]`) ||
    document.querySelector(`#game-tabs [data-game-id="${gameId}"]`) ||
    document.querySelector(`#game-tabs button[value="${gameId}"]`);
  if(btn) btn.click();
}

function setEstimateHeadingDropdown(on){
  const h = document.getElementById('heading-text');
  if(!h) return;

  if(on){
    if(h.dataset.prevHtml === undefined) h.dataset.prevHtml = h.innerHTML;

    h.innerHTML = `<select id="estimate-game-select" class="title-select"></select>`;
    const sel = document.getElementById('estimate-game-select');

    (games||[]).forEach(g=>{
      const opt=document.createElement('option');
      opt.value=g.id;
      opt.textContent=g.name;
      sel.appendChild(opt);
    });

    const current = window.currentDropdownId || customState?.activeGameId || (games?.[0]?.id||'');
    sel.value = current;

    sel.addEventListener('change', ()=>{
      window.currentDropdownId = sel.value;
      switchGameByIdSafe(sel.value);
    });
  }else{
    if(h.dataset.prevHtml !== undefined){
      h.innerHTML = h.dataset.prevHtml;
    }
  }
}

const CAT={BOOSTER:'booster',PREMIUM:'premium',EXTRA:'extra',STARTER:'starter',OTHER:'other',MANGA:'manga', PRECIOUS:'precious'};

function normalizePackCategoryKey(raw){
  const s = String(raw || '').trim();
  if(!s) return '';
  const n = s.toLowerCase().replace(/\s+/g,'').replace(/[＿_\-－]/g,'');
  if(/ブースター|booster|boost|pack/.test(n)) return CAT.BOOSTER;
  if(/スターター|スタートデッキ|starter|startdeck|deck/.test(n)) return CAT.STARTER;
  if(/エクストラ|extra|ex/.test(n)) return CAT.EXTRA;
  if(/プレミアム|premium|prb/.test(n)) return CAT.PREMIUM;
  if(/マンガ|manga|sb/.test(n)) return CAT.MANGA;
  if(/プレシャス|precious|pc/.test(n)) return CAT.PRECIOUS;
  if(/その他|other|others|etc/.test(n)) return CAT.OTHER;
  return n;
}

function getFirstNonEmpty(obj, keys){
  for(const k of keys){
    const v = obj?.[k];
    if(v !== undefined && v !== null && String(v).trim() !== '') return v;
  }
  return '';
}

function getPackServerCategoryRaw(pack){
  return getFirstNonEmpty(pack, [
    'category_key','categoryKey','pack_category_key','packCategoryKey','group_key','groupKey',
    'category','pack_category','packCategory','pack_type','packType','type','kind','group'
  ]);
}

function getPackServerCategoryLabel(pack){
  return getFirstNonEmpty(pack, [
    'category_label','categoryLabel','pack_category_label','packCategoryLabel',
    'pack_type_label','packTypeLabel','group_label','groupLabel','category_name','categoryName'
  ]);
}

function getPackServerCategorySort(pack){
  const v = getFirstNonEmpty(pack, [
    'category_sort','categorySort','pack_category_sort','packCategorySort',
    'pack_type_sort','packTypeSort','group_sort','groupSort'
  ]);
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
}

function categoryLabel(gameId,cat,pack){
  // CardPOS 側がカテゴリ名を持っている場合はそれを最優先で表示する
  const serverLabel = getPackServerCategoryLabel(pack);
  if(serverLabel) return String(serverLabel);

  if(gameId==='doragonboru-dropdown'&&cat===CAT.MANGA)return'マンガブースターパック';
  if(gameId==='onepiece-dropdown'&&cat===CAT.PREMIUM)return'プレミアムブースターパック';
  if(gameId==='UA-dropdown'&&cat===CAT.PRECIOUS)return'プレシャスブースターパック';
  if(cat===CAT.BOOSTER)return'ブースターパック';
  if(cat===CAT.EXTRA)return'エクストラブースターパック';
  if(cat===CAT.STARTER)return'スターターデッキ';
  if(cat===CAT.PREMIUM)return'プレミアムブースターパック';
  if(cat===CAT.MANGA)return'マンガブースターパック';
  if(cat===CAT.PRECIOUS)return'プレシャスブースターパック';
  return'その他';
}

function classifyPackByName(gameId,packName){
  const s=(packName||'').toUpperCase();
  if(/(スタータ|スタートデッキ|必勝祈願デッキ|【ST\d+】|\bST\d+\b|【GD-?ST\d+】|\bGD-?ST\d+\b)/i.test(packName))return CAT.STARTER;
  if(gameId==='doragonboru-dropdown'){
    if(/【SB/i.test(s))return CAT.MANGA;
    if(/【FB/i.test(s))return CAT.BOOSTER;
    if(/【FS/i.test(s))return CAT.STARTER;
    return CAT.OTHER;
  }
  switch(gameId){
    case'onepiece-dropdown':
      if(/PRB-\d+|【PRB/i.test(s))return CAT.PREMIUM;
      if(/【OP-\d+】/i.test(s))return CAT.BOOSTER;
      if(/【EB-\d+】|THE\s*BEST/i.test(s))return CAT.EXTRA;
      return CAT.OTHER;
    case'dejimon-dropdown':
      if(/【BT-\d+】/i.test(s))return CAT.BOOSTER;
      if(/【EX-\d+】/i.test(s))return CAT.EXTRA;
      if(/【RB-\d+】/i.test(s))return CAT.OTHER;
      return CAT.OTHER;
    case'UA-dropdown':
      if(/(?:[【\[]\s*UA[-\s]?\d{1,3}\s*[】\]]|\bUA[-\s]?\d{1,3}\b|UA\d+BT)/i.test(s))return CAT.BOOSTER;
      if(/UA\d+BT/i.test(s))return CAT.BOOSTER;
      if(/EX\d+BT/i.test(s))return CAT.EXTRA;
      if(/PC\d+BT/i.test(s))return CAT.PRECIOUS;
      return CAT.OTHER;
    case'ultraman-dropdown':
      if(/【BP-\d+】/i.test(s))return CAT.BOOSTER;
      return CAT.OTHER;
    case'pokeka-dropdown':{
      if(/-P】|SV-?P|S-?P|SM-?P|プロモ|特集/i.test(packName))return CAT.OTHER;
      if(/【M\d|【M1S|【M1L|【M2|【M3|【M4/i.test(s))return CAT.BOOSTER;
      if(/【SV(?!-?P)/i.test(s))return CAT.BOOSTER;
      if(/【SV8A|【SV9A/i.test(s))return CAT.BOOSTER;
      return CAT.OTHER;
    }
    case'gotoubunbright-dropdown':
      if(/GYC-BP/i.test(s))return CAT.BOOSTER;return CAT.OTHER;
    case'lorcana-dropdown':
      if(/【JA\d+】/i.test(s))return CAT.BOOSTER;return CAT.OTHER;
    case'gundam-dropdown':
      if(/【GD-?ST\d+】|\bGD-?ST\d+\b/i.test(packName))return CAT.STARTER;
      if(/【GD-?\d+】|\bGD-?\d+\b/i.test(packName))return CAT.BOOSTER;return CAT.OTHER;
    case'Xross-dropdown':
      if(/【BP\d+】/i.test(s))return CAT.BOOSTER;
      if(/【ST\d+】/i.test(s))return CAT.STARTER;return CAT.OTHER;
    case'FE-dropdown':
      if(/【FE-B\d+】/i.test(s))return CAT.BOOSTER;return CAT.OTHER;
    default:
      // ✅ コナンなど新規ゲームは CardPOS の category があればそちらを使う。
      // ここはあくまで category が無い場合の補助判定。
      if(/【CT-P\d+】|\bCT-P\d+\b/i.test(packName))return CAT.BOOSTER;
      if(/【CT-D\d+】|\bCT-D\d+\b/i.test(packName))return CAT.STARTER;
      if(/【HV-P/i.test(s))return CAT.BOOSTER;
      if(/【HV-D/i.test(s))return CAT.STARTER;
      if(/【EX|【EB|EX\d|EB-\d|PRB-|THE BEST/i.test(s))return CAT.EXTRA;
      if(/【BT|OP-\d|BP-\d|UA\d+BT|JA\d|SV\d|FB\d|B\d{2}】/i.test(s))return CAT.BOOSTER;
      return CAT.OTHER;
  }
}

function getPackCategoryMeta(gameId,pack){
  const raw = getPackServerCategoryRaw(pack);
  const label = getPackServerCategoryLabel(pack);
  if(raw || label){
    const key = normalizePackCategoryKey(raw || label) || CAT.OTHER;
    return {
      key,
      label: label ? String(label) : categoryLabel(gameId, key, pack),
      sort: getPackServerCategorySort(pack)
    };
  }
  const key = classifyPackByName(gameId, pack?.name || '');
  return {key, label: categoryLabel(gameId, key, pack), sort: null};
}

function classifyPack(gameId,packName,pack){
  return getPackCategoryMeta(gameId, pack || {name: packName}).key;
}


function markActivePackCard(packName){
  const target = String(packName || '');
  document.querySelectorAll('#pack-buttons .pack-card-pack').forEach(card=>{
    const on = String(card.dataset.packName || '') === target;
    card.classList.toggle('is-selected', on);
    if(on) card.setAttribute('aria-current','true');
    else card.removeAttribute('aria-current');
  });
}

function setPackListVisible(visible){
  const el = document.getElementById('pack-buttons');
  if(!el) return;
  if(visible){
    el.classList.remove('is-pack-list-hidden');
    el.style.display = 'block';
  }else{
    el.classList.add('is-pack-list-hidden');
    el.style.display = 'none';
    el.classList.remove('show');
  }
}


/* =============================================================
   UA専用：作品名で探せる横長パック一覧 (2026-10-25)
   CardPOSから公開済みのデータのみ利用。買取金額・カード表示は既存ロジックのまま。
   ============================================================= */
function getUAWorkPackIdentity(pack){
  const source = String(pack?.name || '').normalize('NFKC').trim();
  // [UA-01] / 【UA57】 / UA57BT / UA-10 の表記揺れに対応。
  const match = source.match(/(?:^|[\s【\[（(])UA\s*[-‐‑‒–—]?\s*0*(\d{1,3})(?:\s*BT)?(?=$|[\s】\]）)])/i);
  const number = match ? Number(match[1]) : null;
  const code = number === null ? '' : `UA-${String(number).padStart(2,'0')}`;
  const withoutCode = source
    .replace(/^[\s【\[（(]*UA\s*[-‐‑‒–—]?\s*\d{1,3}(?:\s*BT)?[\s】\]）)]*/i, '')
    .replace(/^[\s:：\/／|｜\-–—]+/, '')
    .trim();
  return { code, number, title: withoutCode || source || '作品名未設定' };
}

function renderUAPackWorkBrowser(game, packs, latestDate, openPack){
  const root = document.getElementById('pack-buttons');
  if(!root) return;
  root.classList.add('ua-pack-mode');
  root.innerHTML = '';

  // デジモン等のパック一覧と同様、メインコンテンツに直接展開する。
  // 外側の固定幅カード/額縁は作らない。
  const header=document.createElement('div');
  header.className='ua-catalog-header';
  header.setAttribute('aria-label','ユニオンアリーナ作品別買取表');

  const heading=document.createElement('div');
  heading.className='ua-catalog-heading';
  heading.innerHTML='<span class="ua-pack-eyebrow">UNION ARENA / 作品別</span>'+
    '<h2 class="ua-pack-heading">作品別買取表</h2>';
  header.appendChild(heading);

  const controls=document.createElement('div');
  controls.className='ua-catalog-controls';
  const total=document.createElement('span');
  total.className='ua-pack-total';
  controls.appendChild(total);

  const sort=document.createElement('select');
  sort.className='ua-pack-sort';
  sort.setAttribute('aria-label','作品の並べ替え');
  [
    ['code','UA番号が新しい順'],
    ['release','発売日が新しい順'],
    ['title','作品名順']
  ].forEach(([value,label])=>{
    const option=document.createElement('option');
    option.value=value;option.textContent=label;sort.appendChild(option);
  });
  controls.appendChild(sort);
  header.appendChild(controls);

  const grid=document.createElement('div');
  grid.className='ua-pack-grid';
  const note=document.createElement('p');
  note.className='ua-pack-note';
  note.textContent=isAdminView()
    ? '管理者表示：公開前の作品も含まれる場合があります。'
    : '※ 現在、買取価格が公開されている作品のみ表示しています。未公開の作品は表示されません。';
  root.append(header,grid,note);

  const entries=packs.map((pack,i)=>({pack,index:i,identity:getUAWorkPackIdentity(pack)}));

  function draw(){
    const found=entries.slice();
    const choice=sort.value;
    found.sort((a,b)=>{
      if(choice==='title')return a.identity.title.localeCompare(b.identity.title,'ja') || a.index-b.index;
      if(choice==='release')return (Date.parse(b.pack.releaseDate||b.pack.release_date||'')||0)-(Date.parse(a.pack.releaseDate||a.pack.release_date||'')||0) || a.index-b.index;
      const an=a.identity.number, bn=b.identity.number;
      if(an!==null && bn!==null && an!==bn)return bn-an;
      if(an===null && bn!==null)return 1;
      if(bn===null && an!==null)return -1;
      return (Date.parse(b.pack.releaseDate||b.pack.release_date||'')||0)-(Date.parse(a.pack.releaseDate||a.pack.release_date||'')||0) || a.index-b.index;
    });
    total.textContent=`公開中 ${entries.length} 作品`;
    grid.replaceChildren();
    if(!found.length){
      const empty=document.createElement('p');
      empty.className='ua-pack-empty';
      empty.textContent='現在表示できる作品がありません。';
      grid.appendChild(empty);
      return;
    }
    const fragment=document.createDocumentFragment();
    found.forEach(({pack,identity})=>{
      const button=document.createElement('button');
      button.type='button';
      button.className='ua-pack-card';
      button.dataset.packName=pack.name||'';
      button.setAttribute('aria-label',`${identity.code||''} ${identity.title}の買取表を開く`);
      const imageBox=document.createElement('div');
      imageBox.className='ua-pack-image';
      const packImage = getPackImageUrl(pack);
      if(packImage){
        const img=document.createElement('img');
        img.src=getProxyImageUrl(packImage);
        img.alt=`${identity.title} パック画像`;
        img.loading='lazy';img.draggable=false;
        imageBox.appendChild(img);
      }else{
        const placeholder=document.createElement('span');
        placeholder.className='ua-pack-placeholder';
        placeholder.textContent='UNION ARENA';
        imageBox.appendChild(placeholder);
      }
      if(identity.code){
        const code=document.createElement('span');
        code.className='ua-pack-code';
        code.textContent=identity.code;
        imageBox.appendChild(code);
      }
      const info=document.createElement('div');
      info.className='ua-pack-info';
      const name=document.createElement('span');
      name.className='ua-pack-name';
      name.textContent=identity.title;
      name.title=identity.title;
      const arrow=document.createElement('span');
      arrow.className='ua-pack-arrow';
      arrow.textContent='›';arrow.setAttribute('aria-hidden','true');
      info.append(name,arrow);
      button.append(imageBox,info);
      if(pack.releaseDate && latestDate && pack.releaseDate === latestDate){
        const latest=document.createElement('span');
        latest.className='ua-pack-latest';latest.textContent='最新弾';
        button.appendChild(latest);
      }
      button.addEventListener('click',()=>openPack(pack));
      fragment.appendChild(button);
    });
    grid.appendChild(fragment);
  }
  sort.addEventListener('change',draw);
  draw();
  triggerFade(root);
}

function renderPackButtons(game){
  const now=new Date();
  const container=$('#pack-buttons');
  container.innerHTML='';
  container.classList.remove('ua-pack-mode');
  container.classList.remove('is-pack-list-hidden');
  container.style.display='block';

  const allPacks=(game.packs||[]).filter(p=>{
    const released = (!p.releaseDate || new Date(p.releaseDate) <= now);
    const visible = isAdminView() ? true : Number(p?.visibleCount || 0) > 0;
    return released && visible;
  });
  const dated=allPacks.filter(p=>p.releaseDate).sort((a,b)=>new Date(b.releaseDate)-new Date(a.releaseDate));
  const latestDate=dated[0]?.releaseDate||'';

  const buckets={};
  const catMetaByKey=new Map();
  allPacks.forEach((p, i)=>{
    const meta=getPackCategoryMeta(game.id,p);
    const cat=meta.key || CAT.OTHER;
    p._cat=cat;
    p._catLabel=meta.label || categoryLabel(game.id, cat, p);
    p._catSort=(meta.sort!==null&&meta.sort!==undefined)?meta.sort:i;
    if(!catMetaByKey.has(cat)){
      catMetaByKey.set(cat,{key:cat,label:p._catLabel,sort:p._catSort,firstIndex:i});
    }
    (buckets[cat] ||= []).push(p);
  });

  let order;
  if(game.id==='doragonboru-dropdown'){order=[CAT.OTHER,CAT.BOOSTER,CAT.MANGA,CAT.STARTER,CAT.EXTRA]}
  else if(game.id==='onepiece-dropdown'){order=[CAT.OTHER,CAT.BOOSTER,CAT.EXTRA,CAT.PREMIUM,CAT.STARTER]}
  else if(game.id==='UA-dropdown'){order=[CAT.OTHER,CAT.BOOSTER,CAT.EXTRA,CAT.PRECIOUS,CAT.STARTER]}
  else{order=[CAT.OTHER,CAT.BOOSTER,CAT.EXTRA,CAT.STARTER]}

  const fallbackIndex = new Map(order.map((x,i)=>[x,i]));
  const availableCats=Object.keys(buckets).sort((a,b)=>{
    const ma=catMetaByKey.get(a)||{};
    const mb=catMetaByKey.get(b)||{};
    const as=Number.isFinite(Number(ma.sort))?Number(ma.sort):null;
    const bs=Number.isFinite(Number(mb.sort))?Number(mb.sort):null;
    if(as!==null || bs!==null){
      if(as===null)return 1;
      if(bs===null)return -1;
      if(as!==bs)return as-bs;
    }
    const ai=fallbackIndex.has(a)?fallbackIndex.get(a):999;
    const bi=fallbackIndex.has(b)?fallbackIndex.get(b):999;
    if(ai!==bi)return ai-bi;
    return (ma.firstIndex??999)-(mb.firstIndex??999);
  });

  if(!allPacks.length){
    container.innerHTML = `
      <div class="empty-pack-state">
        <div class="empty-pack-card">
          <h2 class="empty-pack-title">現在このゲームの買取表は準備中です</h2>
          <p class="empty-pack-sub">公開までしばらくお待ちください。</p>
        </div>
      </div>`;
    const sheet=document.getElementById('sheet-container'); if(sheet) sheet.innerHTML='';
    const heading=document.getElementById('heading-text'); if(heading) heading.innerText=(game.name||'')+'｜買取表準備中';
    triggerFade(container);
    return;
  }

  const bar=document.createElement('div');
  bar.className='cat-bar';
  const btnAll=document.createElement('button');
  btnAll.className='cat-btn active';btnAll.textContent='すべて';btnAll.dataset.cat='all';
  bar.appendChild(btnAll);
  availableCats.forEach(c=>{
    const b=document.createElement('button');
    b.className='cat-btn';b.textContent=(catMetaByKey.get(c)?.label || categoryLabel(game.id,c));b.dataset.cat=c;
    bar.appendChild(b);
  });
  container.appendChild(bar);

  const openPackFromCard=(pack)=>{
    if(!pack || !pack.name) return;
    // パックを選択したら、パック一覧を閉じて買取表だけを表示する。
    // 別パックへ戻る場合は、商品一覧上部の「← パック一覧に戻る」から再表示する。
    setPackListVisible(false);
    markActivePackCard(pack.name);
    loadProducts(pack.name, sheetMap[game.id]);
    window.currentSheetTitle=pack.name;
  };

  // UAは作品別の横長カードで表示。従来の「その他」カテゴリを使わない。
  if(game.id==='UA-dropdown'){
    renderUAPackWorkBrowser(game, allPacks, latestDate, openPackFromCard);
    return;
  }
  container.classList.remove('ua-pack-mode');

  const makeCard=(pack)=>{
    const wrap=document.createElement('div');
    wrap.className='pack-wrapper';
    wrap.style.pointerEvents='auto';

    const isLatest=!!(pack.releaseDate&&latestDate&&pack.releaseDate===latestDate);
    if(isLatest){
      const badge=document.createElement('div');
      badge.className='latest-badge-outside';
      badge.innerText='最新弾!';
      badge.setAttribute('aria-hidden','true');
      wrap.appendChild(badge);
    }

    const card=document.createElement('div');
    card.className='pack-card-pack';
    card.dataset.packName=pack.name||'';
    card.setAttribute('role','button');
    card.setAttribute('tabindex','0');
    card.setAttribute('aria-label',`${pack.name || ''} の買取表を開く`);
    card.style.pointerEvents='auto';

    const packImage = getPackImageUrl(pack);
    if(packImage){
      const img=document.createElement('img');
      img.src=getProxyImageUrl(packImage);
      img.alt=pack.name;
      img.loading='lazy';
      img.draggable=false;
      card.appendChild(img);
    }

    const label=document.createElement('p');
    label.textContent=pack.name;
    card.appendChild(label);

    const open=(event)=>{
      if(event){
        event.preventDefault();
        event.stopPropagation();
      }
      openPackFromCard(pack);
    };

    card.addEventListener('click', open);
    card.addEventListener('keydown', (event)=>{
      if(event.key==='Enter' || event.key===' '){
        open(event);
      }
    });

    wrap.appendChild(card);
    return wrap;
  };

  const content=document.createElement('div');
  content.className='pack-groups';
  container.appendChild(content);

  const renderByCat=(cat)=>{
    bar.querySelectorAll('.cat-btn').forEach(b=>b.classList.toggle('active',b.dataset.cat===(cat||'all')));
    content.innerHTML='';
    if(cat&&cat!=='all'){
      const grid=document.createElement('div');
      grid.className='pack-group pack-group-grid';
      (buckets[cat]||[]).forEach(p=>grid.appendChild(makeCard(p)));
      content.appendChild(grid);
    }else{
      availableCats.forEach(c=>{
        const group=document.createElement('div');group.className='pack-group';
        const title=document.createElement('div');title.className='pack-group-title';title.textContent=(catMetaByKey.get(c)?.label || categoryLabel(game.id,c));
        const grid=document.createElement('div');grid.className='pack-group-grid';
        (buckets[c]||[]).forEach(p=>grid.appendChild(makeCard(p)));
        group.appendChild(title);group.appendChild(grid);
        content.appendChild(group);
      });
    }
    triggerFade(container);
  };

  renderByCat('all');
  bar.addEventListener('click',(e)=>{
    const btn=e.target.closest('.cat-btn');
    if(!btn)return;
    renderByCat(btn.dataset.cat||'all');
  });
}

let _currentView='card';

function loadProducts(packName,url){
  const landing = document.getElementById('game-landing');
  if(landing) landing.style.display = 'none';

  setPackListVisible(false);
  markActivePackCard(packName);

  const tbtn=document.getElementById('tweet-btn');
  if(tbtn)tbtn.style.display='none';

  veilFlash(()=>{
    $('#heading-text').innerText=packName+' の買取表';
    $('#sheet-container').innerHTML=`<div class="loading-wrapper"><span>読み込み中</span><div class="loading-dots"><span></span><span></span><span></span></div></div>`;
  });

  if(!url){$('#sheet-container').innerHTML='<p style="text-align:center;">API URL が未設定です</p>';return;}

  const admin = isAdminView();
  const qs=new URLSearchParams({sheet:packName,exact:'1',hide_zero:admin?'0':'1'});
  if(admin) qs.set('include_unpublished','1');
  fetch(`${url}?${qs.toString()}`)
    .then(r=>r.json())
    .then(json=>{
      smoothSwap('#sheet-container',()=>{
        renderProductList(json.products||json.data||[],getUpdatedFromResponse(json));
        if(isAdminView()&&tbtn)tbtn.style.display='inline-flex';
        window.isProductListReady=true;
      });
      if(AUTOSCROLL_ON_LOAD){requestAnimationFrame(()=>{ensureAllLoaded().catch(()=>{})})}
    })
    .catch(e=>{
      console.error(e);
      $('#sheet-container').innerHTML='<p style="text-align:center;color:#c00">ネットワークエラー：Failed to fetch</p>';
      window.isProductListReady=false;
      if(tbtn)tbtn.style.display='none';
    });
}

function attachSearchBar(){
  if(!ENABLE_SEARCH)return null;
  const container=document.createElement('div');
  container.className='search-wrap';
  container.innerHTML=`<div class="search-bar"><input id="search-input" class="search-input" type="search" placeholder="カード名で検索（/ 快捷键）" /><button id="search-clear" class="search-clear">クリア</button></div>`;
  return container;
}
function makeViewSwitch(onChange){
  const wrap=document.createElement('div');
  wrap.className='view-switch';
  wrap.innerHTML=`<button class="view-btn" data-view="group">グループ表示</button><button class="view-btn" data-view="list">リスト表示</button><button class="view-btn" data-view="card">カード表示</button>`;
  const setActive=()=>{wrap.querySelectorAll('.view-btn').forEach(b=>b.classList.toggle('active',b.dataset.view===_currentView))};
  wrap.addEventListener('click',e=>{
    const btn=e.target.closest('.view-btn');if(!btn)return;
    const v=btn.dataset.view;
    if(v&&v!==_currentView){_currentView=v;setActive();onChange?.(v);}
  });
  setActive();
  return wrap;
}

function renderProductList(items,updated){
  const sc=$('#sheet-container');sc.innerHTML='';
  const searchNode=attachSearchBar();if(searchNode)sc.appendChild(searchNode);

  if(updated){
    const d=new Date(updated);
    $('#update-time').innerText=`最終更新：${d.getFullYear()}/${d.getMonth()+1}/${d.getDate()} ${('0'+d.getHours()).slice(-2)}:${('0'+d.getMinutes()).slice(-2)}`;
  }

  const visibleItems=isAdminView() ? (items||[]) : (items||[]).filter(hasPublicBuyPrice);
  const std=visibleItems.map(it=>{
    const name=String(it.productName??it.name??'').trim();
    const price=Number(it.productPrice??it.price??0);
    const img=it.productImageUrl||'';
    const rarity=parseRarity(name,it,window.currentDropdownId);
    const psa10Price = getPsa10BuyPrice(it);
    const psa10Enabled = isPsa10BuyEnabled(it);
    return {name,price,img,rarity,raw:it,psa10Price,psa10BuyPrice:psa10Price,psa10Enabled,psa10BuyEnabled:psa10Enabled};
  });

  const priceDesc=std.slice().sort((a,b)=>b.price-a.price);

  const order=getGameRarityOrder(window.currentDropdownId);
  const idx=r=>{
    const target = normalizeRarityForCompare(r);
    const i = order.findIndex(x=>normalizeRarityForCompare(x)===target);
    return i>=0?i:999;
  };
  const groups={};
  std.forEach(p=>{(groups[p.rarity] ||= []).push(p)});
  const sortedKeys=Object.keys(groups).sort((a,b)=>idx(a)-idx(b));
  sortedKeys.forEach(k=>groups[k].sort((a,b)=>b.price-a.price));

  const root=document.createElement('div');

  // ✅ 添加"返回按钮 + 视图切换"的容器
  const topBar = document.createElement('div');
  topBar.className = 'buyback-product-toolbar';
  topBar.style.cssText = 'display:flex;gap:12px;align-items:center;justify-content:center;margin:6px auto 8px;padding:0 10px;max-width:1100px;flex-wrap:wrap;';
  
  // ✅ 返回卡包按钮
  const backBtn = document.createElement('button');
  backBtn.className = 'view-btn back-btn';
  backBtn.innerHTML = '← パック一覧に戻る';
  backBtn.addEventListener('click', ()=>{
    const gameId = window.currentDropdownId;
    const game = (games||[]).find(g => g.id === gameId);
    if(game){
      window.currentSheetTitle = '';
      handleGameSelect(game);
    }
  });
  
  topBar.appendChild(backBtn);
  
  const viewSwitch = makeViewSwitch(()=>renderMode(_currentView));
  viewSwitch.style.margin = '0';
  topBar.appendChild(viewSwitch);
  
  sc.appendChild(topBar);

  const priceNotice = document.createElement('div');
  priceNotice.className = 'buyback-notice buyback-notice-product';
  priceNotice.setAttribute('role', 'note');
  priceNotice.textContent = '買取価格は在庫状況・状態・相場により、予告なく変更となる場合がございます。';
  sc.appendChild(priceNotice);

  sc.appendChild(root);

  function updateRaritySectionVisibility(){
    if(_currentView!=='group')return;
    root.querySelectorAll('.rare-section').forEach(sec=>{
      const cards=Array.from(sec.querySelectorAll('.pack-card-product'));
      const visible=cards.filter(c=>c.style.display!=='none').length;
      const badge=sec.querySelector('.rare-badge');
      if(badge)badge.textContent=visible;
      sec.style.display=visible?'':'none';
    });
  }

  function makeCardProduct(p){
    const card=document.createElement('div');card.className='pack-card-product';
    if(p.img){
      const img=document.createElement('img');
      img.src=getProxyImageUrl(p.img);img.alt=p.name;img.loading='lazy';
      card.appendChild(img);
    }
    const name=document.createElement('p');name.textContent=p.name;name.title=p.name;card.appendChild(name);
    const sub=document.createElement('div');sub.style.cssText='font-size:12px;color:#6b7280;margin-bottom:8px;font-weight:700';sub.textContent=p.rarity;card.appendChild(sub);
    appendBuyPriceBlock(card,p);

    if(isAdminView()){
      const btn=document.createElement('button');btn.className='add-estimate-btn';btn.textContent='＋見積に追加';
      const add=()=>{if(!estimateMode)return;addToEstimate({name:p.name,packName:window.currentSheetTitle||'',img:getProxyImageUrl(p.img),price:p.price,qty:1,cond:ALLOWED_CONDS[0]})};
      btn.addEventListener('click',e=>{e.stopPropagation();add()});
      card.addEventListener('click',add);
      card.style.cursor=estimateMode?'pointer':'default';
      card.appendChild(btn);
    }
    return card;
  }

  function renderMode(view){
    root.innerHTML='';
    sc.classList.remove('group-mode','list-mode','card-mode');
    sc.classList.add(`${view}-mode`);

    if(view==='group'){
      sortedKeys.forEach(key=>{
        const section=document.createElement('section');section.className='rare-section';
        const title=document.createElement('div');title.className='rare-title';
        title.innerHTML=`<span class="rare-text">${key}</span><span class="rare-badge" data-count>${groups[key].length}</span>`;
        section.appendChild(title);
        const grid=document.createElement('div');grid.className='rare-grid';
        groups[key].forEach(p=>grid.appendChild(makeCardProduct(p)));
        section.appendChild(grid);
        root.appendChild(section);
      });
    }else if(view==='list'){
      const list=document.createElement('div');list.className='product-list';
      priceDesc.forEach(p=>{
        const row=document.createElement('div');row.className='row';
        const im=document.createElement('img');im.src=getProxyImageUrl(p.img);im.loading='lazy';
        const info=document.createElement('div');info.innerHTML=`<div class="nm">${p.name}</div><div class="sub">${p.rarity}</div>`;
        const pr=document.createElement('div');pr.className='yen';
        const psa10=getPsa10BuyPrice(p);
        pr.innerHTML = `${p.price>0?money(p.price):'-'}${isPsa10BuyEnabled(p)&&psa10>0?`<div style="font-size:11px;color:#7c3aed;font-weight:1000;margin-top:3px">PSA10 ${money(psa10)}</div>`:''}`;
        const add=document.createElement('div');add.style.textAlign='right';
        if(isAdminView()){
          const b=document.createElement('button');b.textContent='＋見積';b.style.cssText='padding:8px 10px;border:none;border-radius:8px;background:#0f766e;color:#fff;font-weight:800;cursor:pointer';
          b.onclick=()=>addToEstimate({name:p.name,packName:window.currentSheetTitle,img:getProxyImageUrl(p.img),price:p.price,qty:1,cond:ALLOWED_CONDS[0]});
          add.appendChild(b);
        }
        row.append(im,info,pr,add);
        list.appendChild(row);
      });
      root.appendChild(list);
    }else{
      const grid=document.createElement('div');grid.className='product-grid';
      priceDesc.forEach(p=>grid.appendChild(makeCardProduct(p)));
      root.appendChild(grid);
    }
  }
  renderMode(_currentView);

  if(ENABLE_SEARCH){
    const input=document.getElementById('search-input');
    const clear=document.getElementById('search-clear');
    const doFilter=()=>{
      const q=(input.value||'').trim().toLowerCase();
      if(_currentView==='group'){
        root.querySelectorAll('.pack-card-product').forEach(el=>{
          const nm=(el.getAttribute('data-nm')||'').toLowerCase();
          el.style.display=!q||nm.includes(q)?'':'none';
        });
        updateRaritySectionVisibility();
      }else{
        root.querySelectorAll('.row,.pack-card-product').forEach(el=>{
          const nm=(el.getAttribute('data-nm')||'').toLowerCase();
          el.style.display=!q||nm.includes(q)?'':'none';
        });
      }
    };
    input?.addEventListener('input',doFilter);
    clear?.addEventListener('click',()=>{input.value='';doFilter();input.focus()});
    window.addEventListener('keydown',(e)=>{if(e.key==='/'&&document.activeElement!==input){e.preventDefault();input?.focus()}});
    root.querySelectorAll('.pack-card-product').forEach(el=>{
      const t=el.querySelector('p')?.textContent||'';
      el.setAttribute('data-nm',t);
    });
    updateRaritySectionVisibility();
  }else{
    root.querySelectorAll('.pack-card-product').forEach(el=>{
      const t=el.querySelector('p')?.textContent||'';
      el.setAttribute('data-nm',t);
    });
  }
}

const STATUS_KEY='buy_status_v1';
let _bsPushTimer=null;
function getAllBrands(){return Array.from(new Set((games||[]).map(g=>g.name)))}
function normalizeStatus(s){
  const all=getAllBrands();
  const out={active:[],paused:[]};
  const A=Array.isArray(s?.active)?s.active:[];
  const B=Array.isArray(s?.paused)?s.paused:[];
  out.active=A.filter(x=>all.includes(x));
  out.paused=B.filter(x=>all.includes(x)&&!out.active.includes(x));
  all.forEach(b=>{if(!out.active.includes(b)&&!out.paused.includes(b))out.paused.push(b)});
  return out;
}
function loadStatusLocal(){
  const all=getAllBrands();
  const defaultsActive=all.slice(0,Math.min(6,all.length));
  let s=null;
  try{s=JSON.parse(localStorage.getItem(STATUS_KEY)||'')}catch(_){}
  if(!s||!Array.isArray(s.active)||!Array.isArray(s.paused)){
    s={active:defaultsActive,paused:all.filter(x=>!defaultsActive.includes(x))};
  }
  return normalizeStatus(s);
}
function saveStatusLocal(s){try{localStorage.setItem(STATUS_KEY,JSON.stringify(normalizeStatus(s)))}catch(_){ }}
async function fetchStatusRemote(){
  try{
    const r=await fetch(`${STATUS_API}?mode=get`,{method:'GET',cache:'no-store'});
    const j=await r.json();
    if(j&&(j.active||j.paused))return normalizeStatus(j);
  }catch(_){}
  return null;
}
async function pushStatusRemote(s){
  try{
    await fetch(STATUS_API,{method:'POST',headers:{'Content-Type':'text/plain;charset=UTF-8'},body:JSON.stringify({key:STATUS_TOKEN,active:s.active||[],paused:s.paused||[]}),mode:'cors',credentials:'omit'});
  }catch(_){}
}
function schedulePushRemote(s){
  if(!isAdminView())return;
  clearTimeout(_bsPushTimer);
  _bsPushTimer=setTimeout(()=>pushStatusRemote(s),350);
}

function renderBuyStatus(){
  const wrap=$('#buy-status');if(!wrap)return;
  const s=loadStatusLocal();
  const admin=isAdminView();
  const actionsHtml=admin?`<div id="status-actions" style="text-align:center;margin-top:10px"><button id="bs-tweet" class="tweet-button">一键发推（今日買取リスト）</button></div>`:'';
  wrap.innerHTML=`
    <div class="status-grid">
      <div class="status-col buying"><div class="col-head">本日買取中</div><div class="col-body" id="bs-buying"></div></div>
      <div class="status-col stop"><div class="col-head">本日買取停止中</div><div class="col-body" id="bs-stop"></div></div>
    </div>${actionsHtml}`;
  const addChip=(name,which)=>{
    const b=document.createElement('button');b.type='button';b.className='brand-chip'+(admin?' editable':'');b.textContent=name;
    if(admin){
      b.title=which==='buy'?'クリックで「停止中」に移動':'クリックで「買取中」に移動';
      b.addEventListener('click',()=>{
        const cur=loadStatusLocal();
        if(which==='buy'){cur.active=cur.active.filter(x=>x!==name);if(!cur.paused.includes(name))cur.paused.push(name)}
        else{cur.paused=cur.paused.filter(x=>x!==name);if(!cur.active.includes(name))cur.active.push(name)}
        const norm=normalizeStatus(cur);
        saveStatusLocal(norm);renderBuyStatus();schedulePushRemote(norm);
      });
    }
    (which==='buy'?$('#bs-buying'):$('#bs-stop')).appendChild(b);
  };
  s.active.forEach(n=>addChip(n,'buy'));
  s.paused.forEach(n=>addChip(n,'stop'));
  if(admin){$('#bs-tweet')?.addEventListener('click',tweetBuyStatus)}
  triggerFade(wrap);
}
async function tweetBuyStatus(){
  const node=$('#buy-status');if(!node)return;
  try{const r=await fetchStatusRemote();if(r){saveStatusLocal(r)}}catch(_){}
  const s=loadStatusLocal();
  const formatList=(arr)=>arr.map(n=>'・#'+(n||'').replace(/\s+/g,'').trim()).join('\n')||'・なし';
  const now=new Date();const y=now.getFullYear();const m=('0'+(now.getMonth()+1)).slice(-2);const d=('0'+now.getDate()).slice(-2);
  const text=[
    '📢 本日の買取状況',`更新日：${y}/${m}/${d}`,'',
    '🟢【買取中】',formatList(s.active),'',
    '⛔【買取停止】',formatList(s.paused),'',
    '🔗 本日の全リスト・他タイトルはこちら👇',
    'https://torekanobankoku.com/pages/kaitorihyou','',
    ...POSTAL_BUY_TWEET_LINES,'',
    '※相場・在庫・状態により変動します。','#買取 #トレカの万国 #秋葉原'
  ].join('\n');
  const cloneWrapper=document.createElement('div');
  cloneWrapper.style.position='absolute';cloneWrapper.style.top='-9999px';cloneWrapper.style.left='0';cloneWrapper.style.width=node.offsetWidth+'px';
  const clone=node.cloneNode(true);const acts=clone.querySelector('#status-actions');if(acts)acts.remove();
  cloneWrapper.appendChild(clone);document.body.appendChild(cloneWrapper);
  const canvas=await html2canvas(clone,{useCORS:true,backgroundColor:'#ffffff',scale:window.devicePixelRatio||1});
  const fileName=`本日買取状況_${y}${m}${d}.png`;
  await new Promise(resolve=>{
    canvas.toBlob(blob=>{
      const url=URL.createObjectURL(blob);
      const a=document.createElement('a');a.href=url;a.download=fileName;a.click();
      setTimeout(()=>URL.revokeObjectURL(url),3000);resolve();
    });
  });
  cloneWrapper.remove();
  openOriginalTweetOnX(text);
}
function showStatusBoard(){
  const el=$('#buy-status');if(!el)return;
  renderBuyStatus();
  el.style.display='block';
  (async()=>{const r=await fetchStatusRemote();if(r){saveStatusLocal(r);renderBuyStatus()}})();
  if(!isAdminView()){
    if(window._bsPoll)clearInterval(window._bsPoll);
    window._bsPoll=setInterval(async()=>{
      const r=await fetchStatusRemote();
      if(r){saveStatusLocal(r);renderBuyStatus()}
    },60000);
  }
}
function hideStatusBoard(){const el=document.getElementById('buy-status');if(el)el.style.display='none';if(window._bsPoll){clearInterval(window._bsPoll);window._bsPoll=null}}

const CUSTOM_BUY_KEY = 'custom_buy_table_v1';
let customMode = false;
let customState = { activeGameId: '', tables: {} };

function loadCustomState(){
  let s=null;
  try{s=JSON.parse(localStorage.getItem(CUSTOM_BUY_KEY)||'')}catch(_){s=null}
  if(!s || typeof s!=='object') s={activeGameId:'',tables:{}};
  if(!s.tables || typeof s.tables!=='object') s.tables={};

  // v38 migration:
  // 自定义表は手入力価格(price)を正とし、旧データに残ったnormalPriceを同期する。
  // 画像URLも旧版のプロキシ済み状態から元URLへ戻し、書き出し時に一度だけプロキシ化する。
  Object.keys(s.tables).forEach(gameId=>{
    const list = Array.isArray(s.tables[gameId]) ? s.tables[gameId] : [];
    s.tables[gameId] = list.map(raw=>{
      const item = (raw && typeof raw === 'object') ? {...raw} : {};
      const currentPrice = readMoneyNumber(item.price ?? item.normalPrice);
      item.price = currentPrice;
      item.normalPrice = currentPrice;
      if(item.img) item.img = unwrapProxyImageUrl(item.img);
      return item;
    });
  });

  const fallback = window.currentDropdownId || (games?.[0]?.id||'');
  if(!s.activeGameId || !sheetMap[s.activeGameId]) s.activeGameId = fallback;
  try{ localStorage.setItem(CUSTOM_BUY_KEY, JSON.stringify(s)); }catch(_){}
  return s;
}
function saveCustomState(){
  try{localStorage.setItem(CUSTOM_BUY_KEY, JSON.stringify(customState))}catch(_){}
}
function getCustomList(gameId){
  const arr = customState.tables?.[gameId];
  return Array.isArray(arr)?arr:[];
}
function setCustomList(gameId, list){
  customState.tables[gameId] = Array.isArray(list)?list:[];
  saveCustomState();
}
function customTotal(gameId){
  return getCustomList(gameId).reduce((s,x)=>s+(Number(x.price)||0),0);
}

const MAIN_HIDE_IDS = ['game-tabs','game-landing','pack-buttons','sheet-container','buy-status'];
function _hideElById(id){
  const el=document.getElementById(id);
  if(!el) return;
  if(el.dataset.prevDisplay===undefined) el.dataset.prevDisplay = el.style.display || '';
  el.style.display='none';
}
function _showElById(id){
  const el=document.getElementById(id);
  if(!el) return;
  const prev = el.dataset.prevDisplay;
  el.style.display = (prev!==undefined ? prev : '');
}
function setMainAreaHidden(hidden){
  MAIN_HIDE_IDS.forEach(id=> hidden ? _hideElById(id) : _showElById(id));
}

function setCustomMode(on){
  if(!isAdminView()) return;
  customMode = !!on;

  const btn = document.getElementById('dock-custom');
  if(btn) btn.textContent = `自定义買取表：${customMode?'ON':'OFF'}`;

  setMainAreaHidden(customMode);

  const topTweet = document.getElementById('tweet-btn');
  if(topTweet) topTweet.style.display='none';

  const estBtn = document.getElementById('dock-estimate');
  if(estBtn) estBtn.disabled = customMode;
  if(customMode){
    setEstimateMode(false);
    toggleEstimatePanel(false);
  }

  const dockTweet = document.getElementById('dock-tweet');
  if(dockTweet) dockTweet.textContent = customMode ? '一鍵発推（自定义）' : '一鍵発推';

  const builder = document.getElementById('custom-builder');
  if(!builder) return;

  if(customMode){
    customState = loadCustomState();
    builder.classList.add('show');
    renderCustomBuilder();
    const h = document.getElementById('heading-text');
    if(h){
      h.style.cursor='pointer';
      if(h.dataset.prevText===undefined) h.dataset.prevText = h.textContent || '';
      h.textContent='自定义買取表';
    }
    const ut = document.getElementById('update-time');
    if(ut) ut.textContent='';
  }else{
    builder.classList.remove('show');
    builder.innerHTML='';
    const h = document.getElementById('heading-text');
    if(h && h.dataset.prevText!==undefined){
      h.textContent = h.dataset.prevText;
      h.style.cursor='';
    }
  }
}

function renderCustomBuilder(){
  if(!isAdminView()) return;
  const builder = document.getElementById('custom-builder');
  if(!builder) return;

  customState = loadCustomState();
  const activeId = customState.activeGameId || (games?.[0]?.id||'');
  const activeGame = (games||[]).find(g=>g.id===activeId) || (games?.[0]||null);

  builder.innerHTML = `
    <div class="cb-grid">
      <div class="cb-card">
        <div class="cb-head">
          <div class="cb-title">検索 → 自定义買取表へ追加</div>
          <div class="cb-controls">
            <select id="cb-game"></select>
          </div>
        </div>
        <div class="cb-body">
          <div class="hero-sub" style="margin:0 0 10px; color:#64748b; font-size:12px; line-height:1.55;">
            例：<b>ルフィ r:SEC</b> / <b>SR</b> / <b>LR*</b>（稀有度快捷键在下方）<br>
            ※ 初回検索はこのタイトルの全パックを読み込みます。
          </div>
          <div class="global-search">
            <input id="cb-search-input" type="search" placeholder="カード名 / SR / r:SEC★ / LR*" />
            <button id="cb-search-clear">クリア</button>
          </div>

          <div class="hero-title hero-title-rarity" style="margin-top:10px;">稀有度</div>
          <div class="rarity-bar" id="cb-rarity-bar"></div>

          <div class="cb-meta">
            <span class="meta-chip">結果：<b id="cb-count">0</b></span>
            <span class="meta-chip muted" id="cb-progress">未検索</span>
            <button id="cb-tweet" class="search-tweet-btn" disabled>自定义表一鍵発推</button>
          </div>

          <div class="cb-results" id="cb-results"></div>
        </div>
      </div>

      <div class="cb-card">
        <div class="cb-head">
          <div class="cb-title">自定义買取表</div>
          <div class="cb-controls cb-controls-right">
            <span class="meta-chip">品目：<b id="cb-table-count">0</b></span>
            <button id="cb-reset" class="btn-pill-grey">表をクリア</button>
          </div>
        </div>

        <div class="cb-list" id="cb-table-list"></div>
        <div class="cb-sum">
          <span class="meta-chip muted">※价格可手动改。重复项目可重复添加。</span>
        </div>
      </div>
    </div>
  `;

  const sel = document.getElementById('cb-game');
  (games||[]).forEach(g=>{
    const opt=document.createElement('option');
    opt.value=g.id; opt.textContent=g.name;
    sel.appendChild(opt);
  });
  sel.value = activeGame?.id || '';
  sel.addEventListener('change', ()=>{
    cancelActiveSearch();
    customState.activeGameId = sel.value;
    saveCustomState();
    renderCustomBuilder();
  });

  const heading = document.getElementById('heading-text');
  if(heading){
    heading.onclick = ()=>{
      if(customMode) document.getElementById('cb-search-input')?.focus();
    };
  }

  function renderCustomTable(){
    const gid = customState.activeGameId;
    const list = getCustomList(gid);

    const listEl = document.getElementById('cb-table-list');
    const cntEl  = document.getElementById('cb-table-count');
    const twBtn  = document.getElementById('cb-tweet');

    if(cntEl) cntEl.textContent = String(list.length);
    if(twBtn) twBtn.disabled = list.length===0;

    if(!listEl) return;
    listEl.innerHTML = '';

    list.forEach(it=>{
      const row=document.createElement('div');
      row.className='cb-item';

      const thumb=document.createElement('div');
      thumb.className='cb-thumb';
      thumb.innerHTML = `<img src="${getProxyImageUrl(it.img||'')}" alt="">`;

      const info=document.createElement('div');
      info.className='cb-info';

      const nm=document.createElement('div');
      nm.className='cb-name';
      nm.textContent = it.name||'';

      const sub=document.createElement('div');
      sub.className='cb-sub';
      sub.textContent = [it.rarity||'', it.packName||''].filter(Boolean).join(' / ');

      const ctr=document.createElement('div');
      ctr.className='cb-row';

      const lab=document.createElement('label');
      lab.textContent='単価';

      const price=document.createElement('input');
      price.type='number';
      price.min='0';
      price.step='1';
      price.value=Number(it.price)||0;
      const commitCustomPrice = (rerender=false)=>{
        const gid = customState.activeGameId;
        const list = getCustomList(gid);
        const t = list.find(x=>x.id===it.id);
        if(!t) return;
        const nextPrice = Math.max(0, readMoneyNumber(price.value));
        // 導出画像はnormalPriceも参照するため、手入力価格と必ず同期する。
        t.price = nextPrice;
        t.normalPrice = nextPrice;
        setCustomList(gid, list);
        if(rerender) renderCustomTable();
      };
      // 入力直後に一鍵発推を押しても最新金額になるよう、changeだけでなくinputでも保存する。
      price.addEventListener('input', ()=>commitCustomPrice(false));
      price.addEventListener('change', ()=>commitCustomPrice(true));

      const del=document.createElement('button');
      del.className='cb-del';
      del.textContent='削除';
      del.addEventListener('click', ()=>{
        const gid = customState.activeGameId;
        const list = getCustomList(gid).filter(x=>x.id!==it.id);
        setCustomList(gid, list);
        renderCustomTable();
      });

      ctr.append(lab, price, del);

      info.append(nm, sub, ctr);
      row.append(thumb, info);
      listEl.appendChild(row);
    });
  }

  renderCustomTable();

  const input = document.getElementById('cb-search-input');
  const clear = document.getElementById('cb-search-clear');
  const results = document.getElementById('cb-results');
  const countEl = document.getElementById('cb-count');
  const progEl  = document.getElementById('cb-progress');
  const rarityBar = document.getElementById('cb-rarity-bar');

  const rarities = getGameRarityOrder(activeGame.id);
  rarityBar.innerHTML='';
  rarities.forEach(r=>{
    const b=document.createElement('button');
    b.type='button';
    b.className='rarity-btn';
    b.textContent=r;
    b.dataset.r=r;
    b.addEventListener('click', ()=>{
      setRarityInInput(input, activeGame.id, r);
      runSearch();
      updateRarityButtonActive(rarityBar, activeGame.id, input.value||'');
      input.focus();
    });
    rarityBar.appendChild(b);
  });

  let timer=null;

  function addToCustomFromProduct(p){
    const gid = customState.activeGameId;
    const list = getCustomList(gid);

    list.push({
      id: uid(),
      name: p.name,
      price: Number(p.price)||0,
      normalPrice: Number(p.price)||0,
      psa10Price: getPsa10BuyPrice(p),
      psa10Enabled: isPsa10BuyEnabled(p),
      img: p.img ? unwrapProxyImageUrl(p.img) : '',
      rarity: p.rarity||'',
      packName: p.packName||''
    });

    setCustomList(gid, list);
    renderCustomTable();
  }

  function renderResultCards(filteredUI){
    const grid=document.createElement('div');
    grid.className='product-grid';

    filteredUI.forEach(p=>{
      const card=document.createElement('div');
      card.className='pack-card-product';

      const chip=document.createElement('div');
      chip.className='pack-chip-mini';
      chip.textContent=p.packName||'';
      card.appendChild(chip);

      if(p.img){
        const img=document.createElement('img');
        img.src=getProxyImageUrl(p.img);
        img.alt=p.name;
        img.loading='lazy';
        card.appendChild(img);
      }

      const nm=document.createElement('p');
      nm.textContent=p.name;
      nm.title=p.name;
      card.appendChild(nm);

      const sub=document.createElement('div');
      sub.style.cssText='font-size:12px;color:#6b7280;margin-bottom:8px;font-weight:700';
      sub.textContent=p.rarity||'';
      card.appendChild(sub);

      appendBuyPriceBlock(card,p);

      const addBtn=document.createElement('button');
      addBtn.className='cb-add-btn';
      addBtn.textContent='＋追加';
      addBtn.addEventListener('click', (e)=>{
        e.stopPropagation();
        addToCustomFromProduct(p);
      });

      addBtn.style.marginTop='10px';
      addBtn.style.width='100%';
      card.appendChild(addBtn);

      card.style.cursor='pointer';
      card.addEventListener('click', ()=>addToCustomFromProduct(p));

      grid.appendChild(card);
    });

    results.innerHTML='';
    results.appendChild(grid);
  }

  function draw(query){
    const {nameQuery,rarityQuery} = parseSearchInput(query, activeGame.id);
    const qName = normalizeQ(nameQuery);
    const qRar  = rarityQuery;

    updateRarityButtonActive(rarityBar, activeGame.id, query||'');

    const hasQuery = !!(qName || String(qRar||'').trim());
    if(!hasQuery){
      results.innerHTML='';
      if(countEl) countEl.textContent='0';
      if(progEl) progEl.textContent='未検索';
      return;
    }

    const cache=_gameSearchCache.get(activeGame.id);
    const base=cache?.products||[];

    const filteredAll=base.filter(p=>{
      const okName=!qName || normalizeQ(p.name).includes(qName);
      const okRar=rarityMatch(p.rarity,qRar);
      return okName && okRar;
    }).sort((a,b)=>(b.price||0)-(a.price||0));

    const filteredUI = filteredAll.slice(0,240);

    if(countEl) countEl.textContent=String(filteredAll.length);

    const rarLabel=String(qRar||'').trim()?` / 稀有度:${String(qRar).trim()}`:'';
    if(progEl){
      if(cache?.totalPacks){
        const loadedHint=cache.promise?'読み込み中':'読み込み完了';
        progEl.textContent=`${loadedHint}${rarLabel}`;
      }else{
        progEl.textContent=`検索中…${rarLabel}`;
      }
    }

    if(filteredAll.length===0){
      results.innerHTML=`<div class="search-loading">🔎 該当なし</div>`;
      return;
    }
    renderResultCards(filteredUI);
  }

  async function runSearch(){
    const q=input.value||'';
    const {nameQuery,rarityQuery}=parseSearchInput(q, activeGame.id);
    const nq=normalizeQ(nameQuery);
    const rq=String(rarityQuery||'').trim();

    updateRarityButtonActive(rarityBar, activeGame.id, q);

    if(!nq && !rq){
      draw('');
      return;
    }

    results.innerHTML=`<div class="search-loading">⏳ データ取得中…</div>`;
    if(progEl) progEl.textContent='読み込み中…';

    window.currentDropdownId = activeGame.id;

    try{
      await ensureGameSearchCache(activeGame, ({done,total,count})=>{
        if(progEl) progEl.textContent=`読み込み：${done}/${total}（累計 ${count} 件）`;
        draw(input.value||'');
      });

      const cache=_gameSearchCache.get(activeGame.id);
      if(progEl) progEl.textContent=`準備完了（全 ${cache?.products?.length||0} 件）`;
      draw(input.value||'');
    }catch(e){
      console.error(e);
      if(progEl) progEl.textContent='取得失敗';
      results.innerHTML=`<div class="search-loading" style="color:#b91c1c">❗ 取得失敗：${(e?.message||e)}</div>`;
    }
  }

  input?.addEventListener('input', ()=>{
    clearTimeout(timer);
    timer=setTimeout(runSearch, 220);
  });
  clear?.addEventListener('click', ()=>{
    input.value='';
    draw('');
    input.focus();
  });

  document.getElementById('cb-reset')?.addEventListener('click', ()=>{
    if(!confirm('自定义買取表をクリアしますか？')) return;
    const gid = customState.activeGameId;
    setCustomList(gid, []);
    renderCustomTable();
  });

  async function tweetCustomTable(){
    if(!isAdminView()) return;

    const gid = customState.activeGameId;
    const game = (games||[]).find(g=>g.id===gid);
    const gameName = game?.name || '';

    const list = getCustomList(gid);
    if(!list.length){ alert('自定义買取表が空です。'); return; }

    const sorted = list.slice().sort((a,b)=>(Number(b.price)||0)-(Number(a.price)||0));
    const top10 = sorted.slice(0,10).map(p=>`- ${p.name}：${formatBuyPriceTextFromItem(p)}`);

    const extraTags=(()=>{
      const id=gid;
      if(id==='ultraman-dropdown')return['#ウルトラマンTCG #UCG'];
      if(id==='dejimon-dropdown')return['#デジカ'];
      if(id==='gotoubunbright-dropdown')return['#ごとカド #五等分の花嫁TCG'];
      if(id==='pokeka-dropdown')return['#ポケカ #ポケモンカード'];
      if(id==='doragonboru-dropdown')return['#フュージョンワールド #DBFW'];
      if(id==='gundam-dropdown')return['#ガンダムカード #GCG'];
      if(id==='UA-dropdown')return['#ユニアリ #ユニオンアリーナ'];
      if(id==='onepiece-dropdown')return['#ワンピースカード'];
      return[];
    })();

    const tweetText=[
      `${gameName} 最新買取情報`,
      '強化買取',
      ...top10,
      '上記以外のカードも高価買取中です。',
      'ぜひお持ちください。',
      ...POSTAL_BUY_TWEET_LINES,
      '買取表はこちらで確認できます⇩',
      'https://torekanobankoku.com/pages/kaitorihyou',
      '※相場・状態・在庫・エディションにより予告なく金額が変動する場合がございます。',
      '#買取 #トレカの万国 #秋葉原',
      ...extraTags
    ].join('\n').trim();

    await downloadTweetImagesByProductCount(sorted, {
      gameId: gid,
      game,
      gameTitle: gameName,
      prefix: '自定义買取表',
      headline: '強化買取',
      cols: 7,
      width: 1400,
      perImage: 28,
      cardImgH: 200
    });

    openOriginalTweetOnX(tweetText);
  }

  document.getElementById('cb-tweet')?.addEventListener('click', tweetCustomTable);

  window.__tweetCustomTable = tweetCustomTable;
}

function tweetCustomIfPossible(){
  if(customMode && typeof window.__tweetCustomTable==='function'){
    return window.__tweetCustomTable();
  }
}

function bindManual(){
  const nameEl = document.getElementById('man-name');
  const qtyEl  = document.getElementById('man-qty');
  const priceEl= document.getElementById('man-price');
  const addBtn = document.getElementById('man-add');
  if(!nameEl || !qtyEl || !priceEl || !addBtn) return;

  const doAdd = ()=>{
    const name = (nameEl.value || '').trim();
    if(!name){ nameEl.focus(); return; }

    const qty   = Math.max(1, Number(qtyEl.value) || 1);
    const price = Math.max(0, Number(priceEl.value) || 0);

    if(!estimateMode) setEstimateMode(true);

    addToEstimate({
      name,
      packName: window.currentSheetTitle || '（手入力）',
      img: '',
      price,
      qty,
      cond: ALLOWED_CONDS[0]
    });

    nameEl.value = '';
    qtyEl.value = 1;
    priceEl.value = '';
    nameEl.focus();
  };

  addBtn.addEventListener('click', doAdd);
  [nameEl, qtyEl, priceEl].forEach(el=>{
    el.addEventListener('keydown', e=>{
      if(e.key === 'Enter'){ e.preventDefault(); doAdd(); }
    });
  });
}

let estimateMode=false;
let cart=[];
const saveCart=()=>{try{localStorage.setItem('estimate_cart',JSON.stringify(cart))}catch(e){}};
const loadCart=()=>{try{cart=JSON.parse(localStorage.getItem('estimate_cart')||'[]')||[]}catch(e){cart=[]}};
const getSortedCart=()=>cart.slice();
const uid=()=> 'K'+Date.now().toString(36)+Math.random().toString(36).slice(2,8);

function addToEstimate(it){cart.push({id:uid(),name:it.name,packName:it.packName,img:it.img,price:it.price||0,qty:it.qty||1,cond:it.cond||ALLOWED_CONDS[0]});saveCart();renderEstimate(true);toggleEstimatePanel(true)}
function removeFromEstimate(id){cart=cart.filter(x=>x.id!==id);saveCart();renderEstimate()}
function updateQty(id,v){const it=cart.find(x=>x.id===id);if(!it)return;it.qty=Math.max(1,Number(v)||1);saveCart();renderEstimate()}
function updatePrice(id,v){const it=cart.find(x=>x.id===id);if(!it)return;it.price=Math.max(0,Number(v)||0);saveCart();renderEstimate()}
function updateCond(id,val){const it=cart.find(x=>x.id===id);if(!it)return;it.cond=val;saveCart()}
const grandTotal=()=>cart.reduce((s,x)=>s+x.price*x.qty,0);

function renderEstimate(scrollToEnd){
  const wrap=$('#estimate-items');if(!wrap)return;
  wrap.innerHTML='';
  getSortedCart().forEach(it=>{
    const row=document.createElement('div');row.className='est-item';
    row.innerHTML=`<div class="est-thumb"><img src="${it.img||''}" alt=""></div>`;
    const info=document.createElement('div');info.className='est-info';
    const nm=document.createElement('div');nm.className='est-name';nm.textContent=it.name;
    const pk=document.createElement('div');pk.className='est-pack';pk.textContent=it.packName||'';
    const ctr=document.createElement('div');ctr.className='est-row';

    const qlab=document.createElement('label');qlab.textContent='数量';
    const q=document.createElement('input');q.type='number';q.className='est-qty';q.value=it.qty;q.min='1';q.addEventListener('change',()=>updateQty(it.id,q.value));

    const plab=document.createElement('label');plab.textContent='単価(円)';
    const p=document.createElement('input');p.type='number';p.className='est-price';p.value=it.price;p.step='1';p.addEventListener('change',()=>updatePrice(it.id,p.value));

    const clab=document.createElement('label');clab.textContent='状態';
    const s=document.createElement('select');s.className='est-cond';
    ALLOWED_CONDS.forEach(opt=>{const o=document.createElement('option');o.value=opt;o.textContent=opt;s.appendChild(o)});
    s.value=ALLOWED_CONDS.includes(it.cond)?it.cond:ALLOWED_CONDS[0];
    s.addEventListener('change',()=>updateCond(it.id,s.value));

    const right=document.createElement('div');right.className='est-right';
    const line=document.createElement('div');line.className='est-total';line.textContent=money(it.price*it.qty);
    const del=document.createElement('button');del.className='est-del';del.textContent='削除';del.onclick=()=>removeFromEstimate(it.id);
    right.append(line,del);

    ctr.append(qlab,q,plab,p,clab,s,right);
    info.append(nm,pk,ctr);row.appendChild(info);wrap.appendChild(row);
  });

  $('#est-count').textContent = cart.length;

  const totalText = money(grandTotal());
  $('#est-grand').textContent = totalText;

  const inline = document.getElementById('est-grand-inline');
  if(inline) inline.textContent = totalText;

  if(scrollToEnd)requestAnimationFrame(()=>wrap.scrollTo({top:wrap.scrollHeight,behavior:'smooth'}));
}
function getViewportWidth(){
  return Math.round(window.visualViewport?.width || document.documentElement.clientWidth || window.innerWidth || 0);
}
function isCompactAdminViewport(){
  // Mobile/tablet are customer-browsing layouts. Do not open the fixed admin estimate panel there.
  return getViewportWidth() <= 1180;
}
function syncResponsiveLayoutState(){
  const w=getViewportWidth();
  document.documentElement.style.setProperty('--viewport-width', w + 'px');
  document.body.classList.toggle('buyback-mobile', w <= 749);
  document.body.classList.toggle('buyback-tablet', w > 749 && w <= 1180);
  document.body.classList.toggle('buyback-desktop', w > 1180);

  // On tablet/phone, a leftover panel-open class can freeze or horizontally stretch the page.
  if(w <= 1180){
    const panel=$('#estimate-panel');
    panel?.classList?.remove('open');
    document.body.classList.remove('panel-open');
    document.documentElement.style.removeProperty('--estimate-panel-measured-width');
  }else if(document.body.classList.contains('panel-open')){
    syncEstimatePanelMetrics();
  }
}
function syncEstimatePanelMetrics(){
  const panel=$('#estimate-panel');
  if(!panel) return;
  const w = Math.ceil(panel.getBoundingClientRect().width || 0);
  if(w > 0){
    document.documentElement.style.setProperty('--estimate-panel-measured-width', w + 'px');
  }
}

function ensureEstimatePanelCloseButton(){
  const ctr=document.querySelector('#estimate-header .est-ctrls') || document.getElementById('estimate-header');
  if(!ctr || document.getElementById('btn-estimate-close')) return;
  const b=document.createElement('button');
  b.id='btn-estimate-close';
  b.type='button';
  b.textContent='閉じる';
  b.addEventListener('click',()=>setEstimateMode(false));
  ctr.appendChild(b);
}

function toggleEstimatePanel(open){
  const panel=$('#estimate-panel');if(!panel)return;
  syncResponsiveLayoutState();
  if(open && isCompactAdminViewport()){
    // Tablet/mobile page is public/compact. Keep estimate mode state, but do not mount the fixed panel.
    panel.classList.remove('open');
    document.body.classList.remove('panel-open');
    return;
  }
  if(open){
    ensureEstimatePanelCloseButton();
    panel.classList.add('open');
    document.body.classList.add('panel-open');
    requestAnimationFrame(()=>{syncResponsiveLayoutState();syncEstimatePanelMetrics();});
    setTimeout(()=>{syncResponsiveLayoutState();syncEstimatePanelMetrics();}, 260);
  }
  else{
    panel.classList.remove('open');
    document.body.classList.remove('panel-open');
    document.documentElement.style.removeProperty('--estimate-panel-measured-width');
  }
}
window.addEventListener('resize', syncResponsiveLayoutState, {passive:true});
window.addEventListener('orientationchange', ()=>setTimeout(syncResponsiveLayoutState, 160), {passive:true});
window.visualViewport?.addEventListener?.('resize', syncResponsiveLayoutState, {passive:true});
function updateProductCardCursors(){
  document.querySelectorAll('.pack-card-product').forEach(card=>{
    card.style.cursor=(isAdminView()&&estimateMode)?'pointer':'default';
  });
}
function setEstimateMode(on){
  estimateMode=!!on;
  const btn=$('#dock-estimate');
  if(btn)btn.textContent=`見積書モード：${estimateMode?'ON':'OFF'}`;
  document.body.classList.toggle('estimate-mode',estimateMode);
  toggleEstimatePanel(estimateMode);
  updateProductCardCursors();

  updateGameTabsUI(window.currentDropdownId);
}

const MERGE_PREFIX = 'BKMERGE2:';

function encodeMergePayload(obj){
  try {
    const json = JSON.stringify(obj);
    const compressed = LZString.compressToEncodedURIComponent(json);
    return MERGE_PREFIX + compressed;
  } catch(e) {
    console.error('Encode error:', e);
    throw new Error('合并码生成失败');
  }
}

function decodeMergePayload(text){
  const t = String(text||'').trim();
  
  if(t.startsWith('BKMERGE1:')){
    const b64 = t.slice('BKMERGE1:'.length).trim();
    const json = decodeURIComponent(escape(atob(b64)));
    return JSON.parse(json);
  }
  
  if(!t.startsWith(MERGE_PREFIX)){
    throw new Error('不是有效的合并码（前缀不匹配）');
  }
  
  try {
    const compressed = t.slice(MERGE_PREFIX.length).trim();
    const json = LZString.decompressFromEncodedURIComponent(compressed);
    
    if(!json) throw new Error('解压失败');
    
    return JSON.parse(json);
  } catch(e) {
    console.error('Decode error:', e);
    throw new Error('合并码解析失败（可能已损坏）');
  }
}

function buildMergeFromCart(){
  // ✅ 备用方案：保留完整图片URL（不压缩）
  return {
    v: 2,
    t: Date.now(),
    i: (cart||[]).map(x=>({
      n: x.name || '',
      p: x.packName || '',
      m: x.img || '',  // ✅ 完整URL
      r: Number(x.price)||0,
      q: Math.max(1, Number(x.qty)||1),
      c: x.cond || ALLOWED_CONDS[0]
    }))
  };
}

function importMergeItems(payload){
  const items = Array.isArray(payload?.i) ? payload.i : [];
  if(!items.length) return 0;

  items.forEach(it=>{
    cart.push({
      id: uid(),
      name: String(it.n||''),
      packName: String(it.p||''),
      img: String(it.m||''),  // ✅ 直接使用完整URL
      price: Math.max(0, Number(it.r)||0),
      qty: Math.max(1, Number(it.q)||1),
      cond: ALLOWED_CONDS.includes(it.c) ? it.c : ALLOWED_CONDS[0],
    });
  });

  saveCart();
  renderEstimate(true);
  return items.length;
}

function importMergeItems(payload){
  const items = Array.isArray(payload?.i) ? payload.i : [];
  if(!items.length) return 0;

  items.forEach(it=>{
    // ✅ 修复：更准确的URL还原
    let fullImg = '';
    if(it.m){
      if(!it.m.startsWith('http')){
        // 重建完整代理URL
        // 注意：这里需要对文件名进行双重编码
        // 1. 先构建原始Shopify URL
        const originalUrl = `https://cdn.shopify.com/s/files/1/0663/8085/7504/files/${it.m}`;
        // 2. 再对整个URL进行encodeURIComponent
        const encodedUrl = encodeURIComponent(originalUrl);
        // 3. 最后拼接代理URL
        fullImg = `https://flat-fire-5577.bankokutcg.workers.dev/?url=${encodedUrl}`;
      } else {
        fullImg = it.m;
      }
    }
    
    cart.push({
      id: uid(),
      name: String(it.n||''),
      packName: String(it.p||''),
      img: fullImg,
      price: Math.max(0, Number(it.r)||0),
      qty: Math.max(1, Number(it.q)||1),
      cond: ALLOWED_CONDS.includes(it.c) ? it.c : ALLOWED_CONDS[0],
    });
  });

  saveCart();
  renderEstimate(true);
  return items.length;
}
function parseManyMergeCodes(raw){
  const lines = String(raw||'')
    .split(/\r?\n/)
    .map(s=>s.trim())
    .filter(Boolean);

  const codes = [];
  for(const line of lines){
    if(line.startsWith(MERGE_PREFIX)) codes.push(line);
  }

  if(codes.length===0){
    const s = String(raw||'');
    const parts = s.split(MERGE_PREFIX).map(x=>x.trim()).filter(Boolean);
    parts.forEach(p=>codes.push(MERGE_PREFIX + p));
  }

  return codes;
}

async function exportMergeToClipboard(){
  if(!cart.length){
    alert('見積が空です（导出失败）');
    return;
  }
  const payload = buildMergeFromCart();
  const code = encodeMergePayload(payload);

  try{
    await navigator.clipboard.writeText(code);
    alert('合并码已复制：把它发给负责人即可');
  }catch(_){
    const ta=document.createElement('textarea');
    ta.value=code;
    document.body.appendChild(ta);
    ta.select();
    document.execCommand('copy');
    ta.remove();
    alert('合并码已复制：把它发给负责人即可');
  }
}

function openMergeModal(){
  const modal = document.getElementById('merge-modal');
  const msg = document.getElementById('merge-msg');
  const ta = document.getElementById('merge-text');
  if(!modal || !ta) return;

  ta.value = '';
  if(msg) msg.textContent = '';
  modal.style.display='flex';
  ta.focus();
}

function closeMergeModal(){
  const modal = document.getElementById('merge-modal');
  if(modal) modal.style.display='none';
}

async function applyMergeAndIssueQR(){
  const ta = document.getElementById('merge-text');
  const msg = document.getElementById('merge-msg');
  const raw = ta?.value || '';

  const codes = parseManyMergeCodes(raw);
  if(!codes.length){
    if(msg) msg.textContent = '未检测到合并码。请确认内容包含 BKMERGE2: 或 BKMERGE1: 开头。';
    return;
  }

  let mergedCount = 0;
  let ok = 0;
  let fail = 0;

  for(const code of codes){
    try{
      const payload = decodeMergePayload(code);
      const n = importMergeItems(payload);
      mergedCount += n;
      ok++;
    }catch(e){
      console.warn(e);
      fail++;
    }
  }

  if(msg){
    msg.textContent = `已处理：${ok} 段成功 / ${fail} 段失败。共导入 ${mergedCount} 件。`;
  }

  if(mergedCount<=0){
    alert('没有导入到任何项目（可能合并码都无效）');
    return;
  }

  try{
    closeMergeModal();
    await issueOnlineEstimate();
  }catch(e){
    alert('合并成功，但发QR失败：' + (e?.message||e));
  }
}

function buildPrint(){
  const now=new Date();

  const issued =
    `${now.getFullYear()}/${('0'+(now.getMonth()+1)).slice(-2)}/${('0'+now.getDate()).slice(-2)} `+
    `${('0'+now.getHours()).slice(-2)}:${('0'+now.getMinutes()).slice(-2)}`;

  const estNo =
    `EST-${now.getFullYear()}${('0'+(now.getMonth()+1)).slice(-2)}${('0'+now.getDate()).slice(-2)}-${now.getTime().toString().slice(-4)}`;

  const dateJP =
    `${now.getFullYear()}年${('0'+(now.getMonth()+1)).slice(-2)}月${('0'+now.getDate()).slice(-2)}日`;

  const storeName = document.getElementById('store-name')?.textContent?.trim()
    || document.getElementById('p-store-name')?.textContent?.trim()
    || 'トレカの万国 秋葉原店';

  const elIssued=document.getElementById('p-issued-at');
  const elNo=document.getElementById('p-est-no');
  const elReceipt=document.getElementById('p-receipt-date');
  const elStore=document.getElementById('p-store-name');
  if(elIssued) elIssued.textContent = issued;
  if(elNo) elNo.textContent = estNo;
  if(elReceipt) elReceipt.textContent = dateJP;
  if(elStore) elStore.textContent = storeName;

  const thImg = document.getElementById('p-th-img');
  if(thImg) thImg.style.display = PRINT_SHOW_THUMB ? '' : 'none';

  const tbody=document.getElementById('p-items');
  if(!tbody) return;
  tbody.innerHTML='';

  const rows=getSortedCart();

  const fmtPack = (t) => t ? t.replace(/^\s*【([^】]+)】\s*/,'【$1】 ') : '';

  if(rows.length===0){
    const tr=document.createElement('tr');
    tr.innerHTML = `
      <td style="text-align:center">1</td>
      <td style="display:${PRINT_SHOW_THUMB?'table-cell':'none'}"></td>
      <td>
        <div class="p-name">（品名）</div>
        <div class="p-pack">【FBxx】（収録）</div>
      </td>
      <td style="text-align:center">__</td>
      <td style="text-align:right">__</td>
      <td style="text-align:right">__</td>
      <td style="text-align:right">__</td>
    `;
    tbody.appendChild(tr);
  }else{
    rows.forEach((it,i)=>{
      const sub = (Number(it.price)||0) * (Number(it.qty)||0);

      const tr=document.createElement('tr');

      const tdIdx = document.createElement('td');
      tdIdx.textContent = String(i+1);
      tdIdx.style.textAlign='center';

      const tdImg = document.createElement('td');
      tdImg.style.textAlign='center';
      tdImg.style.display = PRINT_SHOW_THUMB ? '' : 'none';
      if(PRINT_SHOW_THUMB && it.img){
        const im=document.createElement('img');
        im.src = it.img;
        im.className='p-thumb';
        tdImg.appendChild(im);
      }

      const tdName = document.createElement('td');
      tdName.innerHTML = `
        <div class="p-name">${escapeHtml(it.name||'')}</div>
        <div class="p-pack">${escapeHtml(fmtPack(it.packName||''))}</div>
      `;

      const tdCond=document.createElement('td');
      tdCond.textContent = it.cond || '';
      tdCond.style.textAlign='center';

      const tdQty=document.createElement('td');
      tdQty.textContent = String(it.qty||0);
      tdQty.style.textAlign='right';

      const tdUnit=document.createElement('td');
      tdUnit.textContent = money(it.price);
      tdUnit.style.textAlign='right';

      const tdSub=document.createElement('td');
      tdSub.textContent = money(sub);
      tdSub.style.textAlign='right';

      tr.append(tdIdx, tdImg, tdName, tdCond, tdQty, tdUnit, tdSub);
      tbody.appendChild(tr);
    });
  }

  const total=rows.reduce((s,x)=>s+(Number(x.price)||0)*(Number(x.qty)||0),0);
  const g=document.getElementById('p-grand');
  if(g) g.textContent = money(total);
}

async function ensureAllLoaded(){
  let lastH=0,stable=0,tries=0;
  while(tries<60&&stable<6){
    window.scrollTo({top:document.documentElement.scrollHeight,behavior:'auto'});
    await new Promise(r=>setTimeout(r,150));
    const h=document.documentElement.scrollHeight;
    if(h===lastH)stable++;else stable=0;
    lastH=h;tries++;
  }
  try{if(document.fonts&&document.fonts.ready)await document.fonts.ready}catch(_){}
  const imgs=Array.from(document.images);
  await Promise.all(imgs.map(img=>img.complete?Promise.resolve():new Promise(res=>(img.onload=img.onerror=res))));
  window.scrollTo({top:0,behavior:'auto'});
}

async function saveAndOpenTwitter(){
  const isMaximized=window.outerWidth>=screen.availWidth&&window.outerHeight>=screen.availHeight;
  if(!isMaximized){
    alert('请将浏览器最大化后再按按钮\nブラウザを最大化してからボタンを押してください');
    return;
  }
  if(!window.isProductListReady){
    alert('商品がまだ読み込まれていません。少し後で試してください。');
    return;
  }

  const productList=Array.from(document.querySelectorAll('.pack-card-product'));
  if(productList.length===0){alert('商品がありません。');return;}

  for(const product of productList){
    product.scrollIntoView({block:'center'});
    await new Promise(r=>setTimeout(r,30));
  }
  const images=Array.from(document.querySelectorAll('.pack-card-product img'));
  await Promise.all(images.map(img=>img.complete?Promise.resolve():new Promise(r=>(img.onload=img.onerror=r))));
  window.scrollTo({top:0,behavior:'auto'});

  const game=(games||[]).find(g=>g.id===window.currentDropdownId);
  const gameName=game?game.name:'';

  const cleanedTitle=window.currentSheetTitle
    ? window.currentSheetTitle.replace(/【[^】]*】/g,'').replace(/^\s*[-ー－]\s*/,'').trim()
    : '';
  const titleHashtag=cleanedTitle?`${cleanedTitle}`:'';

  const tweetItems=productList.slice(0,10).map(product=>{
    const name=product.querySelector('p')?.innerText.trim()||'';
    const price=getProductCardPriceText(product);
    return `- ${name}：${price}`;
  });

  const extraTags=(()=>{
    const id=window.currentDropdownId;
    if(id==='ultraman-dropdown')return['#ウルトラマンTCG #UCG'];
    if(id==='dejimon-dropdown')return['#デジカ'];
    if(id==='gotoubunbright-dropdown')return['#ごとカド #五等分の花嫁TCG'];
    if(id==='pokeka-dropdown')return['#ポケカ #ポケモンカード'];
    if(id==='doragonboru-dropdown')return['#フュージョンワールド #DBFW'];
    if(id==='gundam-dropdown')return['#ガンダムカード #GCG'];
    if(id==='UA-dropdown')return['#ユニアリ #ユニオンアリーナ'];
    if(id==='onepiece-dropdown')return['#ワンピースカード'];
    return[];
  })();

  const tweetText=[
    `${gameName} 最新買取情報`,
    ...(titleHashtag?[titleHashtag]:[]),
    ...tweetItems,
    '上記以外のカードも高価買取中です。',
    'ぜひお持ちください。',
    ...POSTAL_BUY_TWEET_LINES,
    '買取表はこちらで確認できます⇩',
    'https://torekanobankoku.com/pages/kaitorihyou',
    '※相場・状態・在庫・エディションにより予告なく金額が変動する場合がございます。',
    '#買取 #トレカの万国 #秋葉原',
    ...extraTags
  ].join('\n').trim();

  const data = productList.map(card=>{
    const imgEl = card.querySelector('img');
    const name = card.querySelector('p')?.innerText.trim() || '';
    const rarity = card.querySelector('div[style*="color:#6b7280"]')?.innerText.trim()
      || card.querySelector('.sub')?.innerText?.trim()
      || '';
    const normalPrice = readMoneyNumber(card.dataset.normalPrice);
    const psa10Price = readMoneyNumber(card.dataset.psa10Price);
    const psa10Enabled = card.dataset.psa10Enabled === '1';
    const priceText = getProductCardPriceText(card);
    return {
      name,
      packName: cleanedTitle || window.currentSheetTitle || '',
      rarity,
      priceText,
      normalPrice,
      psa10Price,
      psa10Enabled,
      img: imgEl ? imgEl.src : ''
    };
  });

  await downloadTweetImagesByProductCount(data, {
    gameId: window.currentDropdownId,
    game,
    gameTitle: gameName,
    prefix: `買取表-${cleanedTitle || gameName || '表'}`,
    headline: '数量限定高価買取!!',
    updatedAt: document.getElementById('update-time')?.innerText || '',
    cols: 8,
    width: 1600,
    perImage: 24,
    cardImgH: 200,
    packName: cleanedTitle || window.currentSheetTitle || ''
  });

  openOriginalTweetOnX(tweetText);
}

let lastOnline={id:'',link:'',viewer:''};
function openQrModalInstant(){$('#qr-modal').style.display='flex';$('#qr-overlay').classList.add('show');$('#qr-box').innerHTML=''}
function generateLocalQR(link){
  const box=$('#qr-box');box.innerHTML='';
  try{new QRCode(box,{text:link,width:256,height:256,correctLevel:QRCode.CorrectLevel.M})}
  catch(e){box.innerHTML=`<div style="padding:10px;font-size:12px;color:#c00">QR生成に失敗しました</div>`}
  finally{$('#qr-overlay').classList.remove('show')}
}
async function issueOnlineEstimate(){
  if(!cart.length){alert('見積が空です');return}
  openQrModalInstant();
  $('#qr-link').value='';$('#qr-id').value='';
  let json;
  try{
    const payload={items:cart,store:$('#store-name')?.textContent?.trim()||'',meta:{sheetTitle:window.currentSheetTitle||''},customer:{}};
    json=await postJSON(`${API_BASE}?mode=create`,payload);
    if(!json||json.ok===false)throw new Error(json?.error||'保存に失敗しました');
  }catch(e){
    $('#qr-overlay').classList.remove('show');alert('保存に失敗しました：'+(e?.message||e));return;
  }
  const id=json.id;
  const estimateUrl=json.estimateUrl||'';
  const viewerUrl=json.viewerUrl||'';
  lastOnline={id,link:estimateUrl||viewerUrl||`${API_BASE}?mode=estimate&id=${encodeURIComponent(id)}`,viewer:viewerUrl||estimateUrl||`${API_BASE}?mode=estimate&id=${encodeURIComponent(id)}`};
  $('#qr-link').value=lastOnline.link;$('#qr-id').value=lastOnline.id;
  generateLocalQR(lastOnline.link);
}
function closeQrModal(){$('#qr-modal').style.display='none'}
function downloadQr(){
  const box=$('#qr-box');const img=box.querySelector('img');const canvas=box.querySelector('canvas');
  let url='';if(img)url=img.src;if(!url&&canvas)url=canvas.toDataURL('image/png');
  if(!url){alert('画像が見つかりません');return}
  const a=document.createElement('a');a.href=url;a.download=`estimate_${lastOnline.id||'qr'}.png`;a.click();
}
async function copyText(t){
  try{await navigator.clipboard.writeText(t);alert('コピーしました')}
  catch(_){const ta=document.createElement('textarea');ta.value=t;document.body.appendChild(ta);ta.select();document.execCommand('copy');ta.remove();alert('コピーしました')}
}

const INLINE_MAIL_BUY_MAIN_IDS = ['mail-buy-cta','game-tabs','game-landing','pack-buttons','sheet-container','buy-status','custom-builder'];
let _inlineMailBuyLoaded = false;
let _inlineMailBuyPrevTitle = '';
let _inlineMailBuyPrevUpdate = '';
let _inlineMailBuyHadSideNav = false;

function _mailBuyApiBase(){
  try{return String(CARDPOS_BASE || location.origin).replace(/\/$/,'')}catch(_){return location.origin}
}
function _setInlineMailBuyError(msg){
  const el=document.getElementById('inline-mail-buy-error');
  if(!el)return;
  if(msg){el.textContent=msg;el.classList.add('show')}else{el.textContent='';el.classList.remove('show')}
}
function _setInlineMailBuySuccess(msg){
  const el=document.getElementById('inline-mail-buy-success');
  if(!el)return;
  if(msg){el.innerHTML=msg;el.classList.add('show')}else{el.innerHTML='';el.classList.remove('show')}
}
function _hideMainForInlineMailBuy(){
  INLINE_MAIL_BUY_MAIN_IDS.forEach(id=>{
    const el=document.getElementById(id);
    if(!el)return;
    if(el.dataset.mailBuyPrevDisplay===undefined) el.dataset.mailBuyPrevDisplay = el.style.display || '';
    el.style.display='none';
  });
}
function _restoreMainFromInlineMailBuy(){
  INLINE_MAIL_BUY_MAIN_IDS.forEach(id=>{
    const el=document.getElementById(id);
    if(!el)return;
    el.style.display = (el.dataset.mailBuyPrevDisplay!==undefined) ? el.dataset.mailBuyPrevDisplay : '';
    delete el.dataset.mailBuyPrevDisplay;
  });
}
function _renderInlineMailBuyGameChoices(gameList){
  const box=document.getElementById('inline-mail-buy-games');
  const submit=document.getElementById('inline-mail-buy-submit');
  if(!box)return;
  const games=Array.isArray(gameList)?gameList:[];
  box.innerHTML='';
  if(!games.length){
    box.innerHTML='<div class="mail-buy-inline-empty">現在、郵送買取受付中のタイトルはありません。</div>';
    if(submit)submit.disabled=true;
    return;
  }
  games.forEach(g=>{
    const id=String(g.id??'');
    const name=String(g.name??'');
    if(!id || !name)return;
    const lab=document.createElement('label');
    lab.className='mail-buy-inline-game-check';
    lab.innerHTML=`<input type="checkbox" name="game_ids" value="${escapeHtml(id)}"><span>${escapeHtml(name)}</span>`;
    box.appendChild(lab);
  });
  if(!box.querySelector('input[name="game_ids"]')){
    box.innerHTML='<div class="mail-buy-inline-empty">現在、郵送買取受付中のタイトルはありません。</div>';
    if(submit)submit.disabled=true;
    return;
  }
  if(submit)submit.disabled=false;
}
function _fallbackInlineMailBuyGamesForPreview(){
  // ローカルHTML確認時や、API更新前に真っ白にならないための表示専用フォールバック。
  // 送信にはサーバー側 /api/mail-buy/requests が必要なので、本番では必ず backend patch を適用してください。
  try{
    const src=(Array.isArray(window._bootstrapGames)&&window._bootstrapGames.length)?window._bootstrapGames:(Array.isArray(games)?games:[]);
    const mapped=src.map(g=>({
      id:g.db_id||g.game_id_numeric||g.numeric_id||g.id,
      name:g.name||g.title||g.label||g.game_name||'' ,
      mail_buy_enabled:g.mail_buy_enabled??g.mailBuyEnabled
    })).filter(g=>g.id!==undefined && g.name);
    const hasFlag=mapped.some(g=>g.mail_buy_enabled!==undefined && g.mail_buy_enabled!==null);
    return (hasFlag?mapped.filter(g=>Number(g.mail_buy_enabled)===1):mapped).slice(0,40);
  }catch(_){return[]}
}
async function loadInlineMailBuyGames(force=false){
  if(_inlineMailBuyLoaded && !force)return;
  const box=document.getElementById('inline-mail-buy-games');
  const submit=document.getElementById('inline-mail-buy-submit');
  if(!box)return;
  box.innerHTML='<div class="mail-buy-inline-empty">読み込み中...</div>';
  if(submit)submit.disabled=true;
  _setInlineMailBuyError('');
  try{
    const r=await fetch(`${_mailBuyApiBase()}/api/mail-buy/games`,{cache:'no-store',credentials:'omit',mode:'cors'});
    const text=await r.text();
    let j;try{j=JSON.parse(text)}catch(_){throw new Error('APIからJSONが返ってきませんでした。')}
    if(!r.ok || j.ok===false)throw new Error(j.error || `HTTP ${r.status}`);
    _renderInlineMailBuyGameChoices(Array.isArray(j.games)?j.games:[]);
    _inlineMailBuyLoaded=true;
  }catch(e){
    console.error(e);
    const fallback=_fallbackInlineMailBuyGamesForPreview();
    if(fallback.length){
      _renderInlineMailBuyGameChoices(fallback);
      _setInlineMailBuyError('郵送買取APIに接続できませんでした。ローカル確認用にタイトルだけ表示しています。サーバーに app.py / modules/database.py を反映して再起動してください。');
    }else{
      box.innerHTML='<div class="mail-buy-inline-empty">郵送買取タイトルを取得できませんでした。</div>';
      _setInlineMailBuyError(`取得失敗：${e?.message||e}。app.py / modules/database.py の反映と再起動を確認してください。`);
      if(submit)submit.disabled=true;
    }
  }
}
function openInlineMailBuy(){
  const panel=document.getElementById('inline-mail-buy');
  if(!panel)return;
  _inlineMailBuyPrevTitle=document.getElementById('heading-text')?.textContent || '';
  _inlineMailBuyPrevUpdate=document.getElementById('update-time')?.textContent || '';
  _inlineMailBuyHadSideNav = !!document.getElementById('kaitori-side-nav')?.classList.contains('is-visible');
  hideKaitoriSideNav();
  _hideMainForInlineMailBuy();
  panel.classList.add('show');
  panel.setAttribute('aria-hidden','false');
  document.body.classList.add('mail-buy-inline-open');
  const h=document.getElementById('heading-text'); if(h)h.textContent='郵送買取のお申し込み';
  const u=document.getElementById('update-time'); if(u)u.textContent='';
  loadInlineMailBuyGames(false);
  panel.scrollIntoView({block:'start',behavior:'smooth'});
}
function closeInlineMailBuy(){
  const panel=document.getElementById('inline-mail-buy');
  if(!panel)return;
  panel.classList.remove('show');
  panel.setAttribute('aria-hidden','true');
  document.body.classList.remove('mail-buy-inline-open');
  _restoreMainFromInlineMailBuy();
  if(_inlineMailBuyHadSideNav && window.currentDropdownId){
    renderKaitoriSideNav(window.currentDropdownId);
  }else{
    hideKaitoriSideNav();
  }
  const h=document.getElementById('heading-text'); if(h)h.textContent=_inlineMailBuyPrevTitle || 'タイトルの買取表を選んでください';
  const u=document.getElementById('update-time'); if(u)u.textContent=_inlineMailBuyPrevUpdate || '';
  document.querySelector('.heading-container')?.scrollIntoView({block:'start',behavior:'smooth'});
}
async function submitInlineMailBuy(e){
  e.preventDefault();
  _setInlineMailBuyError('');
  _setInlineMailBuySuccess('');
  const form=e.currentTarget;
  const submit=document.getElementById('inline-mail-buy-submit');
  const fd=new FormData(form);
  const gameIds=Array.from(form.querySelectorAll('input[name="game_ids"]:checked')).map(x=>x.value).filter(Boolean);
  if(!fd.get('customer_name') || !fd.get('customer_email') || !fd.get('customer_phone') || !fd.get('customer_zip') || !fd.get('customer_address') || !fd.get('customer_birthdate') || !fd.get('id_doc_type') || !gameIds.length){
    _setInlineMailBuyError('お名前、メールアドレス、電話番号、郵便番号、ご住所、生年月日、本人確認書類、買取希望タイトルを入力してください。');
    return;
  }
  if(!form.querySelector('input[name="terms_accepted"]')?.checked){
    _setInlineMailBuyError('郵送買取の注意事項を確認し、同意チェックを入れてください。');
    form.querySelector('.mail-buy-inline-terms')?.scrollIntoView({block:'center',behavior:'smooth'});
    return;
  }
  const payload={
    customer_name:String(fd.get('customer_name')||''),
    customer_kana:String(fd.get('customer_kana')||''),
    customer_email:String(fd.get('customer_email')||''),
    customer_phone:String(fd.get('customer_phone')||''),
    customer_zip:String(fd.get('customer_zip')||''),
    customer_address:String(fd.get('customer_address')||''),
    customer_birthdate:String(fd.get('customer_birthdate')||''),
    id_doc_type:String(fd.get('id_doc_type')||''),
    game_ids:gameIds,
    item_summary:String(fd.get('item_summary')||''),
    note:String(fd.get('note')||''),
    terms_accepted:'1'
  };
  try{
    if(submit){submit.disabled=true;submit.textContent='送信中...'}
    const r=await fetch(`${_mailBuyApiBase()}/api/mail-buy/requests`,{
      method:'POST',
      headers:{'Content-Type':'application/json','Accept':'application/json'},
      body:JSON.stringify(payload),
      credentials:'omit'
    });
    const text=await r.text();
    let j;try{j=JSON.parse(text)}catch(_){throw new Error(text.slice(0,160)||'送信に失敗しました')}
    if(!r.ok || j.ok===false)throw new Error(j.error || `HTTP ${r.status}`);
    form.reset();
    _setInlineMailBuySuccess(`お申し込みを受け付けました。<br>受付番号：<b>PB-${j.id}</b><br>内容確認後、メールにて発送先をご案内します。`);
  }catch(e){
    console.error(e);
    _setInlineMailBuyError(`送信失敗：${e?.message||e}`);
  }finally{
    if(submit){submit.disabled=false;submit.textContent='注意事項に同意して申し込む'}
  }
}
function bindInlineMailBuy(){
  const entry=document.getElementById('mail-buy-entry');
  if(entry){
    entry.setAttribute('href','#mail-buy');
    entry.addEventListener('click',e=>{e.preventDefault();openInlineMailBuy()});
  }
  document.getElementById('inline-mail-buy-back')?.addEventListener('click',closeInlineMailBuy);
  document.getElementById('inline-mail-buy-form')?.addEventListener('submit',submitInlineMailBuy);
}

function tryDeepLinkOpen(){
  if(!QS_GAME||!sheetMap[QS_GAME])return;
  const game=(games||[]).find(g=>g.id===QS_GAME);if(!game)return;
  $('#pack-buttons').classList.remove('is-pack-list-hidden');
  $('#pack-buttons').classList.remove('show');
  $('#pack-buttons').style.display='block';
  $('#sheet-container').innerHTML='';
  $('#heading-text').innerText=game.name+'：パックを選択してください';
  $('#update-time').innerText='';
  window.currentDropdownId=game.id;

  updateGameTabsUI(game.id);

  hideStatusBoard();
  renderPackButtons(game);

  const landing = document.getElementById('game-landing');

  if(!QS_PACK){
    if(landing) landing.style.display = 'block';
    renderGameLanding(game);
  }

  if(QS_PACK){
    if(landing) landing.style.display = 'none';
    const target=QS_PACK;
    const url=sheetMap[game.id];
    setPackListVisible(false);
    loadProducts(target,url);
    window.currentSheetTitle=target;
  }
}

document.addEventListener('DOMContentLoaded', async ()=>{
  syncResponsiveLayoutState();
  bindInlineMailBuy();
  await renderGameTabs();
  syncResponsiveLayoutState();
  hideStatusBoard();
  tryDeepLinkOpen();

  const disableImgActions=img=>{img.draggable=false;img.oncontextmenu=()=>false};
  document.querySelectorAll('img').forEach(disableImgActions);
  const obs=new MutationObserver(muts=>{
    muts.forEach(m=>{
      m.addedNodes.forEach(n=>{
        if(n.tagName==='IMG')disableImgActions(n);
        else if(n.querySelectorAll)n.querySelectorAll('img').forEach(disableImgActions);
      });
    });
  });
  obs.observe(document.body,{childList:true,subtree:true});

  if(!isAdminView()){
    $('#admin-dock')?.remove();
    $('#estimate-panel')?.remove();
    $('#tweet-btn')?.remove();
  }else{
    document.body.classList.add('has-admin-dock');
    $('#admin-dock')?.classList.add('admin-visible');
    $('#estimate-panel')?.classList.add('admin-visible');

    loadCart();renderEstimate();
    bindManual();

    $('#dock-estimate')?.addEventListener('click',()=>setEstimateMode(!estimateMode));
    $('#dock-tweet')?.addEventListener('click',()=>{
      if(customMode) tweetCustomIfPossible();
      else saveAndOpenTwitter();
    });
    $('#dock-custom')?.addEventListener('click',()=>setCustomMode(!customMode));

    $('#tweet-btn')?.addEventListener('click',saveAndOpenTwitter);

    $('#btn-reset')?.addEventListener('click',()=>{if(confirm('見積をリセットしますか？')){cart=[];saveCart();renderEstimate()}});

    $('#btn-print')?.addEventListener('click',()=>{
      buildPrint();
      const area=$('#estimate-print-area');
      const prev=area.style.display;
      area.style.display='block';
      requestAnimationFrame(()=>{window.print();area.style.display=prev||''})
    });

    $('#btn-qr')?.addEventListener('click',issueOnlineEstimate);
    $('#qr-close')?.addEventListener('click',closeQrModal);
    $('#qr-copy')?.addEventListener('click',()=>copyText($('#qr-link')?.value||''));
    $('#qr-open')?.addEventListener('click',()=>{const l=$('#qr-link')?.value;if(l)window.open(l,'_blank')});
    $('#qr-refresh')?.addEventListener('click',issueOnlineEstimate);
    $('#qr-download')?.addEventListener('click',downloadQr);
    
    const exportBtn = $('#btn-export-merge');
    const importBtn = $('#btn-import-merge');
    
    console.log('Export button:', exportBtn);
    console.log('Import button:', importBtn);
    
    if(exportBtn) {
      exportBtn.addEventListener('click', ()=>{
        console.log('Export merge clicked');
        exportMergeToClipboard();
      });
    }
    
    if(importBtn) {
      importBtn.addEventListener('click', ()=>{
        console.log('Import merge clicked');
        openMergeModal();
      });
    }

    const mergeClose = document.getElementById('merge-close');
    const mergeClear = document.getElementById('merge-clear');
    const mergeApply = document.getElementById('merge-apply');
    
    console.log('Merge modal buttons:', {mergeClose, mergeClear, mergeApply});
    
    if(mergeClose) {
      mergeClose.addEventListener('click', ()=>{
        console.log('Close merge modal');
        closeMergeModal();
      });
    }
    
    if(mergeClear) {
      mergeClear.addEventListener('click', ()=>{
        console.log('Clear merge text');
        const ta=document.getElementById('merge-text'); 
        if(ta) ta.value='';
        const msg=document.getElementById('merge-msg'); 
        if(msg) msg.textContent='';
      });
    }
    
    if(mergeApply) {
      mergeApply.addEventListener('click', ()=>{
        console.log('Apply merge');
        applyMergeAndIssueQR();
      });
    }

    document.addEventListener('keydown', (e)=>{
      if(e.key==='Escape'){
        const modal=document.getElementById('merge-modal');
        if(modal && modal.style.display==='flex') closeMergeModal();
      }
    });

    const urlParams=new URLSearchParams(location.search);
    setEstimateMode(urlParams.get('estimate')==='1');
  }
});

document.addEventListener('keydown',e=>{
  if(e.key==='F9'){const area=$('#estimate-print-area');area.style.display=(area.style.display==='block')?'':'block'}
});
